export const SVG_ACCESSIBILITY = 'ACCESSIBILITY';
import { default as ACCESSIBILITY_deprecated } from './deprecated/accessibility.svg';
import { default as ACCESSIBILITY_rebranded } from './rebranded/accessibility.svg';
export const SVG_ADD_ACTIVE = 'ADD_ACTIVE';
import { default as ADD_ACTIVE_deprecated } from './deprecated/add-active.svg';
import { default as ADD_ACTIVE_rebranded } from './rebranded/add-active.svg';
export const SVG_ADD_CIRCLE_ACTIVE = 'ADD_CIRCLE_ACTIVE';
import { default as ADD_CIRCLE_ACTIVE_deprecated } from './deprecated/add-circle-active.svg';
import { default as ADD_CIRCLE_ACTIVE_rebranded } from './rebranded/add-circle-active.svg';
export const SVG_ADD_CIRCLE_INACTIVE = 'ADD_CIRCLE_INACTIVE';
import { default as ADD_CIRCLE_INACTIVE_deprecated } from './deprecated/add-circle-inactive.svg';
import { default as ADD_CIRCLE_INACTIVE_rebranded } from './rebranded/add-circle-inactive.svg';
export const SVG_ADD_INACTIVE = 'ADD_INACTIVE';
import { default as ADD_INACTIVE_deprecated } from './deprecated/add-inactive.svg';
import { default as ADD_INACTIVE_rebranded } from './rebranded/add-inactive.svg';
export const SVG_ADD_PERSON_ACTIVE = 'ADD_PERSON_ACTIVE';
import { default as ADD_PERSON_ACTIVE_deprecated } from './deprecated/add-person-active.svg';
import { default as ADD_PERSON_ACTIVE_rebranded } from './rebranded/add-person-active.svg';
export const SVG_ADD_PERSON_INACTIVE = 'ADD_PERSON_INACTIVE';
import { default as ADD_PERSON_INACTIVE_deprecated } from './deprecated/add-person-inactive.svg';
import { default as ADD_PERSON_INACTIVE_rebranded } from './rebranded/add-person-inactive.svg';
export const SVG_ADD = 'ADD';
import { default as ADD_deprecated } from './deprecated/add.svg';
import { default as ADD_rebranded } from './rebranded/add.svg';
export const SVG_ADDRESS_BOOK_CONTACTS_ACTIVE = 'ADDRESS_BOOK_CONTACTS_ACTIVE';
import { default as ADDRESS_BOOK_CONTACTS_ACTIVE_deprecated } from './deprecated/address-book-contacts-active.svg';
import { default as ADDRESS_BOOK_CONTACTS_ACTIVE_rebranded } from './rebranded/address-book-contacts-active.svg';
export const SVG_ADDRESS_BOOK_CONTACTS_INACTIVE = 'ADDRESS_BOOK_CONTACTS_INACTIVE';
import { default as ADDRESS_BOOK_CONTACTS_INACTIVE_deprecated } from './deprecated/address-book-contacts-inactive.svg';
import { default as ADDRESS_BOOK_CONTACTS_INACTIVE_rebranded } from './rebranded/address-book-contacts-inactive.svg';
export const SVG_ADDRESSES_ACTIVE = 'ADDRESSES_ACTIVE';
import { default as ADDRESSES_ACTIVE_deprecated } from './deprecated/addresses-active.svg';
import { default as ADDRESSES_ACTIVE_rebranded } from './rebranded/addresses-active.svg';
export const SVG_ADDRESSES_INACTIVE = 'ADDRESSES_INACTIVE';
import { default as ADDRESSES_INACTIVE_deprecated } from './deprecated/addresses-inactive.svg';
import { default as ADDRESSES_INACTIVE_rebranded } from './rebranded/addresses-inactive.svg';
export const SVG_ADJUST_CAMERA = 'ADJUST_CAMERA';
import { default as ADJUST_CAMERA_deprecated } from './deprecated/adjust-camera.svg';
import { default as ADJUST_CAMERA_rebranded } from './rebranded/adjust-camera.svg';
export const SVG_ADJUSTMENTS = 'ADJUSTMENTS';
import { default as ADJUSTMENTS_deprecated } from './deprecated/adjustments.svg';
import { default as ADJUSTMENTS_rebranded } from './rebranded/adjustments.svg';
export const SVG_ADMIN_ACTIVE = 'ADMIN_ACTIVE';
import { default as ADMIN_ACTIVE_deprecated } from './deprecated/admin-active.svg';
import { default as ADMIN_ACTIVE_rebranded } from './rebranded/admin-active.svg';
export const SVG_ADMIN_INACTIVE = 'ADMIN_INACTIVE';
import { default as ADMIN_INACTIVE_deprecated } from './deprecated/admin-inactive.svg';
import { default as ADMIN_INACTIVE_rebranded } from './rebranded/admin-inactive.svg';
export const SVG_ADOBE = 'ADOBE';
import { default as ADOBE_deprecated } from './deprecated/adobe.svg';
import { default as ADOBE_rebranded } from './rebranded/adobe.svg';
export const SVG_ALERT_ACTIVE = 'ALERT_ACTIVE';
import { default as ALERT_ACTIVE_deprecated } from './deprecated/alert-active.svg';
import { default as ALERT_ACTIVE_rebranded } from './rebranded/alert-active.svg';
export const SVG_ALERT_INACTIVE = 'ALERT_INACTIVE';
import { default as ALERT_INACTIVE_deprecated } from './deprecated/alert-inactive.svg';
import { default as ALERT_INACTIVE_rebranded } from './rebranded/alert-inactive.svg';
export const SVG_ANDROID = 'ANDROID';
import { default as ANDROID_deprecated } from './deprecated/android.svg';
import { default as ANDROID_rebranded } from './rebranded/android.svg';
export const SVG_AMEX = 'AMEX';
import { default as AMEX_deprecated } from './deprecated/amex.svg';
import { default as AMEX_rebranded } from './rebranded/amex.svg';
export const SVG_ANNOTATION_ACTIVE = 'ANNOTATION_ACTIVE';
import { default as ANNOTATION_ACTIVE_deprecated } from './deprecated/annotation-active.svg';
import { default as ANNOTATION_ACTIVE_rebranded } from './rebranded/annotation-active.svg';
export const SVG_APP_SWITCHER = 'APP_SWITCHER';
import { default as APP_SWITCHER_deprecated } from './deprecated/app-switcher.svg';
import { default as APP_SWITCHER_rebranded } from './rebranded/app-switcher.svg';
export const SVG_APPLE_MONOCHROMATIC = 'APPLE_MONOCHROMATIC';
import { default as APPLE_MONOCHROMATIC_deprecated } from './deprecated/apple-monochromatic.svg';
import { default as APPLE_MONOCHROMATIC_rebranded } from './rebranded/apple-monochromatic.svg';
export const SVG_ARCHIVE_ACTIVE = 'ARCHIVE_ACTIVE';
import { default as ARCHIVE_ACTIVE_deprecated } from './deprecated/archive-active.svg';
import { default as ARCHIVE_ACTIVE_rebranded } from './rebranded/archive-active.svg';
export const SVG_ARCHIVE_INACTIVE = 'ARCHIVE_INACTIVE';
import { default as ARCHIVE_INACTIVE_deprecated } from './deprecated/archive-inactive.svg';
import { default as ARCHIVE_INACTIVE_rebranded } from './rebranded/archive-inactive.svg';
export const SVG_ARROW_DOWN = 'ARROW_DOWN';
import { default as ARROW_DOWN_deprecated } from './deprecated/arrow-down.svg';
import { default as ARROW_DOWN_rebranded } from './rebranded/arrow-down.svg';
export const SVG_ARROW_LEFT = 'ARROW_LEFT';
import { default as ARROW_LEFT_deprecated } from './deprecated/arrow-left.svg';
import { default as ARROW_LEFT_rebranded } from './rebranded/arrow-left.svg';
export const SVG_ARROW_RIGHT = 'ARROW_RIGHT';
import { default as ARROW_RIGHT_deprecated } from './deprecated/arrow-right.svg';
import { default as ARROW_RIGHT_rebranded } from './rebranded/arrow-right.svg';
export const SVG_ARROW_UP = 'ARROW_UP';
import { default as ARROW_UP_deprecated } from './deprecated/arrow-up.svg';
import { default as ARROW_UP_rebranded } from './rebranded/arrow-up.svg';
export const SVG_ASSISTANCE_ACTIVE = 'ASSISTANCE_ACTIVE';
import { default as ASSISTANCE_ACTIVE_deprecated } from './deprecated/assistance-active.svg';
import { default as ASSISTANCE_ACTIVE_rebranded } from './rebranded/assistance-active.svg';
export const SVG_ASSISTANCE_INACTIVE = 'ASSISTANCE_INACTIVE';
import { default as ASSISTANCE_INACTIVE_deprecated } from './deprecated/assistance-inactive.svg';
import { default as ASSISTANCE_INACTIVE_rebranded } from './rebranded/assistance-inactive.svg';
export const SVG_AUDIO_OFF_20_PX = 'AUDIO_OFF_20_PX';
import { default as AUDIO_OFF_20_PX_deprecated } from './deprecated/audio-off-20-px.svg';
import { default as AUDIO_OFF_20_PX_rebranded } from './rebranded/audio-off-20-px.svg';
export const SVG_BACKSPACE = 'BACKSPACE';
import { default as BACKSPACE_deprecated } from './deprecated/backspace.svg';
import { default as BACKSPACE_rebranded } from './rebranded/backspace.svg';
export const SVG_BADGE_INACTIVE = 'BADGE_INACTIVE';
import { default as BADGE_INACTIVE_deprecated } from './deprecated/badge-inactive.svg';
import { default as BADGE_INACTIVE_rebranded } from './rebranded/badge-inactive.svg';
export const SVG_BADGE_ACTIVE = 'BADGE_ACTIVE';
import { default as BADGE_ACTIVE_deprecated } from './deprecated/badge-active.svg';
import { default as BADGE_ACTIVE_rebranded } from './rebranded/badge-active.svg';
export const SVG_BATTERY_LOW = 'BATTERY_LOW';
import { default as BATTERY_LOW_deprecated } from './deprecated/battery-low.svg';
import { default as BATTERY_LOW_rebranded } from './rebranded/battery-low.svg';
export const SVG_BATTERY_FULL = 'BATTERY_FULL';
import { default as BATTERY_FULL_deprecated } from './deprecated/battery-full.svg';
import { default as BATTERY_FULL_rebranded } from './rebranded/battery-full.svg';
export const SVG_BATTERY_MID = 'BATTERY_MID';
import { default as BATTERY_MID_deprecated } from './deprecated/battery-mid.svg';
import { default as BATTERY_MID_rebranded } from './rebranded/battery-mid.svg';
export const SVG_BELL_ACTIVE = 'BELL_ACTIVE';
import { default as BELL_ACTIVE_deprecated } from './deprecated/bell-active.svg';
import { default as BELL_ACTIVE_rebranded } from './rebranded/bell-active.svg';
export const SVG_BELL_DISABLED_INACTIVE = 'BELL_DISABLED_INACTIVE';
import { default as BELL_DISABLED_INACTIVE_deprecated } from './deprecated/bell-disabled-inactive.svg';
import { default as BELL_DISABLED_INACTIVE_rebranded } from './rebranded/bell-disabled-inactive.svg';
export const SVG_BELL_DISABLED_ACTIVE = 'BELL_DISABLED_ACTIVE';
import { default as BELL_DISABLED_ACTIVE_deprecated } from './deprecated/bell-disabled-active.svg';
import { default as BELL_DISABLED_ACTIVE_rebranded } from './rebranded/bell-disabled-active.svg';
export const SVG_BELL_INACTIVE = 'BELL_INACTIVE';
import { default as BELL_INACTIVE_deprecated } from './deprecated/bell-inactive.svg';
import { default as BELL_INACTIVE_rebranded } from './rebranded/bell-inactive.svg';
export const SVG_BLOCK = 'BLOCK';
import { default as BLOCK_deprecated } from './deprecated/block.svg';
import { default as BLOCK_rebranded } from './rebranded/block.svg';
export const SVG_BLUETOOTH = 'BLUETOOTH';
import { default as BLUETOOTH_deprecated } from './deprecated/bluetooth.svg';
import { default as BLUETOOTH_rebranded } from './rebranded/bluetooth.svg';
export const SVG_BLUETOOTH_CONNECTED = 'BLUETOOTH_CONNECTED';
import { default as BLUETOOTH_CONNECTED_deprecated } from './deprecated/bluetooth-connected.svg';
import { default as BLUETOOTH_CONNECTED_rebranded } from './rebranded/bluetooth-connected.svg';
export const SVG_BOOKMARK_ACTIVE = 'BOOKMARK_ACTIVE';
import { default as BOOKMARK_ACTIVE_deprecated } from './deprecated/bookmark-active.svg';
import { default as BOOKMARK_ACTIVE_rebranded } from './rebranded/bookmark-active.svg';
export const SVG_BOOKMARK_INACTIVE = 'BOOKMARK_INACTIVE';
import { default as BOOKMARK_INACTIVE_deprecated } from './deprecated/bookmark-inactive.svg';
import { default as BOOKMARK_INACTIVE_rebranded } from './rebranded/bookmark-inactive.svg';
export const SVG_BRAVE = 'BRAVE';
import { default as BRAVE_deprecated } from './deprecated/brave.svg';
import { default as BRAVE_rebranded } from './rebranded/brave.svg';
export const SVG_BREAKOUT_ROOM = 'BREAKOUT_ROOM';
import { default as BREAKOUT_ROOM_deprecated } from './deprecated/breakout-room.svg';
import { default as BREAKOUT_ROOM_rebranded } from './rebranded/breakout-room.svg';
export const SVG_BRIGHTNESS = 'BRIGHTNESS';
import { default as BRIGHTNESS_deprecated } from './deprecated/brightness.svg';
import { default as BRIGHTNESS_rebranded } from './rebranded/brightness.svg';
export const SVG_BUG_ACTIVE = 'BUG_ACTIVE';
import { default as BUG_ACTIVE_deprecated } from './deprecated/bug-active.svg';
import { default as BUG_ACTIVE_rebranded } from './rebranded/bug-active.svg';
export const SVG_BUG_INACTIVE = 'BUG_INACTIVE';
import { default as BUG_INACTIVE_deprecated } from './deprecated/bug-inactive.svg';
import { default as BUG_INACTIVE_rebranded } from './rebranded/bug-inactive.svg';
export const SVG_BULB_ACTIVE = 'BULB_ACTIVE';
import { default as BULB_ACTIVE_deprecated } from './deprecated/bulb-active.svg';
import { default as BULB_ACTIVE_rebranded } from './rebranded/bulb-active.svg';
export const SVG_BULB_INACTIVE = 'BULB_INACTIVE';
import { default as BULB_INACTIVE_deprecated } from './deprecated/bulb-inactive.svg';
import { default as BULB_INACTIVE_rebranded } from './rebranded/bulb-inactive.svg';
export const SVG_BUSINESS_ACTIVE = 'BUSINESS_ACTIVE';
import { default as BUSINESS_ACTIVE_deprecated } from './deprecated/business-active.svg';
import { default as BUSINESS_ACTIVE_rebranded } from './rebranded/business-active.svg';
export const SVG_BUSINESS_INACTIVE = 'BUSINESS_INACTIVE';
import { default as BUSINESS_INACTIVE_deprecated } from './deprecated/business-inactive.svg';
import { default as BUSINESS_INACTIVE_rebranded } from './rebranded/business-inactive.svg';
export const SVG_CALCULATOR_ACTIVE = 'CALCULATOR_ACTIVE';
import { default as CALCULATOR_ACTIVE_deprecated } from './deprecated/calculator-active.svg';
import { default as CALCULATOR_ACTIVE_rebranded } from './rebranded/calculator-active.svg';
export const SVG_CALCULATOR_INACTIVE = 'CALCULATOR_INACTIVE';
import { default as CALCULATOR_INACTIVE_deprecated } from './deprecated/calculator-inactive.svg';
import { default as CALCULATOR_INACTIVE_rebranded } from './rebranded/calculator-inactive.svg';
export const SVG_CALENDAR_ACTIVE = 'CALENDAR_ACTIVE';
import { default as CALENDAR_ACTIVE_deprecated } from './deprecated/calendar-active.svg';
import { default as CALENDAR_ACTIVE_rebranded } from './rebranded/calendar-active.svg';
export const SVG_CALENDAR_INACTIVE = 'CALENDAR_INACTIVE';
import { default as CALENDAR_INACTIVE_deprecated } from './deprecated/calendar-inactive.svg';
import { default as CALENDAR_INACTIVE_rebranded } from './rebranded/calendar-inactive.svg';
export const SVG_CALL_FAILED_ACTIVE = 'CALL_FAILED_ACTIVE';
import { default as CALL_FAILED_ACTIVE_deprecated } from './deprecated/call-failed-active.svg';
import { default as CALL_FAILED_ACTIVE_rebranded } from './rebranded/call-failed-active.svg';
export const SVG_CALL_FAILED_INACTIVE = 'CALL_FAILED_INACTIVE';
import { default as CALL_FAILED_INACTIVE_deprecated } from './deprecated/call-failed-inactive.svg';
import { default as CALL_FAILED_INACTIVE_rebranded } from './rebranded/call-failed-inactive.svg';
export const SVG_CALL_MADE = 'CALL_MADE';
import { default as CALL_MADE_deprecated } from './deprecated/call-made.svg';
import { default as CALL_MADE_rebranded } from './rebranded/call-made.svg';
export const SVG_CALL_ME_UP_ACTIVE = 'CALL_ME_UP_ACTIVE';
import { default as CALL_ME_UP_ACTIVE_deprecated } from './deprecated/call-me-up-active.svg';
import { default as CALL_ME_UP_ACTIVE_rebranded } from './rebranded/call-me-up-active.svg';
export const SVG_CALL_ME_UP_INACTIVE = 'CALL_ME_UP_INACTIVE';
import { default as CALL_ME_UP_INACTIVE_deprecated } from './deprecated/call-me-up-inactive.svg';
import { default as CALL_ME_UP_INACTIVE_rebranded } from './rebranded/call-me-up-inactive.svg';
export const SVG_CALL_MESSAGE_ACTIVE = 'CALL_MESSAGE_ACTIVE';
import { default as CALL_MESSAGE_ACTIVE_deprecated } from './deprecated/call-message-active.svg';
import { default as CALL_MESSAGE_ACTIVE_rebranded } from './rebranded/call-message-active.svg';
export const SVG_CALL_MERGE = 'CALL_MERGE';
import { default as CALL_MERGE_deprecated } from './deprecated/call-merge.svg';
import { default as CALL_MERGE_rebranded } from './rebranded/call-merge.svg';
export const SVG_CALL_MESSAGE_INACTIVE = 'CALL_MESSAGE_INACTIVE';
import { default as CALL_MESSAGE_INACTIVE_deprecated } from './deprecated/call-message-inactive.svg';
import { default as CALL_MESSAGE_INACTIVE_rebranded } from './rebranded/call-message-inactive.svg';
export const SVG_CALL_MISSED = 'CALL_MISSED';
import { default as CALL_MISSED_deprecated } from './deprecated/call-missed.svg';
import { default as CALL_MISSED_rebranded } from './rebranded/call-missed.svg';
export const SVG_CALL_ON_HOLD_ACTIVE = 'CALL_ON_HOLD_ACTIVE';
import { default as CALL_ON_HOLD_ACTIVE_deprecated } from './deprecated/call-on-hold-active.svg';
import { default as CALL_ON_HOLD_ACTIVE_rebranded } from './rebranded/call-on-hold-active.svg';
export const SVG_CALL_ON_HOLD_INACTIVE = 'CALL_ON_HOLD_INACTIVE';
import { default as CALL_ON_HOLD_INACTIVE_deprecated } from './deprecated/call-on-hold-inactive.svg';
import { default as CALL_ON_HOLD_INACTIVE_rebranded } from './rebranded/call-on-hold-inactive.svg';
export const SVG_CALL_PARK_ACTIVE = 'CALL_PARK_ACTIVE';
import { default as CALL_PARK_ACTIVE_deprecated } from './deprecated/call-park-active.svg';
import { default as CALL_PARK_ACTIVE_rebranded } from './rebranded/call-park-active.svg';
export const SVG_CALL_PARK_INACTIVE = 'CALL_PARK_INACTIVE';
import { default as CALL_PARK_INACTIVE_deprecated } from './deprecated/call-park-inactive.svg';
import { default as CALL_PARK_INACTIVE_rebranded } from './rebranded/call-park-inactive.svg';
export const SVG_CALL_RECEIVED = 'CALL_RECEIVED';
import { default as CALL_RECEIVED_deprecated } from './deprecated/call-received.svg';
import { default as CALL_RECEIVED_rebranded } from './rebranded/call-received.svg';
export const SVG_CALL_SPLIT = 'CALL_SPLIT';
import { default as CALL_SPLIT_deprecated } from './deprecated/call-split.svg';
import { default as CALL_SPLIT_rebranded } from './rebranded/call-split.svg';
export const SVG_CALL_TRANSFER_ACTIVE = 'CALL_TRANSFER_ACTIVE';
import { default as CALL_TRANSFER_ACTIVE_deprecated } from './deprecated/call-transfer-active.svg';
import { default as CALL_TRANSFER_ACTIVE_rebranded } from './rebranded/call-transfer-active.svg';
export const SVG_CALL_TRANSFER_INACTIVE = 'CALL_TRANSFER_INACTIVE';
import { default as CALL_TRANSFER_INACTIVE_deprecated } from './deprecated/call-transfer-inactive.svg';
import { default as CALL_TRANSFER_INACTIVE_rebranded } from './rebranded/call-transfer-inactive.svg';
export const SVG_CAMERA_ACTIVE = 'CAMERA_ACTIVE';
import { default as CAMERA_ACTIVE_deprecated } from './deprecated/camera-active.svg';
import { default as CAMERA_ACTIVE_rebranded } from './rebranded/camera-active.svg';
export const SVG_CAMERA_AUTO = 'CAMERA_AUTO';
import { default as CAMERA_AUTO_deprecated } from './deprecated/camera-auto.svg';
import { default as CAMERA_AUTO_rebranded } from './rebranded/camera-auto.svg';
export const SVG_CAMERA_FLIP = 'CAMERA_FLIP';
import { default as CAMERA_FLIP_deprecated } from './deprecated/camera-flip.svg';
import { default as CAMERA_FLIP_rebranded } from './rebranded/camera-flip.svg';
export const SVG_CAMERA_INACTIVE = 'CAMERA_INACTIVE';
import { default as CAMERA_INACTIVE_deprecated } from './deprecated/camera-inactive.svg';
import { default as CAMERA_INACTIVE_rebranded } from './rebranded/camera-inactive.svg';
export const SVG_CAMERA_POSITION_BOTTOM = 'CAMERA_POSITION_BOTTOM';
import { default as CAMERA_POSITION_BOTTOM_deprecated } from './deprecated/camera-position-bottom.svg';
import { default as CAMERA_POSITION_BOTTOM_rebranded } from './rebranded/camera-position-bottom.svg';
export const SVG_CAMERA_POSITION_LEFT = 'CAMERA_POSITION_LEFT';
import { default as CAMERA_POSITION_LEFT_deprecated } from './deprecated/camera-position-left.svg';
import { default as CAMERA_POSITION_LEFT_rebranded } from './rebranded/camera-position-left.svg';
export const SVG_CAMERA_POSITION_RIGHT = 'CAMERA_POSITION_RIGHT';
import { default as CAMERA_POSITION_RIGHT_deprecated } from './deprecated/camera-position-right.svg';
import { default as CAMERA_POSITION_RIGHT_rebranded } from './rebranded/camera-position-right.svg';
export const SVG_CAMERA_POSITION_TOP = 'CAMERA_POSITION_TOP';
import { default as CAMERA_POSITION_TOP_deprecated } from './deprecated/camera-position-top.svg';
import { default as CAMERA_POSITION_TOP_rebranded } from './rebranded/camera-position-top.svg';
export const SVG_CAMERA_PRESETS_ACTIVE = 'CAMERA_PRESETS_ACTIVE';
import { default as CAMERA_PRESETS_ACTIVE_deprecated } from './deprecated/camera-presets-active.svg';
import { default as CAMERA_PRESETS_ACTIVE_rebranded } from './rebranded/camera-presets-active.svg';
export const SVG_CAMERA_PRESETS_INACTIVE = 'CAMERA_PRESETS_INACTIVE';
import { default as CAMERA_PRESETS_INACTIVE_deprecated } from './deprecated/camera-presets-inactive.svg';
import { default as CAMERA_PRESETS_INACTIVE_rebranded } from './rebranded/camera-presets-inactive.svg';
export const SVG_CAMERA_SHARE = 'CAMERA_SHARE';
import { default as CAMERA_SHARE_deprecated } from './deprecated/camera-share.svg';
import { default as CAMERA_SHARE_rebranded } from './rebranded/camera-share.svg';
export const SVG_CARD = 'CARD';
import { default as CARD_deprecated } from './deprecated/card.svg';
import { default as CARD_rebranded } from './rebranded/card.svg';
export const SVG_CART_ACTIVE = 'CART_ACTIVE';
import { default as CART_ACTIVE_deprecated } from './deprecated/cart-active.svg';
import { default as CART_ACTIVE_rebranded } from './rebranded/cart-active.svg';
export const SVG_CART_INACTIVE = 'CART_INACTIVE';
import { default as CART_INACTIVE_deprecated } from './deprecated/cart-inactive.svg';
import { default as CART_INACTIVE_rebranded } from './rebranded/cart-inactive.svg';
export const SVG_CASH = 'CASH';
import { default as CASH_deprecated } from './deprecated/cash.svg';
import { default as CASH_rebranded } from './rebranded/cash.svg';
export const SVG_CHAT_ACTIVE = 'CHAT_ACTIVE';
import { default as CHAT_ACTIVE_deprecated } from './deprecated/chat-active.svg';
import { default as CHAT_ACTIVE_rebranded } from './rebranded/chat-active.svg';
export const SVG_CHAT_DOTS_ACTIVE = 'CHAT_DOTS_ACTIVE';
import { default as CHAT_DOTS_ACTIVE_deprecated } from './deprecated/chat-dots-active.svg';
import { default as CHAT_DOTS_ACTIVE_rebranded } from './rebranded/chat-dots-active.svg';
export const SVG_CHAT_DOTS_INACTIVE = 'CHAT_DOTS_INACTIVE';
import { default as CHAT_DOTS_INACTIVE_deprecated } from './deprecated/chat-dots-inactive.svg';
import { default as CHAT_DOTS_INACTIVE_rebranded } from './rebranded/chat-dots-inactive.svg';
export const SVG_CHAT_FEEDBACK_ACTIVE = 'CHAT_FEEDBACK_ACTIVE';
import { default as CHAT_FEEDBACK_ACTIVE_deprecated } from './deprecated/chat-feedback-active.svg';
import { default as CHAT_FEEDBACK_ACTIVE_rebranded } from './rebranded/chat-feedback-active.svg';
export const SVG_CHAT_FEEDBACK_INACTIVE = 'CHAT_FEEDBACK_INACTIVE';
import { default as CHAT_FEEDBACK_INACTIVE_deprecated } from './deprecated/chat-feedback-inactive.svg';
import { default as CHAT_FEEDBACK_INACTIVE_rebranded } from './rebranded/chat-feedback-inactive.svg';
export const SVG_CHAT_INACTIVE = 'CHAT_INACTIVE';
import { default as CHAT_INACTIVE_deprecated } from './deprecated/chat-inactive.svg';
import { default as CHAT_INACTIVE_rebranded } from './rebranded/chat-inactive.svg';
export const SVG_CHAT_QUESTION_INACTIVE = 'CHAT_QUESTION_INACTIVE';
import { default as CHAT_QUESTION_INACTIVE_deprecated } from './deprecated/chat-question-inactive.svg';
import { default as CHAT_QUESTION_INACTIVE_rebranded } from './rebranded/chat-question-inactive.svg';
export const SVG_CHAT_QUESTION_ACTIVE = 'CHAT_QUESTION_ACTIVE';
import { default as CHAT_QUESTION_ACTIVE_deprecated } from './deprecated/chat-question-active.svg';
import { default as CHAT_QUESTION_ACTIVE_rebranded } from './rebranded/chat-question-active.svg';
export const SVG_CHECK = 'CHECK';
import { default as CHECK_deprecated } from './deprecated/check.svg';
import { default as CHECK_rebranded } from './rebranded/check.svg';
export const SVG_CHECKBOX_ACTIVE_ANDROID = 'CHECKBOX_ACTIVE_ANDROID';
import { default as CHECKBOX_ACTIVE_ANDROID_deprecated } from './deprecated/checkbox-active-android.svg';
import { default as CHECKBOX_ACTIVE_ANDROID_rebranded } from './rebranded/checkbox-active-android.svg';
export const SVG_CHECKBOX_ACTIVE = 'CHECKBOX_ACTIVE';
import { default as CHECKBOX_ACTIVE_deprecated } from './deprecated/checkbox-active.svg';
import { default as CHECKBOX_ACTIVE_rebranded } from './rebranded/checkbox-active.svg';
export const SVG_CHECKBOX_ANDROID_INDETERMINATE = 'CHECKBOX_ANDROID_INDETERMINATE';
import { default as CHECKBOX_ANDROID_INDETERMINATE_deprecated } from './deprecated/checkbox-android-indeterminate.svg';
import { default as CHECKBOX_ANDROID_INDETERMINATE_rebranded } from './rebranded/checkbox-android-indeterminate.svg';
export const SVG_CHECKBOX_ANDROID = 'CHECKBOX_ANDROID';
import { default as CHECKBOX_ANDROID_deprecated } from './deprecated/checkbox-android.svg';
import { default as CHECKBOX_ANDROID_rebranded } from './rebranded/checkbox-android.svg';
export const SVG_CHECKBOX_CHECK = 'CHECKBOX_CHECK';
import { default as CHECKBOX_CHECK_deprecated } from './deprecated/checkbox-check.svg';
import { default as CHECKBOX_CHECK_rebranded } from './rebranded/checkbox-check.svg';
export const SVG_CHECKBOX_INDETERMINATE = 'CHECKBOX_INDETERMINATE';
import { default as CHECKBOX_INDETERMINATE_deprecated } from './deprecated/checkbox-indeterminate.svg';
import { default as CHECKBOX_INDETERMINATE_rebranded } from './rebranded/checkbox-indeterminate.svg';
export const SVG_CHECKBOX_LINE = 'CHECKBOX_LINE';
import { default as CHECKBOX_LINE_deprecated } from './deprecated/checkbox-line.svg';
import { default as CHECKBOX_LINE_rebranded } from './rebranded/checkbox-line.svg';
export const SVG_CHECKBOX = 'CHECKBOX';
import { default as CHECKBOX_deprecated } from './deprecated/checkbox.svg';
import { default as CHECKBOX_rebranded } from './rebranded/checkbox.svg';
export const SVG_CHECKMARK_CIRCLE_ACTIVE = 'CHECKMARK_CIRCLE_ACTIVE';
import { default as CHECKMARK_CIRCLE_ACTIVE_deprecated } from './deprecated/checkmark-circle-active.svg';
import { default as CHECKMARK_CIRCLE_ACTIVE_rebranded } from './rebranded/checkmark-circle-active.svg';
export const SVG_CHECKMARK_CIRCLE_INACTIVE = 'CHECKMARK_CIRCLE_INACTIVE';
import { default as CHECKMARK_CIRCLE_INACTIVE_deprecated } from './deprecated/checkmark-circle-inactive.svg';
import { default as CHECKMARK_CIRCLE_INACTIVE_rebranded } from './rebranded/checkmark-circle-inactive.svg';
export const SVG_CHEVRON_COMBO = 'CHEVRON_COMBO';
import { default as CHEVRON_COMBO_deprecated } from './deprecated/chevron-combo.svg';
import { default as CHEVRON_COMBO_rebranded } from './rebranded/chevron-combo.svg';
export const SVG_CHEVRON_DOWN_20_PX = 'CHEVRON_DOWN_20_PX';
import { default as CHEVRON_DOWN_20_PX_deprecated } from './deprecated/chevron-down-20-px.svg';
import { default as CHEVRON_DOWN_20_PX_rebranded } from './rebranded/chevron-down-20-px.svg';
export const SVG_CHEVRON_DOWN = 'CHEVRON_DOWN';
import { default as CHEVRON_DOWN_deprecated } from './deprecated/chevron-down.svg';
import { default as CHEVRON_DOWN_rebranded } from './rebranded/chevron-down.svg';
export const SVG_CHEVRON_LEFT_COLLAPSE = 'CHEVRON_LEFT_COLLAPSE';
import { default as CHEVRON_LEFT_COLLAPSE_deprecated } from './deprecated/chevron-left-collapse.svg';
import { default as CHEVRON_LEFT_COLLAPSE_rebranded } from './rebranded/chevron-left-collapse.svg';
export const SVG_CHEVRON_LEFT_IOS = 'CHEVRON_LEFT_IOS';
import { default as CHEVRON_LEFT_IOS_deprecated } from './deprecated/chevron-left-ios.svg';
import { default as CHEVRON_LEFT_IOS_rebranded } from './rebranded/chevron-left-ios.svg';
export const SVG_CHEVRON_LEFT = 'CHEVRON_LEFT';
import { default as CHEVRON_LEFT_deprecated } from './deprecated/chevron-left.svg';
import { default as CHEVRON_LEFT_rebranded } from './rebranded/chevron-left.svg';
export const SVG_CHEVRON_RIGHT_EXPAND = 'CHEVRON_RIGHT_EXPAND';
import { default as CHEVRON_RIGHT_EXPAND_deprecated } from './deprecated/chevron-right-expand.svg';
import { default as CHEVRON_RIGHT_EXPAND_rebranded } from './rebranded/chevron-right-expand.svg';
export const SVG_CHEVRON_RIGHT = 'CHEVRON_RIGHT';
import { default as CHEVRON_RIGHT_deprecated } from './deprecated/chevron-right.svg';
import { default as CHEVRON_RIGHT_rebranded } from './rebranded/chevron-right.svg';
export const SVG_CHEVRON_UP_20_PX = 'CHEVRON_UP_20_PX';
import { default as CHEVRON_UP_20_PX_deprecated } from './deprecated/chevron-up-20-px.svg';
import { default as CHEVRON_UP_20_PX_rebranded } from './rebranded/chevron-up-20-px.svg';
export const SVG_CHEVRON_UP = 'CHEVRON_UP';
import { default as CHEVRON_UP_deprecated } from './deprecated/chevron-up.svg';
import { default as CHEVRON_UP_rebranded } from './rebranded/chevron-up.svg';
export const SVG_CLEAR_ALL = 'CLEAR_ALL';
import { default as CLEAR_ALL_deprecated } from './deprecated/clear-all.svg';
import { default as CLEAR_ALL_rebranded } from './rebranded/clear-all.svg';
export const SVG_CLIP = 'CLIP';
import { default as CLIP_deprecated } from './deprecated/clip.svg';
import { default as CLIP_rebranded } from './rebranded/clip.svg';
export const SVG_CLIPBOARD_ACTIVE = 'CLIPBOARD_ACTIVE';
import { default as CLIPBOARD_ACTIVE_deprecated } from './deprecated/clipboard-active.svg';
import { default as CLIPBOARD_ACTIVE_rebranded } from './rebranded/clipboard-active.svg';
export const SVG_CLIPBOARD_INACTIVE = 'CLIPBOARD_INACTIVE';
import { default as CLIPBOARD_INACTIVE_deprecated } from './deprecated/clipboard-inactive.svg';
import { default as CLIPBOARD_INACTIVE_rebranded } from './rebranded/clipboard-inactive.svg';
export const SVG_CLOCK_ACTIVE = 'CLOCK_ACTIVE';
import { default as CLOCK_ACTIVE_deprecated } from './deprecated/clock-active.svg';
import { default as CLOCK_ACTIVE_rebranded } from './rebranded/clock-active.svg';
export const SVG_CLOCK_INACTIVE = 'CLOCK_INACTIVE';
import { default as CLOCK_INACTIVE_deprecated } from './deprecated/clock-inactive.svg';
import { default as CLOCK_INACTIVE_rebranded } from './rebranded/clock-inactive.svg';
export const SVG_CLOSE_CIRCLE_ACTIVE = 'CLOSE_CIRCLE_ACTIVE';
import { default as CLOSE_CIRCLE_ACTIVE_deprecated } from './deprecated/close-circle-active.svg';
import { default as CLOSE_CIRCLE_ACTIVE_rebranded } from './rebranded/close-circle-active.svg';
export const SVG_CLOSE_CIRCLE_INACTIVE = 'CLOSE_CIRCLE_INACTIVE';
import { default as CLOSE_CIRCLE_INACTIVE_deprecated } from './deprecated/close-circle-inactive.svg';
import { default as CLOSE_CIRCLE_INACTIVE_rebranded } from './rebranded/close-circle-inactive.svg';
export const SVG_CLOSE = 'CLOSE';
import { default as CLOSE_deprecated } from './deprecated/close.svg';
import { default as CLOSE_rebranded } from './rebranded/close.svg';
export const SVG_CLOUD_OFF = 'CLOUD_OFF';
import { default as CLOUD_OFF_deprecated } from './deprecated/cloud-off.svg';
import { default as CLOUD_OFF_rebranded } from './rebranded/cloud-off.svg';
export const SVG_CLOUD = 'CLOUD';
import { default as CLOUD_deprecated } from './deprecated/cloud.svg';
import { default as CLOUD_rebranded } from './rebranded/cloud.svg';
export const SVG_CLOUD_UPLOAD = 'CLOUD_UPLOAD';
import { default as CLOUD_UPLOAD_deprecated } from './deprecated/cloud-upload.svg';
import { default as CLOUD_UPLOAD_rebranded } from './rebranded/cloud-upload.svg';
export const SVG_COBY_ACTIVE = 'COBY_ACTIVE';
import { default as COBY_ACTIVE_deprecated } from './deprecated/coby-active.svg';
import { default as COBY_ACTIVE_rebranded } from './rebranded/coby-active.svg';
export const SVG_COBY_INACTIVE = 'COBY_INACTIVE';
import { default as COBY_INACTIVE_deprecated } from './deprecated/coby-inactive.svg';
import { default as COBY_INACTIVE_rebranded } from './rebranded/coby-inactive.svg';
export const SVG_CODE = 'CODE';
import { default as CODE_deprecated } from './deprecated/code.svg';
import { default as CODE_rebranded } from './rebranded/code.svg';
export const SVG_APPLE = 'APPLE';
import { default as APPLE_deprecated } from './deprecated/apple.svg';
import { default as APPLE_rebranded } from './rebranded/apple.svg';
export const SVG_CONNECT_WISE = 'CONNECT_WISE';
import { default as CONNECT_WISE_deprecated } from './deprecated/connect-wise.svg';
import { default as CONNECT_WISE_rebranded } from './rebranded/connect-wise.svg';
export const SVG_DATTO = 'DATTO';
import { default as DATTO_deprecated } from './deprecated/datto.svg';
import { default as DATTO_rebranded } from './rebranded/datto.svg';
export const SVG_FACEBOOK = 'FACEBOOK';
import { default as FACEBOOK_deprecated } from './deprecated/facebook.svg';
import { default as FACEBOOK_rebranded } from './rebranded/facebook.svg';
export const SVG_FILE = 'FILE';
import { default as FILE_deprecated } from './deprecated/file.svg';
import { default as FILE_rebranded } from './rebranded/file.svg';
export const SVG_GOOGLE_DRIVE_DOC = 'GOOGLE_DRIVE_DOC';
import { default as GOOGLE_DRIVE_DOC_deprecated } from './deprecated/google-drive-doc.svg';
import { default as GOOGLE_DRIVE_DOC_rebranded } from './rebranded/google-drive-doc.svg';
export const SVG_GOOGLE_DRIVE_DRAWINGS = 'GOOGLE_DRIVE_DRAWINGS';
import { default as GOOGLE_DRIVE_DRAWINGS_deprecated } from './deprecated/google-drive-drawings.svg';
import { default as GOOGLE_DRIVE_DRAWINGS_rebranded } from './rebranded/google-drive-drawings.svg';
export const SVG_GOOGLE_DRIVE_FOLDER = 'GOOGLE_DRIVE_FOLDER';
import { default as GOOGLE_DRIVE_FOLDER_deprecated } from './deprecated/google-drive-folder.svg';
import { default as GOOGLE_DRIVE_FOLDER_rebranded } from './rebranded/google-drive-folder.svg';
export const SVG_GOOGLE_DRIVE_SHEET = 'GOOGLE_DRIVE_SHEET';
import { default as GOOGLE_DRIVE_SHEET_deprecated } from './deprecated/google-drive-sheet.svg';
import { default as GOOGLE_DRIVE_SHEET_rebranded } from './rebranded/google-drive-sheet.svg';
export const SVG_GOOGLE_DRIVE_SLIDE = 'GOOGLE_DRIVE_SLIDE';
import { default as GOOGLE_DRIVE_SLIDE_deprecated } from './deprecated/google-drive-slide.svg';
import { default as GOOGLE_DRIVE_SLIDE_rebranded } from './rebranded/google-drive-slide.svg';
export const SVG_GOOGLE_DRIVE = 'GOOGLE_DRIVE';
import { default as GOOGLE_DRIVE_deprecated } from './deprecated/google-drive.svg';
import { default as GOOGLE_DRIVE_rebranded } from './rebranded/google-drive.svg';
export const SVG_GOOGLE_GMAIL = 'GOOGLE_GMAIL';
import { default as GOOGLE_GMAIL_deprecated } from './deprecated/google-gmail.svg';
import { default as GOOGLE_GMAIL_rebranded } from './rebranded/google-gmail.svg';
export const SVG_GOOGLE = 'GOOGLE';
import { default as GOOGLE_deprecated } from './deprecated/google.svg';
import { default as GOOGLE_rebranded } from './rebranded/google.svg';
export const SVG_GOTO_ADMIN_PARTNER_APP_ICON_DARK_MODE = 'GOTO_ADMIN_PARTNER_APP_ICON_DARK_MODE';
import { default as GOTO_ADMIN_PARTNER_APP_ICON_DARK_MODE_deprecated } from './deprecated/goto-admin-partner-app-icon-dark-mode.svg';
import { default as GOTO_ADMIN_PARTNER_APP_ICON_DARK_MODE_rebranded } from './rebranded/goto-admin-partner-app-icon-dark-mode.svg';
export const SVG_GOTO_ADMIN_PARTNER_APP_ICON = 'GOTO_ADMIN_PARTNER_APP_ICON';
import { default as GOTO_ADMIN_PARTNER_APP_ICON_deprecated } from './deprecated/goto-admin-partner-app-icon.svg';
import { default as GOTO_ADMIN_PARTNER_APP_ICON_rebranded } from './rebranded/goto-admin-partner-app-icon.svg';
export const SVG_GOTO_ADMIN_PARTNER_FAVICON_DARK_MODE = 'GOTO_ADMIN_PARTNER_FAVICON_DARK_MODE';
import { default as GOTO_ADMIN_PARTNER_FAVICON_DARK_MODE_deprecated } from './deprecated/goto-admin-partner-favicon-dark-mode.svg';
import { default as GOTO_ADMIN_PARTNER_FAVICON_DARK_MODE_rebranded } from './rebranded/goto-admin-partner-favicon-dark-mode.svg';
export const SVG_GOTO_ADMIN_PARTNER_FAVICON = 'GOTO_ADMIN_PARTNER_FAVICON';
import { default as GOTO_ADMIN_PARTNER_FAVICON_deprecated } from './deprecated/goto-admin-partner-favicon.svg';
import { default as GOTO_ADMIN_PARTNER_FAVICON_rebranded } from './rebranded/goto-admin-partner-favicon.svg';
export const SVG_GOTO_APP_ICON_DARK_MODE = 'GOTO_APP_ICON_DARK_MODE';
import { default as GOTO_APP_ICON_DARK_MODE_deprecated } from './deprecated/goto-app-icon-dark-mode.svg';
import { default as GOTO_APP_ICON_DARK_MODE_rebranded } from './rebranded/goto-app-icon-dark-mode.svg';
export const SVG_GOTO_BLACK_FAVICON = 'GOTO_BLACK_FAVICON';
import { default as GOTO_BLACK_FAVICON_deprecated } from './deprecated/goto-black-favicon.svg';
import { default as GOTO_BLACK_FAVICON_rebranded } from './rebranded/goto-black-favicon.svg';
export const SVG_GOTO_APP_ICON = 'GOTO_APP_ICON';
import { default as GOTO_APP_ICON_deprecated } from './deprecated/goto-app-icon.svg';
import { default as GOTO_APP_ICON_rebranded } from './rebranded/goto-app-icon.svg';
export const SVG_GOTO_BLACK_WHITE = 'GOTO_BLACK_WHITE';
import { default as GOTO_BLACK_WHITE_deprecated } from './deprecated/goto-black-white.svg';
import { default as GOTO_BLACK_WHITE_rebranded } from './rebranded/goto-black-white.svg';
export const SVG_GOTO_BLACK_YELLOW_FAVICON = 'GOTO_BLACK_YELLOW_FAVICON';
import { default as GOTO_BLACK_YELLOW_FAVICON_deprecated } from './deprecated/goto-black-yellow-favicon.svg';
import { default as GOTO_BLACK_YELLOW_FAVICON_rebranded } from './rebranded/goto-black-yellow-favicon.svg';
export const SVG_GOTO_BLACK_YELLOW = 'GOTO_BLACK_YELLOW';
import { default as GOTO_BLACK_YELLOW_deprecated } from './deprecated/goto-black-yellow.svg';
import { default as GOTO_BLACK_YELLOW_rebranded } from './rebranded/goto-black-yellow.svg';
export const SVG_GOTO_BLACK = 'GOTO_BLACK';
import { default as GOTO_BLACK_deprecated } from './deprecated/goto-black.svg';
import { default as GOTO_BLACK_rebranded } from './rebranded/goto-black.svg';
export const SVG_GOTO_GIVES_BLACK_YELLOW = 'GOTO_GIVES_BLACK_YELLOW';
import { default as GOTO_GIVES_BLACK_YELLOW_deprecated } from './deprecated/goto-gives-black-yellow.svg';
import { default as GOTO_GIVES_BLACK_YELLOW_rebranded } from './rebranded/goto-gives-black-yellow.svg';
export const SVG_GOTO_GIVES_BLACK = 'GOTO_GIVES_BLACK';
import { default as GOTO_GIVES_BLACK_deprecated } from './deprecated/goto-gives-black.svg';
import { default as GOTO_GIVES_BLACK_rebranded } from './rebranded/goto-gives-black.svg';
export const SVG_GOTO_GIVES_GREY = 'GOTO_GIVES_GREY';
import { default as GOTO_GIVES_GREY_deprecated } from './deprecated/goto-gives-grey.svg';
import { default as GOTO_GIVES_GREY_rebranded } from './rebranded/goto-gives-grey.svg';
export const SVG_GOTO_GIVES_WHITE_YELLOW = 'GOTO_GIVES_WHITE_YELLOW';
import { default as GOTO_GIVES_WHITE_YELLOW_deprecated } from './deprecated/goto-gives-white-yellow.svg';
import { default as GOTO_GIVES_WHITE_YELLOW_rebranded } from './rebranded/goto-gives-white-yellow.svg';
export const SVG_GOTO_GIVES_WHITE = 'GOTO_GIVES_WHITE';
import { default as GOTO_GIVES_WHITE_deprecated } from './deprecated/goto-gives-white.svg';
import { default as GOTO_GIVES_WHITE_rebranded } from './rebranded/goto-gives-white.svg';
export const SVG_GOTO_GREY = 'GOTO_GREY';
import { default as GOTO_GREY_deprecated } from './deprecated/goto-grey.svg';
import { default as GOTO_GREY_rebranded } from './rebranded/goto-grey.svg';
export const SVG_GOTO_INTEGRATIONS_APP_ICON_DARK_MODE = 'GOTO_INTEGRATIONS_APP_ICON_DARK_MODE';
import { default as GOTO_INTEGRATIONS_APP_ICON_DARK_MODE_deprecated } from './deprecated/goto-integrations-app-icon-dark-mode.svg';
import { default as GOTO_INTEGRATIONS_APP_ICON_DARK_MODE_rebranded } from './rebranded/goto-integrations-app-icon-dark-mode.svg';
export const SVG_GOTO_INTEGRATIONS_APP_ICON = 'GOTO_INTEGRATIONS_APP_ICON';
import { default as GOTO_INTEGRATIONS_APP_ICON_deprecated } from './deprecated/goto-integrations-app-icon.svg';
import { default as GOTO_INTEGRATIONS_APP_ICON_rebranded } from './rebranded/goto-integrations-app-icon.svg';
export const SVG_GOTO_MARK = 'GOTO_MARK';
import { default as GOTO_MARK_deprecated } from './deprecated/goto-mark.svg';
import { default as GOTO_MARK_rebranded } from './rebranded/goto-mark.svg';
export const SVG_GOTO_WHITE_FAVICON = 'GOTO_WHITE_FAVICON';
import { default as GOTO_WHITE_FAVICON_deprecated } from './deprecated/goto-white-favicon.svg';
import { default as GOTO_WHITE_FAVICON_rebranded } from './rebranded/goto-white-favicon.svg';
export const SVG_GOTO_WHITE_YELLOW_FAVICON_DARK_MODE = 'GOTO_WHITE_YELLOW_FAVICON_DARK_MODE';
import { default as GOTO_WHITE_YELLOW_FAVICON_DARK_MODE_deprecated } from './deprecated/goto-white-yellow-favicon-dark-mode.svg';
import { default as GOTO_WHITE_YELLOW_FAVICON_DARK_MODE_rebranded } from './rebranded/goto-white-yellow-favicon-dark-mode.svg';
export const SVG_GOTO_WHITE_YELLOW = 'GOTO_WHITE_YELLOW';
import { default as GOTO_WHITE_YELLOW_deprecated } from './deprecated/goto-white-yellow.svg';
import { default as GOTO_WHITE_YELLOW_rebranded } from './rebranded/goto-white-yellow.svg';
export const SVG_GOTO_WHITE = 'GOTO_WHITE';
import { default as GOTO_WHITE_deprecated } from './deprecated/goto-white.svg';
import { default as GOTO_WHITE_rebranded } from './rebranded/goto-white.svg';
export const SVG_GRASSHOPPER_MARK = 'GRASSHOPPER_MARK';
import { default as GRASSHOPPER_MARK_deprecated } from './deprecated/grasshopper-mark.svg';
import { default as GRASSHOPPER_MARK_rebranded } from './rebranded/grasshopper-mark.svg';
export const SVG_GTC_CONTACT_CENTER_PICTO = 'GTC_CONTACT_CENTER_PICTO';
import { default as GTC_CONTACT_CENTER_PICTO_deprecated } from './deprecated/gtc-contact-center-picto.svg';
import { default as GTC_CONTACT_CENTER_PICTO_rebranded } from './rebranded/gtc-contact-center-picto.svg';
export const SVG_GTC_MEETING_PICTO = 'GTC_MEETING_PICTO';
import { default as GTC_MEETING_PICTO_deprecated } from './deprecated/gtc-meeting-picto.svg';
import { default as GTC_MEETING_PICTO_rebranded } from './rebranded/gtc-meeting-picto.svg';
export const SVG_GTC_MESSAGING_PICTO = 'GTC_MESSAGING_PICTO';
import { default as GTC_MESSAGING_PICTO_deprecated } from './deprecated/gtc-messaging-picto.svg';
import { default as GTC_MESSAGING_PICTO_rebranded } from './rebranded/gtc-messaging-picto.svg';
export const SVG_GTC_PHONE_MTG_BUNDLE_PICTO = 'GTC_PHONE_MTG_BUNDLE_PICTO';
import { default as GTC_PHONE_MTG_BUNDLE_PICTO_deprecated } from './deprecated/gtc-phone-mtg-bundle-picto.svg';
import { default as GTC_PHONE_MTG_BUNDLE_PICTO_rebranded } from './rebranded/gtc-phone-mtg-bundle-picto.svg';
export const SVG_GTC_ROOM_PICTO = 'GTC_ROOM_PICTO';
import { default as GTC_ROOM_PICTO_deprecated } from './deprecated/gtc-room-picto.svg';
import { default as GTC_ROOM_PICTO_rebranded } from './rebranded/gtc-room-picto.svg';
export const SVG_GTC_TRAINING_PICTO = 'GTC_TRAINING_PICTO';
import { default as GTC_TRAINING_PICTO_deprecated } from './deprecated/gtc-training-picto.svg';
import { default as GTC_TRAINING_PICTO_rebranded } from './rebranded/gtc-training-picto.svg';
export const SVG_GTC_VIRTUAL_EVENTS_PICTO = 'GTC_VIRTUAL_EVENTS_PICTO';
import { default as GTC_VIRTUAL_EVENTS_PICTO_deprecated } from './deprecated/gtc-virtual-events-picto.svg';
import { default as GTC_VIRTUAL_EVENTS_PICTO_rebranded } from './rebranded/gtc-virtual-events-picto.svg';
export const SVG_GTC_VOICE_PICTO = 'GTC_VOICE_PICTO';
import { default as GTC_VOICE_PICTO_deprecated } from './deprecated/gtc-voice-picto.svg';
import { default as GTC_VOICE_PICTO_rebranded } from './rebranded/gtc-voice-picto.svg';
export const SVG_GTC_WEBINAR_PICTO = 'GTC_WEBINAR_PICTO';
import { default as GTC_WEBINAR_PICTO_deprecated } from './deprecated/gtc-webinar-picto.svg';
import { default as GTC_WEBINAR_PICTO_rebranded } from './rebranded/gtc-webinar-picto.svg';
export const SVG_GTR_BLACK_HORIZONTAL = 'GTR_BLACK_HORIZONTAL';
import { default as GTR_BLACK_HORIZONTAL_deprecated } from './deprecated/gtr-black-horizontal.svg';
import { default as GTR_BLACK_HORIZONTAL_rebranded } from './rebranded/gtr-black-horizontal.svg';
export const SVG_GTR_BLACK_VERTICAL = 'GTR_BLACK_VERTICAL';
import { default as GTR_BLACK_VERTICAL_deprecated } from './deprecated/gtr-black-vertical.svg';
import { default as GTR_BLACK_VERTICAL_rebranded } from './rebranded/gtr-black-vertical.svg';
export const SVG_GTR_BLACK_YELLOW_PURPLE_HORIZONTAL = 'GTR_BLACK_YELLOW_PURPLE_HORIZONTAL';
import { default as GTR_BLACK_YELLOW_PURPLE_HORIZONTAL_deprecated } from './deprecated/gtr-black-yellow-purple-horizontal.svg';
import { default as GTR_BLACK_YELLOW_PURPLE_HORIZONTAL_rebranded } from './rebranded/gtr-black-yellow-purple-horizontal.svg';
export const SVG_GTR_BLACK_YELLOW_PURPLE_VERTICAL = 'GTR_BLACK_YELLOW_PURPLE_VERTICAL';
import { default as GTR_BLACK_YELLOW_PURPLE_VERTICAL_deprecated } from './deprecated/gtr-black-yellow-purple-vertical.svg';
import { default as GTR_BLACK_YELLOW_PURPLE_VERTICAL_rebranded } from './rebranded/gtr-black-yellow-purple-vertical.svg';
export const SVG_GTR_CONVERSATIONAL_TICKETING_PICTO = 'GTR_CONVERSATIONAL_TICKETING_PICTO';
import { default as GTR_CONVERSATIONAL_TICKETING_PICTO_deprecated } from './deprecated/gtr-conversational-ticketing-picto.svg';
import { default as GTR_CONVERSATIONAL_TICKETING_PICTO_rebranded } from './rebranded/gtr-conversational-ticketing-picto.svg';
export const SVG_GTR_DEFAULT_APP_ICON_DARK_MODE = 'GTR_DEFAULT_APP_ICON_DARK_MODE';
import { default as GTR_DEFAULT_APP_ICON_DARK_MODE_deprecated } from './deprecated/gtr-default-app-icon-dark-mode.svg';
import { default as GTR_DEFAULT_APP_ICON_DARK_MODE_rebranded } from './rebranded/gtr-default-app-icon-dark-mode.svg';
export const SVG_GTR_DEFAULT_APP_ICON = 'GTR_DEFAULT_APP_ICON';
import { default as GTR_DEFAULT_APP_ICON_deprecated } from './deprecated/gtr-default-app-icon.svg';
import { default as GTR_DEFAULT_APP_ICON_rebranded } from './rebranded/gtr-default-app-icon.svg';
export const SVG_GTR_DEVICE_MONITORING_PICTO = 'GTR_DEVICE_MONITORING_PICTO';
import { default as GTR_DEVICE_MONITORING_PICTO_deprecated } from './deprecated/gtr-device-monitoring-picto.svg';
import { default as GTR_DEVICE_MONITORING_PICTO_rebranded } from './rebranded/gtr-device-monitoring-picto.svg';
export const SVG_GTR_ENDPOINT_MANAGEMENT_PICTO = 'GTR_ENDPOINT_MANAGEMENT_PICTO';
import { default as GTR_ENDPOINT_MANAGEMENT_PICTO_deprecated } from './deprecated/gtr-endpoint-management-picto.svg';
import { default as GTR_ENDPOINT_MANAGEMENT_PICTO_rebranded } from './rebranded/gtr-endpoint-management-picto.svg';
export const SVG_GTR_ENDPOINT_SECURITY_PICTO = 'GTR_ENDPOINT_SECURITY_PICTO';
import { default as GTR_ENDPOINT_SECURITY_PICTO_deprecated } from './deprecated/gtr-endpoint-security-picto.svg';
import { default as GTR_ENDPOINT_SECURITY_PICTO_rebranded } from './rebranded/gtr-endpoint-security-picto.svg';
export const SVG_GTR_FAVICON_DARK_MODE = 'GTR_FAVICON_DARK_MODE';
import { default as GTR_FAVICON_DARK_MODE_deprecated } from './deprecated/gtr-favicon-dark-mode.svg';
import { default as GTR_FAVICON_DARK_MODE_rebranded } from './rebranded/gtr-favicon-dark-mode.svg';
export const SVG_GTR_FAVICON = 'GTR_FAVICON';
import { default as GTR_FAVICON_deprecated } from './deprecated/gtr-favicon.svg';
import { default as GTR_FAVICON_rebranded } from './rebranded/gtr-favicon.svg';
export const SVG_GTR_GREY_VERTICAL = 'GTR_GREY_VERTICAL';
import { default as GTR_GREY_VERTICAL_deprecated } from './deprecated/gtr-grey-vertical.svg';
import { default as GTR_GREY_VERTICAL_rebranded } from './rebranded/gtr-grey-vertical.svg';
export const SVG_GTR_GREY_HORIZONTAL = 'GTR_GREY_HORIZONTAL';
import { default as GTR_GREY_HORIZONTAL_deprecated } from './deprecated/gtr-grey-horizontal.svg';
import { default as GTR_GREY_HORIZONTAL_rebranded } from './rebranded/gtr-grey-horizontal.svg';
export const SVG_GTR_HELP_DESK_PICTO = 'GTR_HELP_DESK_PICTO';
import { default as GTR_HELP_DESK_PICTO_deprecated } from './deprecated/gtr-help-desk-picto.svg';
import { default as GTR_HELP_DESK_PICTO_rebranded } from './rebranded/gtr-help-desk-picto.svg';
export const SVG_GTR_MOBILE_DEVICE_SUPPORT_PICTO = 'GTR_MOBILE_DEVICE_SUPPORT_PICTO';
import { default as GTR_MOBILE_DEVICE_SUPPORT_PICTO_deprecated } from './deprecated/gtr-mobile-device-support-picto.svg';
import { default as GTR_MOBILE_DEVICE_SUPPORT_PICTO_rebranded } from './rebranded/gtr-mobile-device-support-picto.svg';
export const SVG_GTR_IT_AUTOMATION_PICTO = 'GTR_IT_AUTOMATION_PICTO';
import { default as GTR_IT_AUTOMATION_PICTO_deprecated } from './deprecated/gtr-it-automation-picto.svg';
import { default as GTR_IT_AUTOMATION_PICTO_rebranded } from './rebranded/gtr-it-automation-picto.svg';
export const SVG_GTR_PURPLE_APP_ICON_DARK_MODE = 'GTR_PURPLE_APP_ICON_DARK_MODE';
import { default as GTR_PURPLE_APP_ICON_DARK_MODE_deprecated } from './deprecated/gtr-purple-app-icon-dark-mode.svg';
import { default as GTR_PURPLE_APP_ICON_DARK_MODE_rebranded } from './rebranded/gtr-purple-app-icon-dark-mode.svg';
export const SVG_GTR_PURPLE_APP_ICON = 'GTR_PURPLE_APP_ICON';
import { default as GTR_PURPLE_APP_ICON_deprecated } from './deprecated/gtr-purple-app-icon.svg';
import { default as GTR_PURPLE_APP_ICON_rebranded } from './rebranded/gtr-purple-app-icon.svg';
export const SVG_GTR_REMOTE_ACCESS_PICTO = 'GTR_REMOTE_ACCESS_PICTO';
import { default as GTR_REMOTE_ACCESS_PICTO_deprecated } from './deprecated/gtr-remote-access-picto.svg';
import { default as GTR_REMOTE_ACCESS_PICTO_rebranded } from './rebranded/gtr-remote-access-picto.svg';
export const SVG_GTR_VISUAL_ENGAGEMENT_PICTO = 'GTR_VISUAL_ENGAGEMENT_PICTO';
import { default as GTR_VISUAL_ENGAGEMENT_PICTO_deprecated } from './deprecated/gtr-visual-engagement-picto.svg';
import { default as GTR_VISUAL_ENGAGEMENT_PICTO_rebranded } from './rebranded/gtr-visual-engagement-picto.svg';
export const SVG_GTR_REMOTE_SUPPORT_PICTO = 'GTR_REMOTE_SUPPORT_PICTO';
import { default as GTR_REMOTE_SUPPORT_PICTO_deprecated } from './deprecated/gtr-remote-support-picto.svg';
import { default as GTR_REMOTE_SUPPORT_PICTO_rebranded } from './rebranded/gtr-remote-support-picto.svg';
export const SVG_GTR_WHITE_HORIZONTAL = 'GTR_WHITE_HORIZONTAL';
import { default as GTR_WHITE_HORIZONTAL_deprecated } from './deprecated/gtr-white-horizontal.svg';
import { default as GTR_WHITE_HORIZONTAL_rebranded } from './rebranded/gtr-white-horizontal.svg';
export const SVG_GTR_WHITE_YELLOW_HORIZONTAL = 'GTR_WHITE_YELLOW_HORIZONTAL';
import { default as GTR_WHITE_YELLOW_HORIZONTAL_deprecated } from './deprecated/gtr-white-yellow-horizontal.svg';
import { default as GTR_WHITE_YELLOW_HORIZONTAL_rebranded } from './rebranded/gtr-white-yellow-horizontal.svg';
export const SVG_GTR_WHITE_VERTICAL = 'GTR_WHITE_VERTICAL';
import { default as GTR_WHITE_VERTICAL_deprecated } from './deprecated/gtr-white-vertical.svg';
import { default as GTR_WHITE_VERTICAL_rebranded } from './rebranded/gtr-white-vertical.svg';
export const SVG_GTR_WHITE_YELLOW_VERTICAL = 'GTR_WHITE_YELLOW_VERTICAL';
import { default as GTR_WHITE_YELLOW_VERTICAL_deprecated } from './deprecated/gtr-white-yellow-vertical.svg';
import { default as GTR_WHITE_YELLOW_VERTICAL_rebranded } from './rebranded/gtr-white-yellow-vertical.svg';
export const SVG_INSTAGRAM = 'INSTAGRAM';
import { default as INSTAGRAM_deprecated } from './deprecated/instagram.svg';
import { default as INSTAGRAM_rebranded } from './rebranded/instagram.svg';
export const SVG_LINKEDIN = 'LINKEDIN';
import { default as LINKEDIN_deprecated } from './deprecated/linkedin.svg';
import { default as LINKEDIN_rebranded } from './rebranded/linkedin.svg';
export const SVG_LP_BY_GO_TO_BLACK_HORIZONTAL = 'LP_BY_GO_TO_BLACK_HORIZONTAL';
import { default as LP_BY_GO_TO_BLACK_HORIZONTAL_deprecated } from './deprecated/lp-by-go-to-black-horizontal.svg';
import { default as LP_BY_GO_TO_BLACK_HORIZONTAL_rebranded } from './rebranded/lp-by-go-to-black-horizontal.svg';
export const SVG_LP_BY_GO_TO_BLACK_RED_HORIZONTAL = 'LP_BY_GO_TO_BLACK_RED_HORIZONTAL';
import { default as LP_BY_GO_TO_BLACK_RED_HORIZONTAL_deprecated } from './deprecated/lp-by-go-to-black-red-horizontal.svg';
import { default as LP_BY_GO_TO_BLACK_RED_HORIZONTAL_rebranded } from './rebranded/lp-by-go-to-black-red-horizontal.svg';
export const SVG_LP_BY_GO_TO_BLACK_RED_VERTICAL = 'LP_BY_GO_TO_BLACK_RED_VERTICAL';
import { default as LP_BY_GO_TO_BLACK_RED_VERTICAL_deprecated } from './deprecated/lp-by-go-to-black-red-vertical.svg';
import { default as LP_BY_GO_TO_BLACK_RED_VERTICAL_rebranded } from './rebranded/lp-by-go-to-black-red-vertical.svg';
export const SVG_LP_BY_GO_TO_BLACK_VERTICAL = 'LP_BY_GO_TO_BLACK_VERTICAL';
import { default as LP_BY_GO_TO_BLACK_VERTICAL_deprecated } from './deprecated/lp-by-go-to-black-vertical.svg';
import { default as LP_BY_GO_TO_BLACK_VERTICAL_rebranded } from './rebranded/lp-by-go-to-black-vertical.svg';
export const SVG_LP_BY_GO_TO_GREY_HORIZONTAL = 'LP_BY_GO_TO_GREY_HORIZONTAL';
import { default as LP_BY_GO_TO_GREY_HORIZONTAL_deprecated } from './deprecated/lp-by-go-to-grey-horizontal.svg';
import { default as LP_BY_GO_TO_GREY_HORIZONTAL_rebranded } from './rebranded/lp-by-go-to-grey-horizontal.svg';
export const SVG_LP_BY_GO_TO_GREY_VERTICAL = 'LP_BY_GO_TO_GREY_VERTICAL';
import { default as LP_BY_GO_TO_GREY_VERTICAL_deprecated } from './deprecated/lp-by-go-to-grey-vertical.svg';
import { default as LP_BY_GO_TO_GREY_VERTICAL_rebranded } from './rebranded/lp-by-go-to-grey-vertical.svg';
export const SVG_LP_BY_GO_TO_WHITE_HORIZONTAL = 'LP_BY_GO_TO_WHITE_HORIZONTAL';
import { default as LP_BY_GO_TO_WHITE_HORIZONTAL_deprecated } from './deprecated/lp-by-go-to-white-horizontal.svg';
import { default as LP_BY_GO_TO_WHITE_HORIZONTAL_rebranded } from './rebranded/lp-by-go-to-white-horizontal.svg';
export const SVG_LP_BY_GO_TO_WHITE_RED_HORIZONTAL = 'LP_BY_GO_TO_WHITE_RED_HORIZONTAL';
import { default as LP_BY_GO_TO_WHITE_RED_HORIZONTAL_deprecated } from './deprecated/lp-by-go-to-white-red-horizontal.svg';
import { default as LP_BY_GO_TO_WHITE_RED_HORIZONTAL_rebranded } from './rebranded/lp-by-go-to-white-red-horizontal.svg';
export const SVG_LP_BY_GO_TO_WHITE_RED_VERTICAL = 'LP_BY_GO_TO_WHITE_RED_VERTICAL';
import { default as LP_BY_GO_TO_WHITE_RED_VERTICAL_deprecated } from './deprecated/lp-by-go-to-white-red-vertical.svg';
import { default as LP_BY_GO_TO_WHITE_RED_VERTICAL_rebranded } from './rebranded/lp-by-go-to-white-red-vertical.svg';
export const SVG_LP_BY_GO_TO_WHITE_VERTICAL = 'LP_BY_GO_TO_WHITE_VERTICAL';
import { default as LP_BY_GO_TO_WHITE_VERTICAL_deprecated } from './deprecated/lp-by-go-to-white-vertical.svg';
import { default as LP_BY_GO_TO_WHITE_VERTICAL_rebranded } from './rebranded/lp-by-go-to-white-vertical.svg';
export const SVG_MICROSOFT_TEAMS = 'MICROSOFT_TEAMS';
import { default as MICROSOFT_TEAMS_deprecated } from './deprecated/microsoft-teams.svg';
import { default as MICROSOFT_TEAMS_rebranded } from './rebranded/microsoft-teams.svg';
export const SVG_MICROSOFT = 'MICROSOFT';
import { default as MICROSOFT_deprecated } from './deprecated/microsoft.svg';
import { default as MICROSOFT_rebranded } from './rebranded/microsoft.svg';
export const SVG_OFFICE_365 = 'OFFICE_365';
import { default as OFFICE_365_deprecated } from './deprecated/office-365.svg';
import { default as OFFICE_365_rebranded } from './rebranded/office-365.svg';
export const SVG_OUTLOOK = 'OUTLOOK';
import { default as OUTLOOK_deprecated } from './deprecated/outlook.svg';
import { default as OUTLOOK_rebranded } from './rebranded/outlook.svg';
export const SVG_SLACK = 'SLACK';
import { default as SLACK_deprecated } from './deprecated/slack.svg';
import { default as SLACK_rebranded } from './rebranded/slack.svg';
export const SVG_TWITTER = 'TWITTER';
import { default as TWITTER_deprecated } from './deprecated/twitter.svg';
import { default as TWITTER_rebranded } from './rebranded/twitter.svg';
export const SVG_YOUTUBE = 'YOUTUBE';
import { default as YOUTUBE_deprecated } from './deprecated/youtube.svg';
import { default as YOUTUBE_rebranded } from './rebranded/youtube.svg';
export const SVG_COMMUTER_MODE = 'COMMUTER_MODE';
import { default as COMMUTER_MODE_deprecated } from './deprecated/commuter-mode.svg';
import { default as COMMUTER_MODE_rebranded } from './rebranded/commuter-mode.svg';
export const SVG_CONFERENCE_PHONE = 'CONFERENCE_PHONE';
import { default as CONFERENCE_PHONE_deprecated } from './deprecated/conference-phone.svg';
import { default as CONFERENCE_PHONE_rebranded } from './rebranded/conference-phone.svg';
export const SVG_CONNECT_ACTIVE = 'CONNECT_ACTIVE';
import { default as CONNECT_ACTIVE_deprecated } from './deprecated/connect-active.svg';
import { default as CONNECT_ACTIVE_rebranded } from './rebranded/connect-active.svg';
export const SVG_CONNECTED_VIA_PHONE_ACTIVE = 'CONNECTED_VIA_PHONE_ACTIVE';
import { default as CONNECTED_VIA_PHONE_ACTIVE_deprecated } from './deprecated/connected-via-phone-active.svg';
import { default as CONNECTED_VIA_PHONE_ACTIVE_rebranded } from './rebranded/connected-via-phone-active.svg';
export const SVG_CONNECT_INACTIVE = 'CONNECT_INACTIVE';
import { default as CONNECT_INACTIVE_deprecated } from './deprecated/connect-inactive.svg';
import { default as CONNECT_INACTIVE_rebranded } from './rebranded/connect-inactive.svg';
export const SVG_CONNECTED_VIA_PHONE_INACTIVE = 'CONNECTED_VIA_PHONE_INACTIVE';
import { default as CONNECTED_VIA_PHONE_INACTIVE_deprecated } from './deprecated/connected-via-phone-inactive.svg';
import { default as CONNECTED_VIA_PHONE_INACTIVE_rebranded } from './rebranded/connected-via-phone-inactive.svg';
export const SVG_CONTINUE_20_PX = 'CONTINUE_20_PX';
import { default as CONTINUE_20_PX_deprecated } from './deprecated/continue-20-px.svg';
import { default as CONTINUE_20_PX_rebranded } from './rebranded/continue-20-px.svg';
export const SVG_CONTROLS_ACTIVE = 'CONTROLS_ACTIVE';
import { default as CONTROLS_ACTIVE_deprecated } from './deprecated/controls-active.svg';
import { default as CONTROLS_ACTIVE_rebranded } from './rebranded/controls-active.svg';
export const SVG_CONTROLS_INACTIVE = 'CONTROLS_INACTIVE';
import { default as CONTROLS_INACTIVE_deprecated } from './deprecated/controls-inactive.svg';
import { default as CONTROLS_INACTIVE_rebranded } from './rebranded/controls-inactive.svg';
export const SVG_CONVERSATION_ACTIVE = 'CONVERSATION_ACTIVE';
import { default as CONVERSATION_ACTIVE_deprecated } from './deprecated/conversation-active.svg';
import { default as CONVERSATION_ACTIVE_rebranded } from './rebranded/conversation-active.svg';
export const SVG_CONVERSATION_INACTIVE = 'CONVERSATION_INACTIVE';
import { default as CONVERSATION_INACTIVE_deprecated } from './deprecated/conversation-inactive.svg';
import { default as CONVERSATION_INACTIVE_rebranded } from './rebranded/conversation-inactive.svg';
export const SVG_COPY_ACTIVE = 'COPY_ACTIVE';
import { default as COPY_ACTIVE_deprecated } from './deprecated/copy-active.svg';
import { default as COPY_ACTIVE_rebranded } from './rebranded/copy-active.svg';
export const SVG_COPY_INACTIVE = 'COPY_INACTIVE';
import { default as COPY_INACTIVE_deprecated } from './deprecated/copy-inactive.svg';
import { default as COPY_INACTIVE_rebranded } from './rebranded/copy-inactive.svg';
export const SVG_CPU = 'CPU';
import { default as CPU_deprecated } from './deprecated/cpu.svg';
import { default as CPU_rebranded } from './rebranded/cpu.svg';
export const SVG_CREATE_CONVERSATION_ACTIVE = 'CREATE_CONVERSATION_ACTIVE';
import { default as CREATE_CONVERSATION_ACTIVE_deprecated } from './deprecated/create-conversation-active.svg';
import { default as CREATE_CONVERSATION_ACTIVE_rebranded } from './rebranded/create-conversation-active.svg';
export const SVG_CREATE_CONVERSATION_INACTIVE = 'CREATE_CONVERSATION_INACTIVE';
import { default as CREATE_CONVERSATION_INACTIVE_deprecated } from './deprecated/create-conversation-inactive.svg';
import { default as CREATE_CONVERSATION_INACTIVE_rebranded } from './rebranded/create-conversation-inactive.svg';
export const SVG_CREATE_GROUP_ACTIVE = 'CREATE_GROUP_ACTIVE';
import { default as CREATE_GROUP_ACTIVE_deprecated } from './deprecated/create-group-active.svg';
import { default as CREATE_GROUP_ACTIVE_rebranded } from './rebranded/create-group-active.svg';
export const SVG_CREATE_GROUP_INACTIVE = 'CREATE_GROUP_INACTIVE';
import { default as CREATE_GROUP_INACTIVE_deprecated } from './deprecated/create-group-inactive.svg';
import { default as CREATE_GROUP_INACTIVE_rebranded } from './rebranded/create-group-inactive.svg';
export const SVG_CROWD_INACTIVE = 'CROWD_INACTIVE';
import { default as CROWD_INACTIVE_deprecated } from './deprecated/crowd-inactive.svg';
import { default as CROWD_INACTIVE_rebranded } from './rebranded/crowd-inactive.svg';
export const SVG_CTRL_ALT_DEL_ACTIVE = 'CTRL_ALT_DEL_ACTIVE';
import { default as CTRL_ALT_DEL_ACTIVE_deprecated } from './deprecated/ctrl-alt-del-active.svg';
import { default as CTRL_ALT_DEL_ACTIVE_rebranded } from './rebranded/ctrl-alt-del-active.svg';
export const SVG_CROWD_ACTIVE = 'CROWD_ACTIVE';
import { default as CROWD_ACTIVE_deprecated } from './deprecated/crowd-active.svg';
import { default as CROWD_ACTIVE_rebranded } from './rebranded/crowd-active.svg';
export const SVG_CVS_ACTIVE = 'CVS_ACTIVE';
import { default as CVS_ACTIVE_deprecated } from './deprecated/cvs-active.svg';
import { default as CVS_ACTIVE_rebranded } from './rebranded/cvs-active.svg';
export const SVG_CTRL_ALT_DEL_INACTIVE = 'CTRL_ALT_DEL_INACTIVE';
import { default as CTRL_ALT_DEL_INACTIVE_deprecated } from './deprecated/ctrl-alt-del-inactive.svg';
import { default as CTRL_ALT_DEL_INACTIVE_rebranded } from './rebranded/ctrl-alt-del-inactive.svg';
export const SVG_DARK_MODE = 'DARK_MODE';
import { default as DARK_MODE_deprecated } from './deprecated/dark-mode.svg';
import { default as DARK_MODE_rebranded } from './rebranded/dark-mode.svg';
export const SVG_CVS_INACTIVE = 'CVS_INACTIVE';
import { default as CVS_INACTIVE_deprecated } from './deprecated/cvs-inactive.svg';
import { default as CVS_INACTIVE_rebranded } from './rebranded/cvs-inactive.svg';
export const SVG_DASHBOARD_ACTIVE = 'DASHBOARD_ACTIVE';
import { default as DASHBOARD_ACTIVE_deprecated } from './deprecated/dashboard-active.svg';
import { default as DASHBOARD_ACTIVE_rebranded } from './rebranded/dashboard-active.svg';
export const SVG_DATA_MASKING_ACTIVE = 'DATA_MASKING_ACTIVE';
import { default as DATA_MASKING_ACTIVE_deprecated } from './deprecated/data-masking-active.svg';
import { default as DATA_MASKING_ACTIVE_rebranded } from './rebranded/data-masking-active.svg';
export const SVG_DASHBOARD_INACTIVE = 'DASHBOARD_INACTIVE';
import { default as DASHBOARD_INACTIVE_deprecated } from './deprecated/dashboard-inactive.svg';
import { default as DASHBOARD_INACTIVE_rebranded } from './rebranded/dashboard-inactive.svg';
export const SVG_DATA_MASKING_INACTIVE = 'DATA_MASKING_INACTIVE';
import { default as DATA_MASKING_INACTIVE_deprecated } from './deprecated/data-masking-inactive.svg';
import { default as DATA_MASKING_INACTIVE_rebranded } from './rebranded/data-masking-inactive.svg';
export const SVG_DATA = 'DATA';
import { default as DATA_deprecated } from './deprecated/data.svg';
import { default as DATA_rebranded } from './rebranded/data.svg';
export const SVG_DELETE_CONVERSATION_ACTIVE = 'DELETE_CONVERSATION_ACTIVE';
import { default as DELETE_CONVERSATION_ACTIVE_deprecated } from './deprecated/delete-conversation-active.svg';
import { default as DELETE_CONVERSATION_ACTIVE_rebranded } from './rebranded/delete-conversation-active.svg';
export const SVG_DESKTOP = 'DESKTOP';
import { default as DESKTOP_deprecated } from './deprecated/desktop.svg';
import { default as DESKTOP_rebranded } from './rebranded/desktop.svg';
export const SVG_DELETE_CONVERSATION_INACTIVE = 'DELETE_CONVERSATION_INACTIVE';
import { default as DELETE_CONVERSATION_INACTIVE_deprecated } from './deprecated/delete-conversation-inactive.svg';
import { default as DELETE_CONVERSATION_INACTIVE_rebranded } from './rebranded/delete-conversation-inactive.svg';
export const SVG_DEVICES_ACTIVE = 'DEVICES_ACTIVE';
import { default as DEVICES_ACTIVE_deprecated } from './deprecated/devices-active.svg';
import { default as DEVICES_ACTIVE_rebranded } from './rebranded/devices-active.svg';
export const SVG_DEVICES_INACTIVE = 'DEVICES_INACTIVE';
import { default as DEVICES_INACTIVE_deprecated } from './deprecated/devices-inactive.svg';
import { default as DEVICES_INACTIVE_rebranded } from './rebranded/devices-inactive.svg';
export const SVG_DIAL_IN_ACTIVE = 'DIAL_IN_ACTIVE';
import { default as DIAL_IN_ACTIVE_deprecated } from './deprecated/dial-in-active.svg';
import { default as DIAL_IN_ACTIVE_rebranded } from './rebranded/dial-in-active.svg';
export const SVG_DIAL_IN_INACTIVE = 'DIAL_IN_INACTIVE';
import { default as DIAL_IN_INACTIVE_deprecated } from './deprecated/dial-in-inactive.svg';
import { default as DIAL_IN_INACTIVE_rebranded } from './rebranded/dial-in-inactive.svg';
export const SVG_DIAL_OUT_ACTIVE = 'DIAL_OUT_ACTIVE';
import { default as DIAL_OUT_ACTIVE_deprecated } from './deprecated/dial-out-active.svg';
import { default as DIAL_OUT_ACTIVE_rebranded } from './rebranded/dial-out-active.svg';
export const SVG_DIAL_OUT_INACTIVE = 'DIAL_OUT_INACTIVE';
import { default as DIAL_OUT_INACTIVE_deprecated } from './deprecated/dial-out-inactive.svg';
import { default as DIAL_OUT_INACTIVE_rebranded } from './rebranded/dial-out-inactive.svg';
export const SVG_DIAL_PAD = 'DIAL_PAD';
import { default as DIAL_PAD_deprecated } from './deprecated/dial-pad.svg';
import { default as DIAL_PAD_rebranded } from './rebranded/dial-pad.svg';
export const SVG_DISCOVER = 'DISCOVER';
import { default as DISCOVER_deprecated } from './deprecated/discover.svg';
import { default as DISCOVER_rebranded } from './rebranded/discover.svg';
export const SVG_DOCUMENT_ACTIVE = 'DOCUMENT_ACTIVE';
import { default as DOCUMENT_ACTIVE_deprecated } from './deprecated/document-active.svg';
import { default as DOCUMENT_ACTIVE_rebranded } from './rebranded/document-active.svg';
export const SVG_DOCUMENT_INACTIVE = 'DOCUMENT_INACTIVE';
import { default as DOCUMENT_INACTIVE_deprecated } from './deprecated/document-inactive.svg';
import { default as DOCUMENT_INACTIVE_rebranded } from './rebranded/document-inactive.svg';
export const SVG_DOLLAR = 'DOLLAR';
import { default as DOLLAR_deprecated } from './deprecated/dollar.svg';
import { default as DOLLAR_rebranded } from './rebranded/dollar.svg';
export const SVG_DOWNLOAD = 'DOWNLOAD';
import { default as DOWNLOAD_deprecated } from './deprecated/download.svg';
import { default as DOWNLOAD_rebranded } from './rebranded/download.svg';
export const SVG_DOLBY = 'DOLBY';
import { default as DOLBY_deprecated } from './deprecated/dolby.svg';
import { default as DOLBY_rebranded } from './rebranded/dolby.svg';
export const SVG_DRAG_CURSOR = 'DRAG_CURSOR';
import { default as DRAG_CURSOR_deprecated } from './deprecated/drag-cursor.svg';
import { default as DRAG_CURSOR_rebranded } from './rebranded/drag-cursor.svg';
export const SVG_DRAG_DROP = 'DRAG_DROP';
import { default as DRAG_DROP_deprecated } from './deprecated/drag-drop.svg';
import { default as DRAG_DROP_rebranded } from './rebranded/drag-drop.svg';
export const SVG_DRAG_FREE = 'DRAG_FREE';
import { default as DRAG_FREE_deprecated } from './deprecated/drag-free.svg';
import { default as DRAG_FREE_rebranded } from './rebranded/drag-free.svg';
export const SVG_DRAG_LINEAR = 'DRAG_LINEAR';
import { default as DRAG_LINEAR_deprecated } from './deprecated/drag-linear.svg';
import { default as DRAG_LINEAR_rebranded } from './rebranded/drag-linear.svg';
export const SVG_DRAWER_LEFT_INACTIVE = 'DRAWER_LEFT_INACTIVE';
import { default as DRAWER_LEFT_INACTIVE_deprecated } from './deprecated/drawer-left-inactive.svg';
import { default as DRAWER_LEFT_INACTIVE_rebranded } from './rebranded/drawer-left-inactive.svg';
export const SVG_DRAWER_LEFT_ACTIVE = 'DRAWER_LEFT_ACTIVE';
import { default as DRAWER_LEFT_ACTIVE_deprecated } from './deprecated/drawer-left-active.svg';
import { default as DRAWER_LEFT_ACTIVE_rebranded } from './rebranded/drawer-left-active.svg';
export const SVG_DRAWER_RIGHT_ACTIVE = 'DRAWER_RIGHT_ACTIVE';
import { default as DRAWER_RIGHT_ACTIVE_deprecated } from './deprecated/drawer-right-active.svg';
import { default as DRAWER_RIGHT_ACTIVE_rebranded } from './rebranded/drawer-right-active.svg';
export const SVG_DRAWER_RIGHT_INACTIVE = 'DRAWER_RIGHT_INACTIVE';
import { default as DRAWER_RIGHT_INACTIVE_deprecated } from './deprecated/drawer-right-inactive.svg';
import { default as DRAWER_RIGHT_INACTIVE_rebranded } from './rebranded/drawer-right-inactive.svg';
export const SVG_DRIVE_ACTIVE = 'DRIVE_ACTIVE';
import { default as DRIVE_ACTIVE_deprecated } from './deprecated/drive-active.svg';
import { default as DRIVE_ACTIVE_rebranded } from './rebranded/drive-active.svg';
export const SVG_DRIVE_INACTIVE = 'DRIVE_INACTIVE';
import { default as DRIVE_INACTIVE_deprecated } from './deprecated/drive-inactive.svg';
import { default as DRIVE_INACTIVE_rebranded } from './rebranded/drive-inactive.svg';
export const SVG_DUAL_DISPLAY_ACTIVE = 'DUAL_DISPLAY_ACTIVE';
import { default as DUAL_DISPLAY_ACTIVE_deprecated } from './deprecated/dual-display-active.svg';
import { default as DUAL_DISPLAY_ACTIVE_rebranded } from './rebranded/dual-display-active.svg';
export const SVG_DUAL_DISPLAY = 'DUAL_DISPLAY';
import { default as DUAL_DISPLAY_deprecated } from './deprecated/dual-display.svg';
import { default as DUAL_DISPLAY_rebranded } from './rebranded/dual-display.svg';
export const SVG_EDGE = 'EDGE';
import { default as EDGE_deprecated } from './deprecated/edge.svg';
import { default as EDGE_rebranded } from './rebranded/edge.svg';
export const SVG_ECHO = 'ECHO';
import { default as ECHO_deprecated } from './deprecated/echo.svg';
import { default as ECHO_rebranded } from './rebranded/echo.svg';
export const SVG_EDIT_INACTIVE = 'EDIT_INACTIVE';
import { default as EDIT_INACTIVE_deprecated } from './deprecated/edit-inactive.svg';
import { default as EDIT_INACTIVE_rebranded } from './rebranded/edit-inactive.svg';
export const SVG_EDIT = 'EDIT';
import { default as EDIT_deprecated } from './deprecated/edit.svg';
import { default as EDIT_rebranded } from './rebranded/edit.svg';
export const SVG_EDUCATION_ACTIVE = 'EDUCATION_ACTIVE';
import { default as EDUCATION_ACTIVE_deprecated } from './deprecated/education-active.svg';
import { default as EDUCATION_ACTIVE_rebranded } from './rebranded/education-active.svg';
export const SVG_EDUCATION_INACTIVE = 'EDUCATION_INACTIVE';
import { default as EDUCATION_INACTIVE_deprecated } from './deprecated/education-inactive.svg';
import { default as EDUCATION_INACTIVE_rebranded } from './rebranded/education-inactive.svg';
export const SVG_EMAIL_ACTIVE = 'EMAIL_ACTIVE';
import { default as EMAIL_ACTIVE_deprecated } from './deprecated/email-active.svg';
import { default as EMAIL_ACTIVE_rebranded } from './rebranded/email-active.svg';
export const SVG_EMAIL_INACTIVE = 'EMAIL_INACTIVE';
import { default as EMAIL_INACTIVE_deprecated } from './deprecated/email-inactive.svg';
import { default as EMAIL_INACTIVE_rebranded } from './rebranded/email-inactive.svg';
export const SVG_EMOJI_SAD = 'EMOJI_SAD';
import { default as EMOJI_SAD_deprecated } from './deprecated/emoji-sad.svg';
import { default as EMOJI_SAD_rebranded } from './rebranded/emoji-sad.svg';
export const SVG_EMOJI = 'EMOJI';
import { default as EMOJI_deprecated } from './deprecated/emoji.svg';
import { default as EMOJI_rebranded } from './rebranded/emoji.svg';
export const SVG_ENLARGE_MEETING = 'ENLARGE_MEETING';
import { default as ENLARGE_MEETING_deprecated } from './deprecated/enlarge-meeting.svg';
import { default as ENLARGE_MEETING_rebranded } from './rebranded/enlarge-meeting.svg';
export const SVG_ENTER_ACTIVE = 'ENTER_ACTIVE';
import { default as ENTER_ACTIVE_deprecated } from './deprecated/enter-active.svg';
import { default as ENTER_ACTIVE_rebranded } from './rebranded/enter-active.svg';
export const SVG_ENTER_INACTIVE = 'ENTER_INACTIVE';
import { default as ENTER_INACTIVE_deprecated } from './deprecated/enter-inactive.svg';
import { default as ENTER_INACTIVE_rebranded } from './rebranded/enter-inactive.svg';
export const SVG_EVENT_ACTIVE = 'EVENT_ACTIVE';
import { default as EVENT_ACTIVE_deprecated } from './deprecated/event-active.svg';
import { default as EVENT_ACTIVE_rebranded } from './rebranded/event-active.svg';
export const SVG_EURO = 'EURO';
import { default as EURO_deprecated } from './deprecated/euro.svg';
import { default as EURO_rebranded } from './rebranded/euro.svg';
export const SVG_EVENT_INACTIVE = 'EVENT_INACTIVE';
import { default as EVENT_INACTIVE_deprecated } from './deprecated/event-inactive.svg';
import { default as EVENT_INACTIVE_rebranded } from './rebranded/event-inactive.svg';
export const SVG_EVENT_PHONE_ACTIVE = 'EVENT_PHONE_ACTIVE';
import { default as EVENT_PHONE_ACTIVE_deprecated } from './deprecated/event-phone-active.svg';
import { default as EVENT_PHONE_ACTIVE_rebranded } from './rebranded/event-phone-active.svg';
export const SVG_EVENT_PHONE_INACTIVE = 'EVENT_PHONE_INACTIVE';
import { default as EVENT_PHONE_INACTIVE_deprecated } from './deprecated/event-phone-inactive.svg';
import { default as EVENT_PHONE_INACTIVE_rebranded } from './rebranded/event-phone-inactive.svg';
export const SVG_EXECUTABLE_ACTIVE = 'EXECUTABLE_ACTIVE';
import { default as EXECUTABLE_ACTIVE_deprecated } from './deprecated/executable-active.svg';
import { default as EXECUTABLE_ACTIVE_rebranded } from './rebranded/executable-active.svg';
export const SVG_EXECUTABLE_INACTIVE = 'EXECUTABLE_INACTIVE';
import { default as EXECUTABLE_INACTIVE_deprecated } from './deprecated/executable-inactive.svg';
import { default as EXECUTABLE_INACTIVE_rebranded } from './rebranded/executable-inactive.svg';
export const SVG_EXTERNAL_LINK = 'EXTERNAL_LINK';
import { default as EXTERNAL_LINK_deprecated } from './deprecated/external-link.svg';
import { default as EXTERNAL_LINK_rebranded } from './rebranded/external-link.svg';
export const SVG_FADE_OUT = 'FADE_OUT';
import { default as FADE_OUT_deprecated } from './deprecated/fade-out.svg';
import { default as FADE_OUT_rebranded } from './rebranded/fade-out.svg';
export const SVG_FAX = 'FAX';
import { default as FAX_deprecated } from './deprecated/fax.svg';
import { default as FAX_rebranded } from './rebranded/fax.svg';
export const SVG_FILE_ACTIVE = 'FILE_ACTIVE';
import { default as FILE_ACTIVE_deprecated } from './deprecated/file-active.svg';
import { default as FILE_ACTIVE_rebranded } from './rebranded/file-active.svg';
export const SVG_FILE_BROWSER_ACTIVE = 'FILE_BROWSER_ACTIVE';
import { default as FILE_BROWSER_ACTIVE_deprecated } from './deprecated/file-browser-active.svg';
import { default as FILE_BROWSER_ACTIVE_rebranded } from './rebranded/file-browser-active.svg';
export const SVG_FILE_BROWSER_INACTIVE = 'FILE_BROWSER_INACTIVE';
import { default as FILE_BROWSER_INACTIVE_deprecated } from './deprecated/file-browser-inactive.svg';
import { default as FILE_BROWSER_INACTIVE_rebranded } from './rebranded/file-browser-inactive.svg';
export const SVG_FILE_CODE_ACTIVE = 'FILE_CODE_ACTIVE';
import { default as FILE_CODE_ACTIVE_deprecated } from './deprecated/file-code-active.svg';
import { default as FILE_CODE_ACTIVE_rebranded } from './rebranded/file-code-active.svg';
export const SVG_FILE_CODE_INACTIVE = 'FILE_CODE_INACTIVE';
import { default as FILE_CODE_INACTIVE_deprecated } from './deprecated/file-code-inactive.svg';
import { default as FILE_CODE_INACTIVE_rebranded } from './rebranded/file-code-inactive.svg';
export const SVG_FILE_INACTIVE = 'FILE_INACTIVE';
import { default as FILE_INACTIVE_deprecated } from './deprecated/file-inactive.svg';
import { default as FILE_INACTIVE_rebranded } from './rebranded/file-inactive.svg';
export const SVG_FILE_PDF_ACTIVE = 'FILE_PDF_ACTIVE';
import { default as FILE_PDF_ACTIVE_deprecated } from './deprecated/file-pdf-active.svg';
import { default as FILE_PDF_ACTIVE_rebranded } from './rebranded/file-pdf-active.svg';
export const SVG_FILE_PDF_INACTIVE = 'FILE_PDF_INACTIVE';
import { default as FILE_PDF_INACTIVE_deprecated } from './deprecated/file-pdf-inactive.svg';
import { default as FILE_PDF_INACTIVE_rebranded } from './rebranded/file-pdf-inactive.svg';
export const SVG_FILE_PRESENTATION_ACTIVE = 'FILE_PRESENTATION_ACTIVE';
import { default as FILE_PRESENTATION_ACTIVE_deprecated } from './deprecated/file-presentation-active.svg';
import { default as FILE_PRESENTATION_ACTIVE_rebranded } from './rebranded/file-presentation-active.svg';
export const SVG_FILE_PRESENTATION_INACTIVE = 'FILE_PRESENTATION_INACTIVE';
import { default as FILE_PRESENTATION_INACTIVE_deprecated } from './deprecated/file-presentation-inactive.svg';
import { default as FILE_PRESENTATION_INACTIVE_rebranded } from './rebranded/file-presentation-inactive.svg';
export const SVG_FILE_SOUND_ACTIVE = 'FILE_SOUND_ACTIVE';
import { default as FILE_SOUND_ACTIVE_deprecated } from './deprecated/file-sound-active.svg';
import { default as FILE_SOUND_ACTIVE_rebranded } from './rebranded/file-sound-active.svg';
export const SVG_FILE_SOUND_INACTIVE = 'FILE_SOUND_INACTIVE';
import { default as FILE_SOUND_INACTIVE_deprecated } from './deprecated/file-sound-inactive.svg';
import { default as FILE_SOUND_INACTIVE_rebranded } from './rebranded/file-sound-inactive.svg';
export const SVG_FILE_SPREADSHEET_ACTIVE = 'FILE_SPREADSHEET_ACTIVE';
import { default as FILE_SPREADSHEET_ACTIVE_deprecated } from './deprecated/file-spreadsheet-active.svg';
import { default as FILE_SPREADSHEET_ACTIVE_rebranded } from './rebranded/file-spreadsheet-active.svg';
export const SVG_FILE_SPREADSHEET_INACTIVE = 'FILE_SPREADSHEET_INACTIVE';
import { default as FILE_SPREADSHEET_INACTIVE_deprecated } from './deprecated/file-spreadsheet-inactive.svg';
import { default as FILE_SPREADSHEET_INACTIVE_rebranded } from './rebranded/file-spreadsheet-inactive.svg';
export const SVG_FILE_TRANSFER_ACTIVE = 'FILE_TRANSFER_ACTIVE';
import { default as FILE_TRANSFER_ACTIVE_deprecated } from './deprecated/file-transfer-active.svg';
import { default as FILE_TRANSFER_ACTIVE_rebranded } from './rebranded/file-transfer-active.svg';
export const SVG_FILE_TRANSFER_INACTIVE = 'FILE_TRANSFER_INACTIVE';
import { default as FILE_TRANSFER_INACTIVE_deprecated } from './deprecated/file-transfer-inactive.svg';
import { default as FILE_TRANSFER_INACTIVE_rebranded } from './rebranded/file-transfer-inactive.svg';
export const SVG_FILE_VIDEO_ACTIVE = 'FILE_VIDEO_ACTIVE';
import { default as FILE_VIDEO_ACTIVE_deprecated } from './deprecated/file-video-active.svg';
import { default as FILE_VIDEO_ACTIVE_rebranded } from './rebranded/file-video-active.svg';
export const SVG_FILE_VIDEO_INACTIVE = 'FILE_VIDEO_INACTIVE';
import { default as FILE_VIDEO_INACTIVE_deprecated } from './deprecated/file-video-inactive.svg';
import { default as FILE_VIDEO_INACTIVE_rebranded } from './rebranded/file-video-inactive.svg';
export const SVG_FILTER_ACTIVE = 'FILTER_ACTIVE';
import { default as FILTER_ACTIVE_deprecated } from './deprecated/filter-active.svg';
import { default as FILTER_ACTIVE_rebranded } from './rebranded/filter-active.svg';
export const SVG_FILTER_INACTIVE = 'FILTER_INACTIVE';
import { default as FILTER_INACTIVE_deprecated } from './deprecated/filter-inactive.svg';
import { default as FILTER_INACTIVE_rebranded } from './rebranded/filter-inactive.svg';
export const SVG_FIREFOX = 'FIREFOX';
import { default as FIREFOX_deprecated } from './deprecated/firefox.svg';
import { default as FIREFOX_rebranded } from './rebranded/firefox.svg';
export const SVG_FIT_HEIGHT = 'FIT_HEIGHT';
import { default as FIT_HEIGHT_deprecated } from './deprecated/fit-height.svg';
import { default as FIT_HEIGHT_rebranded } from './rebranded/fit-height.svg';
export const SVG_FIT_WIDTH = 'FIT_WIDTH';
import { default as FIT_WIDTH_deprecated } from './deprecated/fit-width.svg';
import { default as FIT_WIDTH_rebranded } from './rebranded/fit-width.svg';
export const SVG_FITNESS = 'FITNESS';
import { default as FITNESS_deprecated } from './deprecated/fitness.svg';
import { default as FITNESS_rebranded } from './rebranded/fitness.svg';
export const SVG_FLASLIGHT_OFF_ACTIVE = 'FLASLIGHT_OFF_ACTIVE';
import { default as FLASLIGHT_OFF_ACTIVE_deprecated } from './deprecated/flaslight-off-active.svg';
import { default as FLASLIGHT_OFF_ACTIVE_rebranded } from './rebranded/flaslight-off-active.svg';
export const SVG_FLASLIGHT_OFF_INACTIVE = 'FLASLIGHT_OFF_INACTIVE';
import { default as FLASLIGHT_OFF_INACTIVE_deprecated } from './deprecated/flaslight-off-inactive.svg';
import { default as FLASLIGHT_OFF_INACTIVE_rebranded } from './rebranded/flaslight-off-inactive.svg';
export const SVG_FLASLIGHT_ON_ACTIVE = 'FLASLIGHT_ON_ACTIVE';
import { default as FLASLIGHT_ON_ACTIVE_deprecated } from './deprecated/flaslight-on-active.svg';
import { default as FLASLIGHT_ON_ACTIVE_rebranded } from './rebranded/flaslight-on-active.svg';
export const SVG_FLASLIGHT_ON_INACTIVE = 'FLASLIGHT_ON_INACTIVE';
import { default as FLASLIGHT_ON_INACTIVE_deprecated } from './deprecated/flaslight-on-inactive.svg';
import { default as FLASLIGHT_ON_INACTIVE_rebranded } from './rebranded/flaslight-on-inactive.svg';
export const SVG_FLOWCHART = 'FLOWCHART';
import { default as FLOWCHART_deprecated } from './deprecated/flowchart.svg';
import { default as FLOWCHART_rebranded } from './rebranded/flowchart.svg';
export const SVG_FOLDER_ACTIVE = 'FOLDER_ACTIVE';
import { default as FOLDER_ACTIVE_deprecated } from './deprecated/folder-active.svg';
import { default as FOLDER_ACTIVE_rebranded } from './rebranded/folder-active.svg';
export const SVG_FOLDER_ARCHIVE_ACTIVE = 'FOLDER_ARCHIVE_ACTIVE';
import { default as FOLDER_ARCHIVE_ACTIVE_deprecated } from './deprecated/folder-archive-active.svg';
import { default as FOLDER_ARCHIVE_ACTIVE_rebranded } from './rebranded/folder-archive-active.svg';
export const SVG_FOLDER_ARCHIVE_INACTIVE = 'FOLDER_ARCHIVE_INACTIVE';
import { default as FOLDER_ARCHIVE_INACTIVE_deprecated } from './deprecated/folder-archive-inactive.svg';
import { default as FOLDER_ARCHIVE_INACTIVE_rebranded } from './rebranded/folder-archive-inactive.svg';
export const SVG_FOLDER_INACTIVE = 'FOLDER_INACTIVE';
import { default as FOLDER_INACTIVE_deprecated } from './deprecated/folder-inactive.svg';
import { default as FOLDER_INACTIVE_rebranded } from './rebranded/folder-inactive.svg';
export const SVG_FOLDER_UP = 'FOLDER_UP';
import { default as FOLDER_UP_deprecated } from './deprecated/folder-up.svg';
import { default as FOLDER_UP_rebranded } from './rebranded/folder-up.svg';
export const SVG_FONT = 'FONT';
import { default as FONT_deprecated } from './deprecated/font.svg';
import { default as FONT_rebranded } from './rebranded/font.svg';
export const SVG_GEO_PIN_ACTIVE = 'GEO_PIN_ACTIVE';
import { default as GEO_PIN_ACTIVE_deprecated } from './deprecated/geo-pin-active.svg';
import { default as GEO_PIN_ACTIVE_rebranded } from './rebranded/geo-pin-active.svg';
export const SVG_GEO_PIN_INACTIVE = 'GEO_PIN_INACTIVE';
import { default as GEO_PIN_INACTIVE_deprecated } from './deprecated/geo-pin-inactive.svg';
import { default as GEO_PIN_INACTIVE_rebranded } from './rebranded/geo-pin-inactive.svg';
export const SVG_GIFT = 'GIFT';
import { default as GIFT_deprecated } from './deprecated/gift.svg';
import { default as GIFT_rebranded } from './rebranded/gift.svg';
export const SVG_GLOBE = 'GLOBE';
import { default as GLOBE_deprecated } from './deprecated/globe.svg';
import { default as GLOBE_rebranded } from './rebranded/globe.svg';
export const SVG_GOOGLE_CHROME = 'GOOGLE_CHROME';
import { default as GOOGLE_CHROME_deprecated } from './deprecated/google-chrome.svg';
import { default as GOOGLE_CHROME_rebranded } from './rebranded/google-chrome.svg';
export const SVG_GOOGLE_MONOCHROMATIC = 'GOOGLE_MONOCHROMATIC';
import { default as GOOGLE_MONOCHROMATIC_deprecated } from './deprecated/google-monochromatic.svg';
import { default as GOOGLE_MONOCHROMATIC_rebranded } from './rebranded/google-monochromatic.svg';
export const SVG_GOTO_ASSIST = 'GOTO_ASSIST';
import { default as GOTO_ASSIST_deprecated } from './deprecated/goto-assist.svg';
import { default as GOTO_ASSIST_rebranded } from './rebranded/goto-assist.svg';
export const SVG_GOTO = 'GOTO';
import { default as GOTO_deprecated } from './deprecated/goto.svg';
import { default as GOTO_rebranded } from './rebranded/goto.svg';
export const SVG_GRIP_20_PX = 'GRIP_20_PX';
import { default as GRIP_20_PX_deprecated } from './deprecated/grip-20-px.svg';
import { default as GRIP_20_PX_rebranded } from './rebranded/grip-20-px.svg';
export const SVG_HAMBURGER_MENU = 'HAMBURGER_MENU';
import { default as HAMBURGER_MENU_deprecated } from './deprecated/hamburger-menu.svg';
import { default as HAMBURGER_MENU_rebranded } from './rebranded/hamburger-menu.svg';
export const SVG_HAND_RAISE = 'HAND_RAISE';
import { default as HAND_RAISE_deprecated } from './deprecated/hand-raise.svg';
import { default as HAND_RAISE_rebranded } from './rebranded/hand-raise.svg';
export const SVG_HAND_LOWER = 'HAND_LOWER';
import { default as HAND_LOWER_deprecated } from './deprecated/hand-lower.svg';
import { default as HAND_LOWER_rebranded } from './rebranded/hand-lower.svg';
export const SVG_HARDPHONE = 'HARDPHONE';
import { default as HARDPHONE_deprecated } from './deprecated/hardphone.svg';
import { default as HARDPHONE_rebranded } from './rebranded/hardphone.svg';
export const SVG_HDMI = 'HDMI';
import { default as HDMI_deprecated } from './deprecated/hdmi.svg';
import { default as HDMI_rebranded } from './rebranded/hdmi.svg';
export const SVG_HEADPHONES = 'HEADPHONES';
import { default as HEADPHONES_deprecated } from './deprecated/headphones.svg';
import { default as HEADPHONES_rebranded } from './rebranded/headphones.svg';
export const SVG_HEALTHCARE_ACTIVE = 'HEALTHCARE_ACTIVE';
import { default as HEALTHCARE_ACTIVE_deprecated } from './deprecated/healthcare-active.svg';
import { default as HEALTHCARE_ACTIVE_rebranded } from './rebranded/healthcare-active.svg';
export const SVG_HEALTHCARE_INACTIVE = 'HEALTHCARE_INACTIVE';
import { default as HEALTHCARE_INACTIVE_deprecated } from './deprecated/healthcare-inactive.svg';
import { default as HEALTHCARE_INACTIVE_rebranded } from './rebranded/healthcare-inactive.svg';
export const SVG_HEART_ACTIVE = 'HEART_ACTIVE';
import { default as HEART_ACTIVE_deprecated } from './deprecated/heart-active.svg';
import { default as HEART_ACTIVE_rebranded } from './rebranded/heart-active.svg';
export const SVG_HEART_INACTIVE = 'HEART_INACTIVE';
import { default as HEART_INACTIVE_deprecated } from './deprecated/heart-inactive.svg';
import { default as HEART_INACTIVE_rebranded } from './rebranded/heart-inactive.svg';
export const SVG_HELP_CIRCLE_ACTIVE = 'HELP_CIRCLE_ACTIVE';
import { default as HELP_CIRCLE_ACTIVE_deprecated } from './deprecated/help-circle-active.svg';
import { default as HELP_CIRCLE_ACTIVE_rebranded } from './rebranded/help-circle-active.svg';
export const SVG_HELP_CIRCLE_INACTIVE = 'HELP_CIRCLE_INACTIVE';
import { default as HELP_CIRCLE_INACTIVE_deprecated } from './deprecated/help-circle-inactive.svg';
import { default as HELP_CIRCLE_INACTIVE_rebranded } from './rebranded/help-circle-inactive.svg';
export const SVG_HELP_SQUARE_ACTIVE = 'HELP_SQUARE_ACTIVE';
import { default as HELP_SQUARE_ACTIVE_deprecated } from './deprecated/help-square-active.svg';
import { default as HELP_SQUARE_ACTIVE_rebranded } from './rebranded/help-square-active.svg';
export const SVG_HELPDESK = 'HELPDESK';
import { default as HELPDESK_deprecated } from './deprecated/helpdesk.svg';
import { default as HELPDESK_rebranded } from './rebranded/helpdesk.svg';
export const SVG_HELP_SQUARE_INACTIVE = 'HELP_SQUARE_INACTIVE';
import { default as HELP_SQUARE_INACTIVE_deprecated } from './deprecated/help-square-inactive.svg';
import { default as HELP_SQUARE_INACTIVE_rebranded } from './rebranded/help-square-inactive.svg';
export const SVG_HIGHLIGHTER_ACTIVE = 'HIGHLIGHTER_ACTIVE';
import { default as HIGHLIGHTER_ACTIVE_deprecated } from './deprecated/highlighter-active.svg';
import { default as HIGHLIGHTER_ACTIVE_rebranded } from './rebranded/highlighter-active.svg';
export const SVG_HIGHLIGHTER = 'HIGHLIGHTER';
import { default as HIGHLIGHTER_deprecated } from './deprecated/highlighter.svg';
import { default as HIGHLIGHTER_rebranded } from './rebranded/highlighter.svg';
export const SVG_HISTORY = 'HISTORY';
import { default as HISTORY_deprecated } from './deprecated/history.svg';
import { default as HISTORY_rebranded } from './rebranded/history.svg';
export const SVG_HOME_ACTIVE = 'HOME_ACTIVE';
import { default as HOME_ACTIVE_deprecated } from './deprecated/home-active.svg';
import { default as HOME_ACTIVE_rebranded } from './rebranded/home-active.svg';
export const SVG_HOME_INACTIVE = 'HOME_INACTIVE';
import { default as HOME_INACTIVE_deprecated } from './deprecated/home-inactive.svg';
import { default as HOME_INACTIVE_rebranded } from './rebranded/home-inactive.svg';
export const SVG_HOUSE_ACTIVE = 'HOUSE_ACTIVE';
import { default as HOUSE_ACTIVE_deprecated } from './deprecated/house-active.svg';
import { default as HOUSE_ACTIVE_rebranded } from './rebranded/house-active.svg';
export const SVG_INBOX_ACTIVE = 'INBOX_ACTIVE';
import { default as INBOX_ACTIVE_deprecated } from './deprecated/inbox-active.svg';
import { default as INBOX_ACTIVE_rebranded } from './rebranded/inbox-active.svg';
export const SVG_HOUSE_INACTIVE = 'HOUSE_INACTIVE';
import { default as HOUSE_INACTIVE_deprecated } from './deprecated/house-inactive.svg';
import { default as HOUSE_INACTIVE_rebranded } from './rebranded/house-inactive.svg';
export const SVG_ID_CARD = 'ID_CARD';
import { default as ID_CARD_deprecated } from './deprecated/id-card.svg';
import { default as ID_CARD_rebranded } from './rebranded/id-card.svg';
export const SVG_INBOX_INACTIVE = 'INBOX_INACTIVE';
import { default as INBOX_INACTIVE_deprecated } from './deprecated/inbox-inactive.svg';
import { default as INBOX_INACTIVE_rebranded } from './rebranded/inbox-inactive.svg';
export const SVG_INFINITY = 'INFINITY';
import { default as INFINITY_deprecated } from './deprecated/infinity.svg';
import { default as INFINITY_rebranded } from './rebranded/infinity.svg';
export const SVG_INFO_ACTIVE = 'INFO_ACTIVE';
import { default as INFO_ACTIVE_deprecated } from './deprecated/info-active.svg';
import { default as INFO_ACTIVE_rebranded } from './rebranded/info-active.svg';
export const SVG_INFO_INACTIVE = 'INFO_INACTIVE';
import { default as INFO_INACTIVE_deprecated } from './deprecated/info-inactive.svg';
import { default as INFO_INACTIVE_rebranded } from './rebranded/info-inactive.svg';
export const SVG_INTEGRATIONS = 'INTEGRATIONS';
import { default as INTEGRATIONS_deprecated } from './deprecated/integrations.svg';
import { default as INTEGRATIONS_rebranded } from './rebranded/integrations.svg';
export const SVG_KEY_ACTIVE = 'KEY_ACTIVE';
import { default as KEY_ACTIVE_deprecated } from './deprecated/key-active.svg';
import { default as KEY_ACTIVE_rebranded } from './rebranded/key-active.svg';
export const SVG_INTERNET_EXPLORER = 'INTERNET_EXPLORER';
import { default as INTERNET_EXPLORER_deprecated } from './deprecated/internet-explorer.svg';
import { default as INTERNET_EXPLORER_rebranded } from './rebranded/internet-explorer.svg';
export const SVG_KEY_INACTIVE = 'KEY_INACTIVE';
import { default as KEY_INACTIVE_deprecated } from './deprecated/key-inactive.svg';
import { default as KEY_INACTIVE_rebranded } from './rebranded/key-inactive.svg';
export const SVG_LAB_ACTIVE = 'LAB_ACTIVE';
import { default as LAB_ACTIVE_deprecated } from './deprecated/lab-active.svg';
import { default as LAB_ACTIVE_rebranded } from './rebranded/lab-active.svg';
export const SVG_KEYBOARD_INACTIVE = 'KEYBOARD_INACTIVE';
import { default as KEYBOARD_INACTIVE_deprecated } from './deprecated/keyboard-inactive.svg';
import { default as KEYBOARD_INACTIVE_rebranded } from './rebranded/keyboard-inactive.svg';
export const SVG_LAB_INACTIVE = 'LAB_INACTIVE';
import { default as LAB_INACTIVE_deprecated } from './deprecated/lab-inactive.svg';
import { default as LAB_INACTIVE_rebranded } from './rebranded/lab-inactive.svg';
export const SVG_LAUNCH_ACTIVE = 'LAUNCH_ACTIVE';
import { default as LAUNCH_ACTIVE_deprecated } from './deprecated/launch-active.svg';
import { default as LAUNCH_ACTIVE_rebranded } from './rebranded/launch-active.svg';
export const SVG_LAUNCH_INACTIVE = 'LAUNCH_INACTIVE';
import { default as LAUNCH_INACTIVE_deprecated } from './deprecated/launch-inactive.svg';
import { default as LAUNCH_INACTIVE_rebranded } from './rebranded/launch-inactive.svg';
export const SVG_LEGAL_ACTIVE = 'LEGAL_ACTIVE';
import { default as LEGAL_ACTIVE_deprecated } from './deprecated/legal-active.svg';
import { default as LEGAL_ACTIVE_rebranded } from './rebranded/legal-active.svg';
export const SVG_LEAVE = 'LEAVE';
import { default as LEAVE_deprecated } from './deprecated/leave.svg';
import { default as LEAVE_rebranded } from './rebranded/leave.svg';
export const SVG_LEGAL_INACTIVE = 'LEGAL_INACTIVE';
import { default as LEGAL_INACTIVE_deprecated } from './deprecated/legal-inactive.svg';
import { default as LEGAL_INACTIVE_rebranded } from './rebranded/legal-inactive.svg';
export const SVG_LINK_ACTIVE = 'LINK_ACTIVE';
import { default as LINK_ACTIVE_deprecated } from './deprecated/link-active.svg';
import { default as LINK_ACTIVE_rebranded } from './rebranded/link-active.svg';
export const SVG_LINK_HORIZONTAL = 'LINK_HORIZONTAL';
import { default as LINK_HORIZONTAL_deprecated } from './deprecated/link-horizontal.svg';
import { default as LINK_HORIZONTAL_rebranded } from './rebranded/link-horizontal.svg';
export const SVG_LINK_INACTIVE = 'LINK_INACTIVE';
import { default as LINK_INACTIVE_deprecated } from './deprecated/link-inactive.svg';
import { default as LINK_INACTIVE_rebranded } from './rebranded/link-inactive.svg';
export const SVG_LINUX = 'LINUX';
import { default as LINUX_deprecated } from './deprecated/linux.svg';
import { default as LINUX_rebranded } from './rebranded/linux.svg';
export const SVG_LIST_ACTIVE = 'LIST_ACTIVE';
import { default as LIST_ACTIVE_deprecated } from './deprecated/list-active.svg';
import { default as LIST_ACTIVE_rebranded } from './rebranded/list-active.svg';
export const SVG_LIST_INACTIVE = 'LIST_INACTIVE';
import { default as LIST_INACTIVE_deprecated } from './deprecated/list-inactive.svg';
import { default as LIST_INACTIVE_rebranded } from './rebranded/list-inactive.svg';
export const SVG_LISTEN = 'LISTEN';
import { default as LISTEN_deprecated } from './deprecated/listen.svg';
import { default as LISTEN_rebranded } from './rebranded/listen.svg';
export const SVG_LOADER = 'LOADER';
import { default as LOADER_deprecated } from './deprecated/loader.svg';
import { default as LOADER_rebranded } from './rebranded/loader.svg';
export const SVG_LOCKED_ACTIVE_20_PX = 'LOCKED_ACTIVE_20_PX';
import { default as LOCKED_ACTIVE_20_PX_deprecated } from './deprecated/locked-active-20-px.svg';
import { default as LOCKED_ACTIVE_20_PX_rebranded } from './rebranded/locked-active-20-px.svg';
export const SVG_LOCKED_ACTIVE = 'LOCKED_ACTIVE';
import { default as LOCKED_ACTIVE_deprecated } from './deprecated/locked-active.svg';
import { default as LOCKED_ACTIVE_rebranded } from './rebranded/locked-active.svg';
export const SVG_LOCKED_INACTIVE_20_PX = 'LOCKED_INACTIVE_20_PX';
import { default as LOCKED_INACTIVE_20_PX_deprecated } from './deprecated/locked-inactive-20-px.svg';
import { default as LOCKED_INACTIVE_20_PX_rebranded } from './rebranded/locked-inactive-20-px.svg';
export const SVG_LOCKED_INACTIVE = 'LOCKED_INACTIVE';
import { default as LOCKED_INACTIVE_deprecated } from './deprecated/locked-inactive.svg';
import { default as LOCKED_INACTIVE_rebranded } from './rebranded/locked-inactive.svg';
export const SVG_LOG_ACTIVE = 'LOG_ACTIVE';
import { default as LOG_ACTIVE_deprecated } from './deprecated/log-active.svg';
import { default as LOG_ACTIVE_rebranded } from './rebranded/log-active.svg';
export const SVG_LOG_INACTIVE = 'LOG_INACTIVE';
import { default as LOG_INACTIVE_deprecated } from './deprecated/log-inactive.svg';
import { default as LOG_INACTIVE_rebranded } from './rebranded/log-inactive.svg';
export const SVG_LOGMEIN = 'LOGMEIN';
import { default as LOGMEIN_deprecated } from './deprecated/logmein.svg';
import { default as LOGMEIN_rebranded } from './rebranded/logmein.svg';
export const SVG_LOUD_SPEAKER = 'LOUD_SPEAKER';
import { default as LOUD_SPEAKER_deprecated } from './deprecated/loud-speaker.svg';
import { default as LOUD_SPEAKER_rebranded } from './rebranded/loud-speaker.svg';
export const SVG_MAGIC_WAND_ACTIVE = 'MAGIC_WAND_ACTIVE';
import { default as MAGIC_WAND_ACTIVE_deprecated } from './deprecated/magic-wand-active.svg';
import { default as MAGIC_WAND_ACTIVE_rebranded } from './rebranded/magic-wand-active.svg';
export const SVG_MAIN_SWITCH_ACTIVE = 'MAIN_SWITCH_ACTIVE';
import { default as MAIN_SWITCH_ACTIVE_deprecated } from './deprecated/main-switch-active.svg';
import { default as MAIN_SWITCH_ACTIVE_rebranded } from './rebranded/main-switch-active.svg';
export const SVG_MAGIC_WAND_INACTIVE = 'MAGIC_WAND_INACTIVE';
import { default as MAGIC_WAND_INACTIVE_deprecated } from './deprecated/magic-wand-inactive.svg';
import { default as MAGIC_WAND_INACTIVE_rebranded } from './rebranded/magic-wand-inactive.svg';
export const SVG_MAIN_SWITCH_INACTIVE = 'MAIN_SWITCH_INACTIVE';
import { default as MAIN_SWITCH_INACTIVE_deprecated } from './deprecated/main-switch-inactive.svg';
import { default as MAIN_SWITCH_INACTIVE_rebranded } from './rebranded/main-switch-inactive.svg';
export const SVG_MANUFACTURING_ACTIVE = 'MANUFACTURING_ACTIVE';
import { default as MANUFACTURING_ACTIVE_deprecated } from './deprecated/manufacturing-active.svg';
import { default as MANUFACTURING_ACTIVE_rebranded } from './rebranded/manufacturing-active.svg';
export const SVG_MANUFACTURING_INACTIVE = 'MANUFACTURING_INACTIVE';
import { default as MANUFACTURING_INACTIVE_deprecated } from './deprecated/manufacturing-inactive.svg';
import { default as MANUFACTURING_INACTIVE_rebranded } from './rebranded/manufacturing-inactive.svg';
export const SVG_MATERIALS_ACTIVE = 'MATERIALS_ACTIVE';
import { default as MATERIALS_ACTIVE_deprecated } from './deprecated/materials-active.svg';
import { default as MATERIALS_ACTIVE_rebranded } from './rebranded/materials-active.svg';
export const SVG_MASTER = 'MASTER';
import { default as MASTER_deprecated } from './deprecated/master.svg';
import { default as MASTER_rebranded } from './rebranded/master.svg';
export const SVG_MATERIALS_INACTIVE = 'MATERIALS_INACTIVE';
import { default as MATERIALS_INACTIVE_deprecated } from './deprecated/materials-inactive.svg';
import { default as MATERIALS_INACTIVE_rebranded } from './rebranded/materials-inactive.svg';
export const SVG_MEET_NOW = 'MEET_NOW';
import { default as MEET_NOW_deprecated } from './deprecated/meet-now.svg';
import { default as MEET_NOW_rebranded } from './rebranded/meet-now.svg';
export const SVG_MEETING_JOIN_ACTIVE = 'MEETING_JOIN_ACTIVE';
import { default as MEETING_JOIN_ACTIVE_deprecated } from './deprecated/meeting-join-active.svg';
import { default as MEETING_JOIN_ACTIVE_rebranded } from './rebranded/meeting-join-active.svg';
export const SVG_MEETING_JOIN_INACTIVE = 'MEETING_JOIN_INACTIVE';
import { default as MEETING_JOIN_INACTIVE_deprecated } from './deprecated/meeting-join-inactive.svg';
import { default as MEETING_JOIN_INACTIVE_rebranded } from './rebranded/meeting-join-inactive.svg';
export const SVG_MEETING_SYNC = 'MEETING_SYNC';
import { default as MEETING_SYNC_deprecated } from './deprecated/meeting-sync.svg';
import { default as MEETING_SYNC_rebranded } from './rebranded/meeting-sync.svg';
export const SVG_MEETINGS_ACTIVE = 'MEETINGS_ACTIVE';
import { default as MEETINGS_ACTIVE_deprecated } from './deprecated/meetings-active.svg';
import { default as MEETINGS_ACTIVE_rebranded } from './rebranded/meetings-active.svg';
export const SVG_MEETINGS_INACTIVE = 'MEETINGS_INACTIVE';
import { default as MEETINGS_INACTIVE_deprecated } from './deprecated/meetings-inactive.svg';
import { default as MEETINGS_INACTIVE_rebranded } from './rebranded/meetings-inactive.svg';
export const SVG_MERGE = 'MERGE';
import { default as MERGE_deprecated } from './deprecated/merge.svg';
import { default as MERGE_rebranded } from './rebranded/merge.svg';
export const SVG_MESSENGER = 'MESSENGER';
import { default as MESSENGER_deprecated } from './deprecated/messenger.svg';
import { default as MESSENGER_rebranded } from './rebranded/messenger.svg';
export const SVG_MIC_OFF_20_PX = 'MIC_OFF_20_PX';
import { default as MIC_OFF_20_PX_deprecated } from './deprecated/mic-off-20-px.svg';
import { default as MIC_OFF_20_PX_rebranded } from './rebranded/mic-off-20-px.svg';
export const SVG_MIC_ON_20_PX = 'MIC_ON_20_PX';
import { default as MIC_ON_20_PX_deprecated } from './deprecated/mic-on-20-px.svg';
import { default as MIC_ON_20_PX_rebranded } from './rebranded/mic-on-20-px.svg';
export const SVG_MICROPHONE_ACTIVE = 'MICROPHONE_ACTIVE';
import { default as MICROPHONE_ACTIVE_deprecated } from './deprecated/microphone-active.svg';
import { default as MICROPHONE_ACTIVE_rebranded } from './rebranded/microphone-active.svg';
export const SVG_MICROPHONE_INACTIVE = 'MICROPHONE_INACTIVE';
import { default as MICROPHONE_INACTIVE_deprecated } from './deprecated/microphone-inactive.svg';
import { default as MICROPHONE_INACTIVE_rebranded } from './rebranded/microphone-inactive.svg';
export const SVG_MICROPHONE_OFF_ACTIVE = 'MICROPHONE_OFF_ACTIVE';
import { default as MICROPHONE_OFF_ACTIVE_deprecated } from './deprecated/microphone-off-active.svg';
import { default as MICROPHONE_OFF_ACTIVE_rebranded } from './rebranded/microphone-off-active.svg';
export const SVG_MICROPHONE_ON_INACTIVE = 'MICROPHONE_ON_INACTIVE';
import { default as MICROPHONE_ON_INACTIVE_deprecated } from './deprecated/microphone-on-inactive.svg';
import { default as MICROPHONE_ON_INACTIVE_rebranded } from './rebranded/microphone-on-inactive.svg';
export const SVG_MINIFY_MEETING = 'MINIFY_MEETING';
import { default as MINIFY_MEETING_deprecated } from './deprecated/minify-meeting.svg';
import { default as MINIFY_MEETING_rebranded } from './rebranded/minify-meeting.svg';
export const SVG_MOBILE_SUPPORT = 'MOBILE_SUPPORT';
import { default as MOBILE_SUPPORT_deprecated } from './deprecated/mobile-support.svg';
import { default as MOBILE_SUPPORT_rebranded } from './rebranded/mobile-support.svg';
export const SVG_MORE_VERTICAL_MOBILE_ONLY = 'MORE_VERTICAL_MOBILE_ONLY';
import { default as MORE_VERTICAL_MOBILE_ONLY_deprecated } from './deprecated/more-vertical-mobile-only.svg';
import { default as MORE_VERTICAL_MOBILE_ONLY_rebranded } from './rebranded/more-vertical-mobile-only.svg';
export const SVG_MORE_HORIZONTAL = 'MORE_HORIZONTAL';
import { default as MORE_HORIZONTAL_deprecated } from './deprecated/more-horizontal.svg';
import { default as MORE_HORIZONTAL_rebranded } from './rebranded/more-horizontal.svg';
export const SVG_MOUSE_ACTIVE = 'MOUSE_ACTIVE';
import { default as MOUSE_ACTIVE_deprecated } from './deprecated/mouse-active.svg';
import { default as MOUSE_ACTIVE_rebranded } from './rebranded/mouse-active.svg';
export const SVG_MOUSE_INACTIVE = 'MOUSE_INACTIVE';
import { default as MOUSE_INACTIVE_deprecated } from './deprecated/mouse-inactive.svg';
import { default as MOUSE_INACTIVE_rebranded } from './rebranded/mouse-inactive.svg';
export const SVG_MUSIC = 'MUSIC';
import { default as MUSIC_deprecated } from './deprecated/music.svg';
import { default as MUSIC_rebranded } from './rebranded/music.svg';
export const SVG_NETWORK_ACTIVE = 'NETWORK_ACTIVE';
import { default as NETWORK_ACTIVE_deprecated } from './deprecated/network-active.svg';
import { default as NETWORK_ACTIVE_rebranded } from './rebranded/network-active.svg';
export const SVG_NETWORK_INACTIVE = 'NETWORK_INACTIVE';
import { default as NETWORK_INACTIVE_deprecated } from './deprecated/network-inactive.svg';
import { default as NETWORK_INACTIVE_rebranded } from './rebranded/network-inactive.svg';
export const SVG_NOTE_ACTIVE = 'NOTE_ACTIVE';
import { default as NOTE_ACTIVE_deprecated } from './deprecated/note-active.svg';
import { default as NOTE_ACTIVE_rebranded } from './rebranded/note-active.svg';
export const SVG_NOTE_INACTIVE = 'NOTE_INACTIVE';
import { default as NOTE_INACTIVE_deprecated } from './deprecated/note-inactive.svg';
import { default as NOTE_INACTIVE_rebranded } from './rebranded/note-inactive.svg';
export const SVG_NOTE = 'NOTE';
import { default as NOTE_deprecated } from './deprecated/note.svg';
import { default as NOTE_rebranded } from './rebranded/note.svg';
export const SVG_NOTEPAD_ACTIVE = 'NOTEPAD_ACTIVE';
import { default as NOTEPAD_ACTIVE_deprecated } from './deprecated/notepad-active.svg';
import { default as NOTEPAD_ACTIVE_rebranded } from './rebranded/notepad-active.svg';
export const SVG_NOTEPAD_INACTIVE = 'NOTEPAD_INACTIVE';
import { default as NOTEPAD_INACTIVE_deprecated } from './deprecated/notepad-inactive.svg';
import { default as NOTEPAD_INACTIVE_rebranded } from './rebranded/notepad-inactive.svg';
export const SVG_NOTIFICATIONS_ALERT_ACTIVE = 'NOTIFICATIONS_ALERT_ACTIVE';
import { default as NOTIFICATIONS_ALERT_ACTIVE_deprecated } from './deprecated/notifications-alert-active.svg';
import { default as NOTIFICATIONS_ALERT_ACTIVE_rebranded } from './rebranded/notifications-alert-active.svg';
export const SVG_NOTIFICATIONS_ALERT_INACTIVE = 'NOTIFICATIONS_ALERT_INACTIVE';
import { default as NOTIFICATIONS_ALERT_INACTIVE_deprecated } from './deprecated/notifications-alert-inactive.svg';
import { default as NOTIFICATIONS_ALERT_INACTIVE_rebranded } from './rebranded/notifications-alert-inactive.svg';
export const SVG_NOTIFICATIONS = 'NOTIFICATIONS';
import { default as NOTIFICATIONS_deprecated } from './deprecated/notifications.svg';
import { default as NOTIFICATIONS_rebranded } from './rebranded/notifications.svg';
export const SVG_NPA_INACTIVE = 'NPA_INACTIVE';
import { default as NPA_INACTIVE_deprecated } from './deprecated/npa-inactive.svg';
import { default as NPA_INACTIVE_rebranded } from './rebranded/npa-inactive.svg';
export const SVG_NPA_ACTIVE = 'NPA_ACTIVE';
import { default as NPA_ACTIVE_deprecated } from './deprecated/npa-active.svg';
import { default as NPA_ACTIVE_rebranded } from './rebranded/npa-active.svg';
export const SVG_NUMBERED_ARROW_INACTIVE = 'NUMBERED_ARROW_INACTIVE';
import { default as NUMBERED_ARROW_INACTIVE_deprecated } from './deprecated/numbered-arrow-inactive.svg';
import { default as NUMBERED_ARROW_INACTIVE_rebranded } from './rebranded/numbered-arrow-inactive.svg';
export const SVG_NUMBERED_ARROW_ACTIVE = 'NUMBERED_ARROW_ACTIVE';
import { default as NUMBERED_ARROW_ACTIVE_deprecated } from './deprecated/numbered-arrow-active.svg';
import { default as NUMBERED_ARROW_ACTIVE_rebranded } from './rebranded/numbered-arrow-active.svg';
export const SVG_OPEN_VOICE = 'OPEN_VOICE';
import { default as OPEN_VOICE_deprecated } from './deprecated/open-voice.svg';
import { default as OPEN_VOICE_rebranded } from './rebranded/open-voice.svg';
export const SVG_OPERA = 'OPERA';
import { default as OPERA_deprecated } from './deprecated/opera.svg';
import { default as OPERA_rebranded } from './rebranded/opera.svg';
export const SVG_PAINT_INACTIVE = 'PAINT_INACTIVE';
import { default as PAINT_INACTIVE_deprecated } from './deprecated/paint-inactive.svg';
import { default as PAINT_INACTIVE_rebranded } from './rebranded/paint-inactive.svg';
export const SVG_PAINT_ACTIVE = 'PAINT_ACTIVE';
import { default as PAINT_ACTIVE_deprecated } from './deprecated/paint-active.svg';
import { default as PAINT_ACTIVE_rebranded } from './rebranded/paint-active.svg';
export const SVG_PALETTE_ACTIVE = 'PALETTE_ACTIVE';
import { default as PALETTE_ACTIVE_deprecated } from './deprecated/palette-active.svg';
import { default as PALETTE_ACTIVE_rebranded } from './rebranded/palette-active.svg';
export const SVG_PALETTE_INACTIVE = 'PALETTE_INACTIVE';
import { default as PALETTE_INACTIVE_deprecated } from './deprecated/palette-inactive.svg';
import { default as PALETTE_INACTIVE_rebranded } from './rebranded/palette-inactive.svg';
export const SVG_PAUSE_20_PX = 'PAUSE_20_PX';
import { default as PAUSE_20_PX_deprecated } from './deprecated/pause-20-px.svg';
import { default as PAUSE_20_PX_rebranded } from './rebranded/pause-20-px.svg';
export const SVG_PAUSE_ACTIVE = 'PAUSE_ACTIVE';
import { default as PAUSE_ACTIVE_deprecated } from './deprecated/pause-active.svg';
import { default as PAUSE_ACTIVE_rebranded } from './rebranded/pause-active.svg';
export const SVG_PAUSE_CIRCLE_ACTIVE = 'PAUSE_CIRCLE_ACTIVE';
import { default as PAUSE_CIRCLE_ACTIVE_deprecated } from './deprecated/pause-circle-active.svg';
import { default as PAUSE_CIRCLE_ACTIVE_rebranded } from './rebranded/pause-circle-active.svg';
export const SVG_PAUSE_CIRCLE_INACTIVE = 'PAUSE_CIRCLE_INACTIVE';
import { default as PAUSE_CIRCLE_INACTIVE_deprecated } from './deprecated/pause-circle-inactive.svg';
import { default as PAUSE_CIRCLE_INACTIVE_rebranded } from './rebranded/pause-circle-inactive.svg';
export const SVG_PAUSE_INACTIVE = 'PAUSE_INACTIVE';
import { default as PAUSE_INACTIVE_deprecated } from './deprecated/pause-inactive.svg';
import { default as PAUSE_INACTIVE_rebranded } from './rebranded/pause-inactive.svg';
export const SVG_PBX = 'PBX';
import { default as PBX_deprecated } from './deprecated/pbx.svg';
import { default as PBX_rebranded } from './rebranded/pbx.svg';
export const SVG_PEOPLE_ACTIVE = 'PEOPLE_ACTIVE';
import { default as PEOPLE_ACTIVE_deprecated } from './deprecated/people-active.svg';
import { default as PEOPLE_ACTIVE_rebranded } from './rebranded/people-active.svg';
export const SVG_PEOPLE_INACTIVE = 'PEOPLE_INACTIVE';
import { default as PEOPLE_INACTIVE_deprecated } from './deprecated/people-inactive.svg';
import { default as PEOPLE_INACTIVE_rebranded } from './rebranded/people-inactive.svg';
export const SVG_PERSON_ACTIVE = 'PERSON_ACTIVE';
import { default as PERSON_ACTIVE_deprecated } from './deprecated/person-active.svg';
import { default as PERSON_ACTIVE_rebranded } from './rebranded/person-active.svg';
export const SVG_PERSON_CHECKMARK_ACTIVE = 'PERSON_CHECKMARK_ACTIVE';
import { default as PERSON_CHECKMARK_ACTIVE_deprecated } from './deprecated/person-checkmark-active.svg';
import { default as PERSON_CHECKMARK_ACTIVE_rebranded } from './rebranded/person-checkmark-active.svg';
export const SVG_PERSON_CHECKMARK_INACTIVE = 'PERSON_CHECKMARK_INACTIVE';
import { default as PERSON_CHECKMARK_INACTIVE_deprecated } from './deprecated/person-checkmark-inactive.svg';
import { default as PERSON_CHECKMARK_INACTIVE_rebranded } from './rebranded/person-checkmark-inactive.svg';
export const SVG_PERSON_INACTIVE = 'PERSON_INACTIVE';
import { default as PERSON_INACTIVE_deprecated } from './deprecated/person-inactive.svg';
import { default as PERSON_INACTIVE_rebranded } from './rebranded/person-inactive.svg';
export const SVG_PERSON_TRANSFER_FROM_INACTIVE = 'PERSON_TRANSFER_FROM_INACTIVE';
import { default as PERSON_TRANSFER_FROM_INACTIVE_deprecated } from './deprecated/person-transfer-from-inactive.svg';
import { default as PERSON_TRANSFER_FROM_INACTIVE_rebranded } from './rebranded/person-transfer-from-inactive.svg';
export const SVG_PERSON_TRANSFER_FROM_ACTIVE = 'PERSON_TRANSFER_FROM_ACTIVE';
import { default as PERSON_TRANSFER_FROM_ACTIVE_deprecated } from './deprecated/person-transfer-from-active.svg';
import { default as PERSON_TRANSFER_FROM_ACTIVE_rebranded } from './rebranded/person-transfer-from-active.svg';
export const SVG_PERSON_TRANSFER_TO_ACTIVE = 'PERSON_TRANSFER_TO_ACTIVE';
import { default as PERSON_TRANSFER_TO_ACTIVE_deprecated } from './deprecated/person-transfer-to-active.svg';
import { default as PERSON_TRANSFER_TO_ACTIVE_rebranded } from './rebranded/person-transfer-to-active.svg';
export const SVG_PERSON_TRANSFER_TO_INACTIVE = 'PERSON_TRANSFER_TO_INACTIVE';
import { default as PERSON_TRANSFER_TO_INACTIVE_deprecated } from './deprecated/person-transfer-to-inactive.svg';
import { default as PERSON_TRANSFER_TO_INACTIVE_rebranded } from './rebranded/person-transfer-to-inactive.svg';
export const SVG_PHONE_DOWN_ACTIVE = 'PHONE_DOWN_ACTIVE';
import { default as PHONE_DOWN_ACTIVE_deprecated } from './deprecated/phone-down-active.svg';
import { default as PHONE_DOWN_ACTIVE_rebranded } from './rebranded/phone-down-active.svg';
export const SVG_PHONE_DOWN_INACTIVE = 'PHONE_DOWN_INACTIVE';
import { default as PHONE_DOWN_INACTIVE_deprecated } from './deprecated/phone-down-inactive.svg';
import { default as PHONE_DOWN_INACTIVE_rebranded } from './rebranded/phone-down-inactive.svg';
export const SVG_PHONE_UP_ACTIVE = 'PHONE_UP_ACTIVE';
import { default as PHONE_UP_ACTIVE_deprecated } from './deprecated/phone-up-active.svg';
import { default as PHONE_UP_ACTIVE_rebranded } from './rebranded/phone-up-active.svg';
export const SVG_PHONE_UP_DISABLED_ACTIVE = 'PHONE_UP_DISABLED_ACTIVE';
import { default as PHONE_UP_DISABLED_ACTIVE_deprecated } from './deprecated/phone-up-disabled-active.svg';
import { default as PHONE_UP_DISABLED_ACTIVE_rebranded } from './rebranded/phone-up-disabled-active.svg';
export const SVG_PHONE_UP_DISABLED_INACTIVE = 'PHONE_UP_DISABLED_INACTIVE';
import { default as PHONE_UP_DISABLED_INACTIVE_deprecated } from './deprecated/phone-up-disabled-inactive.svg';
import { default as PHONE_UP_DISABLED_INACTIVE_rebranded } from './rebranded/phone-up-disabled-inactive.svg';
export const SVG_PHONE_UP_INACTIVE = 'PHONE_UP_INACTIVE';
import { default as PHONE_UP_INACTIVE_deprecated } from './deprecated/phone-up-inactive.svg';
import { default as PHONE_UP_INACTIVE_rebranded } from './rebranded/phone-up-inactive.svg';
export const SVG_PICTURE_ACTIVE = 'PICTURE_ACTIVE';
import { default as PICTURE_ACTIVE_deprecated } from './deprecated/picture-active.svg';
import { default as PICTURE_ACTIVE_rebranded } from './rebranded/picture-active.svg';
export const SVG_PICTURE_DISABLED_ACTIVE = 'PICTURE_DISABLED_ACTIVE';
import { default as PICTURE_DISABLED_ACTIVE_deprecated } from './deprecated/picture-disabled-active.svg';
import { default as PICTURE_DISABLED_ACTIVE_rebranded } from './rebranded/picture-disabled-active.svg';
export const SVG_PICTURE_DISABLED_INACTIVE = 'PICTURE_DISABLED_INACTIVE';
import { default as PICTURE_DISABLED_INACTIVE_deprecated } from './deprecated/picture-disabled-inactive.svg';
import { default as PICTURE_DISABLED_INACTIVE_rebranded } from './rebranded/picture-disabled-inactive.svg';
export const SVG_PICTURE_INACTIVE = 'PICTURE_INACTIVE';
import { default as PICTURE_INACTIVE_deprecated } from './deprecated/picture-inactive.svg';
import { default as PICTURE_INACTIVE_rebranded } from './rebranded/picture-inactive.svg';
export const SVG_PIE_CHART_ACTIVE = 'PIE_CHART_ACTIVE';
import { default as PIE_CHART_ACTIVE_deprecated } from './deprecated/pie-chart-active.svg';
import { default as PIE_CHART_ACTIVE_rebranded } from './rebranded/pie-chart-active.svg';
export const SVG_PIE_CHART_INACTIVE = 'PIE_CHART_INACTIVE';
import { default as PIE_CHART_INACTIVE_deprecated } from './deprecated/pie-chart-inactive.svg';
import { default as PIE_CHART_INACTIVE_rebranded } from './rebranded/pie-chart-inactive.svg';
export const SVG_PIP_MAXIMIZE = 'PIP_MAXIMIZE';
import { default as PIP_MAXIMIZE_deprecated } from './deprecated/pip-maximize.svg';
import { default as PIP_MAXIMIZE_rebranded } from './rebranded/pip-maximize.svg';
export const SVG_PIP_MINIMIZE = 'PIP_MINIMIZE';
import { default as PIP_MINIMIZE_deprecated } from './deprecated/pip-minimize.svg';
import { default as PIP_MINIMIZE_rebranded } from './rebranded/pip-minimize.svg';
export const SVG_PLAY_ACTIVE = 'PLAY_ACTIVE';
import { default as PLAY_ACTIVE_deprecated } from './deprecated/play-active.svg';
import { default as PLAY_ACTIVE_rebranded } from './rebranded/play-active.svg';
export const SVG_PLAY_INACTIVE = 'PLAY_INACTIVE';
import { default as PLAY_INACTIVE_deprecated } from './deprecated/play-inactive.svg';
import { default as PLAY_INACTIVE_rebranded } from './rebranded/play-inactive.svg';
export const SVG_POINTER_OFF_INACTIVE = 'POINTER_OFF_INACTIVE';
import { default as POINTER_OFF_INACTIVE_deprecated } from './deprecated/pointer-off-inactive.svg';
import { default as POINTER_OFF_INACTIVE_rebranded } from './rebranded/pointer-off-inactive.svg';
export const SVG_POINTER_OFF_ACTIVE = 'POINTER_OFF_ACTIVE';
import { default as POINTER_OFF_ACTIVE_deprecated } from './deprecated/pointer-off-active.svg';
import { default as POINTER_OFF_ACTIVE_rebranded } from './rebranded/pointer-off-active.svg';
export const SVG_POINTER_ON_INACTIVE = 'POINTER_ON_INACTIVE';
import { default as POINTER_ON_INACTIVE_deprecated } from './deprecated/pointer-on-inactive.svg';
import { default as POINTER_ON_INACTIVE_rebranded } from './rebranded/pointer-on-inactive.svg';
export const SVG_POINTER_ON_ACTIVE = 'POINTER_ON_ACTIVE';
import { default as POINTER_ON_ACTIVE_deprecated } from './deprecated/pointer-on-active.svg';
import { default as POINTER_ON_ACTIVE_rebranded } from './rebranded/pointer-on-active.svg';
export const SVG_POINTER_WINDOWS_OFF_ACTIVE = 'POINTER_WINDOWS_OFF_ACTIVE';
import { default as POINTER_WINDOWS_OFF_ACTIVE_deprecated } from './deprecated/pointer-windows-off-active.svg';
import { default as POINTER_WINDOWS_OFF_ACTIVE_rebranded } from './rebranded/pointer-windows-off-active.svg';
export const SVG_POINTER_WINDOWS_OFF_INACTIVE = 'POINTER_WINDOWS_OFF_INACTIVE';
import { default as POINTER_WINDOWS_OFF_INACTIVE_deprecated } from './deprecated/pointer-windows-off-inactive.svg';
import { default as POINTER_WINDOWS_OFF_INACTIVE_rebranded } from './rebranded/pointer-windows-off-inactive.svg';
export const SVG_POINTER_WINDOWS_ON_ACTIVE = 'POINTER_WINDOWS_ON_ACTIVE';
import { default as POINTER_WINDOWS_ON_ACTIVE_deprecated } from './deprecated/pointer-windows-on-active.svg';
import { default as POINTER_WINDOWS_ON_ACTIVE_rebranded } from './rebranded/pointer-windows-on-active.svg';
export const SVG_POINTER_WINDOWS_ON_INACTIVE = 'POINTER_WINDOWS_ON_INACTIVE';
import { default as POINTER_WINDOWS_ON_INACTIVE_deprecated } from './deprecated/pointer-windows-on-inactive.svg';
import { default as POINTER_WINDOWS_ON_INACTIVE_rebranded } from './rebranded/pointer-windows-on-inactive.svg';
export const SVG_POINTER = 'POINTER';
import { default as POINTER_deprecated } from './deprecated/pointer.svg';
import { default as POINTER_rebranded } from './rebranded/pointer.svg';
export const SVG_POLLS = 'POLLS';
import { default as POLLS_deprecated } from './deprecated/polls.svg';
import { default as POLLS_rebranded } from './rebranded/polls.svg';
export const SVG_POP_IT_BACK = 'POP_IT_BACK';
import { default as POP_IT_BACK_deprecated } from './deprecated/pop-it-back.svg';
import { default as POP_IT_BACK_rebranded } from './rebranded/pop-it-back.svg';
export const SVG_POP_IT_OUT = 'POP_IT_OUT';
import { default as POP_IT_OUT_deprecated } from './deprecated/pop-it-out.svg';
import { default as POP_IT_OUT_rebranded } from './rebranded/pop-it-out.svg';
export const SVG_POP_OUT_CAMERA = 'POP_OUT_CAMERA';
import { default as POP_OUT_CAMERA_deprecated } from './deprecated/pop-out-camera.svg';
import { default as POP_OUT_CAMERA_rebranded } from './rebranded/pop-out-camera.svg';
export const SVG_POP_OUT_WINDOW = 'POP_OUT_WINDOW';
import { default as POP_OUT_WINDOW_deprecated } from './deprecated/pop-out-window.svg';
import { default as POP_OUT_WINDOW_rebranded } from './rebranded/pop-out-window.svg';
export const SVG_POSITION_TV_BOTTOM = 'POSITION_TV_BOTTOM';
import { default as POSITION_TV_BOTTOM_deprecated } from './deprecated/position-tv-bottom.svg';
import { default as POSITION_TV_BOTTOM_rebranded } from './rebranded/position-tv-bottom.svg';
export const SVG_POSITION_TV_LEFT = 'POSITION_TV_LEFT';
import { default as POSITION_TV_LEFT_deprecated } from './deprecated/position-tv-left.svg';
import { default as POSITION_TV_LEFT_rebranded } from './rebranded/position-tv-left.svg';
export const SVG_POSITION_TV_RIGHT = 'POSITION_TV_RIGHT';
import { default as POSITION_TV_RIGHT_deprecated } from './deprecated/position-tv-right.svg';
import { default as POSITION_TV_RIGHT_rebranded } from './rebranded/position-tv-right.svg';
export const SVG_POUND_SIGN = 'POUND_SIGN';
import { default as POUND_SIGN_deprecated } from './deprecated/pound-sign.svg';
import { default as POUND_SIGN_rebranded } from './rebranded/pound-sign.svg';
export const SVG_POSITION_TV_TOP = 'POSITION_TV_TOP';
import { default as POSITION_TV_TOP_deprecated } from './deprecated/position-tv-top.svg';
import { default as POSITION_TV_TOP_rebranded } from './rebranded/position-tv-top.svg';
export const SVG_POUND = 'POUND';
import { default as POUND_deprecated } from './deprecated/pound.svg';
import { default as POUND_rebranded } from './rebranded/pound.svg';
export const SVG_PRESENCE_AVAILABLE = 'PRESENCE_AVAILABLE';
import { default as PRESENCE_AVAILABLE_deprecated } from './deprecated/presence-available.svg';
import { default as PRESENCE_AVAILABLE_rebranded } from './rebranded/presence-available.svg';
export const SVG_PRESENCE_BUSY_ACTIVE = 'PRESENCE_BUSY_ACTIVE';
import { default as PRESENCE_BUSY_ACTIVE_deprecated } from './deprecated/presence-busy-active.svg';
import { default as PRESENCE_BUSY_ACTIVE_rebranded } from './rebranded/presence-busy-active.svg';
export const SVG_PRESENCE_BUSY_INACTIVE = 'PRESENCE_BUSY_INACTIVE';
import { default as PRESENCE_BUSY_INACTIVE_deprecated } from './deprecated/presence-busy-inactive.svg';
import { default as PRESENCE_BUSY_INACTIVE_rebranded } from './rebranded/presence-busy-inactive.svg';
export const SVG_PRESENCE_DND = 'PRESENCE_DND';
import { default as PRESENCE_DND_deprecated } from './deprecated/presence-dnd.svg';
import { default as PRESENCE_DND_rebranded } from './rebranded/presence-dnd.svg';
export const SVG_PRESENCE_OFFLINE = 'PRESENCE_OFFLINE';
import { default as PRESENCE_OFFLINE_deprecated } from './deprecated/presence-offline.svg';
import { default as PRESENCE_OFFLINE_rebranded } from './rebranded/presence-offline.svg';
export const SVG_PRESENTATION_ACTIVE = 'PRESENTATION_ACTIVE';
import { default as PRESENTATION_ACTIVE_deprecated } from './deprecated/presentation-active.svg';
import { default as PRESENTATION_ACTIVE_rebranded } from './rebranded/presentation-active.svg';
export const SVG_PRESENTATION_INACTIVE = 'PRESENTATION_INACTIVE';
import { default as PRESENTATION_INACTIVE_deprecated } from './deprecated/presentation-inactive.svg';
import { default as PRESENTATION_INACTIVE_rebranded } from './rebranded/presentation-inactive.svg';
export const SVG_PRIVATE_ACTIVE = 'PRIVATE_ACTIVE';
import { default as PRIVATE_ACTIVE_deprecated } from './deprecated/private-active.svg';
import { default as PRIVATE_ACTIVE_rebranded } from './rebranded/private-active.svg';
export const SVG_PRIVATE_INACTIVE = 'PRIVATE_INACTIVE';
import { default as PRIVATE_INACTIVE_deprecated } from './deprecated/private-inactive.svg';
import { default as PRIVATE_INACTIVE_rebranded } from './rebranded/private-inactive.svg';
export const SVG_PUSHPIN_ACTIVE = 'PUSHPIN_ACTIVE';
import { default as PUSHPIN_ACTIVE_deprecated } from './deprecated/pushpin-active.svg';
import { default as PUSHPIN_ACTIVE_rebranded } from './rebranded/pushpin-active.svg';
export const SVG_PUSHPIN_INACTIVE = 'PUSHPIN_INACTIVE';
import { default as PUSHPIN_INACTIVE_deprecated } from './deprecated/pushpin-inactive.svg';
import { default as PUSHPIN_INACTIVE_rebranded } from './rebranded/pushpin-inactive.svg';
export const SVG_QUESTION = 'QUESTION';
import { default as QUESTION_deprecated } from './deprecated/question.svg';
import { default as QUESTION_rebranded } from './rebranded/question.svg';
export const SVG_RADIO_BUTTON_ANDROID_SELECTED = 'RADIO_BUTTON_ANDROID_SELECTED';
import { default as RADIO_BUTTON_ANDROID_SELECTED_deprecated } from './deprecated/radio-button-android-selected.svg';
import { default as RADIO_BUTTON_ANDROID_SELECTED_rebranded } from './rebranded/radio-button-android-selected.svg';
export const SVG_RADIO_BUTTON_ANDROID_UNSELECTED = 'RADIO_BUTTON_ANDROID_UNSELECTED';
import { default as RADIO_BUTTON_ANDROID_UNSELECTED_deprecated } from './deprecated/radio-button-android-unselected.svg';
import { default as RADIO_BUTTON_ANDROID_UNSELECTED_rebranded } from './rebranded/radio-button-android-unselected.svg';
export const SVG_RADIO_BUTTON_SELECTED = 'RADIO_BUTTON_SELECTED';
import { default as RADIO_BUTTON_SELECTED_deprecated } from './deprecated/radio-button-selected.svg';
import { default as RADIO_BUTTON_SELECTED_rebranded } from './rebranded/radio-button-selected.svg';
export const SVG_RADIO_BUTTON_UNSELECTED = 'RADIO_BUTTON_UNSELECTED';
import { default as RADIO_BUTTON_UNSELECTED_deprecated } from './deprecated/radio-button-unselected.svg';
import { default as RADIO_BUTTON_UNSELECTED_rebranded } from './rebranded/radio-button-unselected.svg';
export const SVG_READER_ACTIVE = 'READER_ACTIVE';
import { default as READER_ACTIVE_deprecated } from './deprecated/reader-active.svg';
import { default as READER_ACTIVE_rebranded } from './rebranded/reader-active.svg';
export const SVG_READER_INACTIVE = 'READER_INACTIVE';
import { default as READER_INACTIVE_deprecated } from './deprecated/reader-inactive.svg';
import { default as READER_INACTIVE_rebranded } from './rebranded/reader-inactive.svg';
export const SVG_RECORD_INACTIVE = 'RECORD_INACTIVE';
import { default as RECORD_INACTIVE_deprecated } from './deprecated/record-inactive.svg';
import { default as RECORD_INACTIVE_rebranded } from './rebranded/record-inactive.svg';
export const SVG_RECORDING_TAPE = 'RECORDING_TAPE';
import { default as RECORDING_TAPE_deprecated } from './deprecated/recording-tape.svg';
import { default as RECORDING_TAPE_rebranded } from './rebranded/recording-tape.svg';
export const SVG_RECORDING = 'RECORDING';
import { default as RECORDING_deprecated } from './deprecated/recording.svg';
import { default as RECORDING_rebranded } from './rebranded/recording.svg';
export const SVG_RECURRING = 'RECURRING';
import { default as RECURRING_deprecated } from './deprecated/recurring.svg';
import { default as RECURRING_rebranded } from './rebranded/recurring.svg';
export const SVG_REDO = 'REDO';
import { default as REDO_deprecated } from './deprecated/redo.svg';
import { default as REDO_rebranded } from './rebranded/redo.svg';
export const SVG_REFRESH = 'REFRESH';
import { default as REFRESH_deprecated } from './deprecated/refresh.svg';
import { default as REFRESH_rebranded } from './rebranded/refresh.svg';
export const SVG_REMOTE_SUPPORT_ACTIVE = 'REMOTE_SUPPORT_ACTIVE';
import { default as REMOTE_SUPPORT_ACTIVE_deprecated } from './deprecated/remote-support-active.svg';
import { default as REMOTE_SUPPORT_ACTIVE_rebranded } from './rebranded/remote-support-active.svg';
export const SVG_REMOTE_SUPPORT = 'REMOTE_SUPPORT';
import { default as REMOTE_SUPPORT_deprecated } from './deprecated/remote-support.svg';
import { default as REMOTE_SUPPORT_rebranded } from './rebranded/remote-support.svg';
export const SVG_REPLY = 'REPLY';
import { default as REPLY_deprecated } from './deprecated/reply.svg';
import { default as REPLY_rebranded } from './rebranded/reply.svg';
export const SVG_REPORT = 'REPORT';
import { default as REPORT_deprecated } from './deprecated/report.svg';
import { default as REPORT_rebranded } from './rebranded/report.svg';
export const SVG_RESIZE_HANDLE = 'RESIZE_HANDLE';
import { default as RESIZE_HANDLE_deprecated } from './deprecated/resize-handle.svg';
import { default as RESIZE_HANDLE_rebranded } from './rebranded/resize-handle.svg';
export const SVG_RESTORE = 'RESTORE';
import { default as RESTORE_deprecated } from './deprecated/restore.svg';
import { default as RESTORE_rebranded } from './rebranded/restore.svg';
export const SVG_ROOM_PHYSICAL = 'ROOM_PHYSICAL';
import { default as ROOM_PHYSICAL_deprecated } from './deprecated/room-physical.svg';
import { default as ROOM_PHYSICAL_rebranded } from './rebranded/room-physical.svg';
export const SVG_ROOM_VIEW = 'ROOM_VIEW';
import { default as ROOM_VIEW_deprecated } from './deprecated/room-view.svg';
import { default as ROOM_VIEW_rebranded } from './rebranded/room-view.svg';
export const SVG_ROTATE_CCW_ACTIVE = 'ROTATE_CCW_ACTIVE';
import { default as ROTATE_CCW_ACTIVE_deprecated } from './deprecated/rotate-ccw-active.svg';
import { default as ROTATE_CCW_ACTIVE_rebranded } from './rebranded/rotate-ccw-active.svg';
export const SVG_ROTATE_CCW_INACTIVE = 'ROTATE_CCW_INACTIVE';
import { default as ROTATE_CCW_INACTIVE_deprecated } from './deprecated/rotate-ccw-inactive.svg';
import { default as ROTATE_CCW_INACTIVE_rebranded } from './rebranded/rotate-ccw-inactive.svg';
export const SVG_ROTATE_CW_ACTIVE = 'ROTATE_CW_ACTIVE';
import { default as ROTATE_CW_ACTIVE_deprecated } from './deprecated/rotate-cw-active.svg';
import { default as ROTATE_CW_ACTIVE_rebranded } from './rebranded/rotate-cw-active.svg';
export const SVG_ROTATE_CW_INACTIVE = 'ROTATE_CW_INACTIVE';
import { default as ROTATE_CW_INACTIVE_deprecated } from './deprecated/rotate-cw-inactive.svg';
import { default as ROTATE_CW_INACTIVE_rebranded } from './rebranded/rotate-cw-inactive.svg';
export const SVG_ROUTER_ACTIVE = 'ROUTER_ACTIVE';
import { default as ROUTER_ACTIVE_deprecated } from './deprecated/router-active.svg';
import { default as ROUTER_ACTIVE_rebranded } from './rebranded/router-active.svg';
export const SVG_ROUTER_INACTIVE = 'ROUTER_INACTIVE';
import { default as ROUTER_INACTIVE_deprecated } from './deprecated/router-inactive.svg';
import { default as ROUTER_INACTIVE_rebranded } from './rebranded/router-inactive.svg';
export const SVG_SAFARI = 'SAFARI';
import { default as SAFARI_deprecated } from './deprecated/safari.svg';
import { default as SAFARI_rebranded } from './rebranded/safari.svg';
export const SVG_SCREEN_ACTIVE = 'SCREEN_ACTIVE';
import { default as SCREEN_ACTIVE_deprecated } from './deprecated/screen-active.svg';
import { default as SCREEN_ACTIVE_rebranded } from './rebranded/screen-active.svg';
export const SVG_SCREEN_ADD_DEVICE_ACTIVE = 'SCREEN_ADD_DEVICE_ACTIVE';
import { default as SCREEN_ADD_DEVICE_ACTIVE_deprecated } from './deprecated/screen-add-device-active.svg';
import { default as SCREEN_ADD_DEVICE_ACTIVE_rebranded } from './rebranded/screen-add-device-active.svg';
export const SVG_SCREEN_ADD_DEVICE_INACTIVE = 'SCREEN_ADD_DEVICE_INACTIVE';
import { default as SCREEN_ADD_DEVICE_INACTIVE_deprecated } from './deprecated/screen-add-device-inactive.svg';
import { default as SCREEN_ADD_DEVICE_INACTIVE_rebranded } from './rebranded/screen-add-device-inactive.svg';
export const SVG_SCREEN_INACTIVE = 'SCREEN_INACTIVE';
import { default as SCREEN_INACTIVE_deprecated } from './deprecated/screen-inactive.svg';
import { default as SCREEN_INACTIVE_rebranded } from './rebranded/screen-inactive.svg';
export const SVG_SCREEN_MIRRORING_LAPTOP = 'SCREEN_MIRRORING_LAPTOP';
import { default as SCREEN_MIRRORING_LAPTOP_deprecated } from './deprecated/screen-mirroring-laptop.svg';
import { default as SCREEN_MIRRORING_LAPTOP_rebranded } from './rebranded/screen-mirroring-laptop.svg';
export const SVG_SCREEN_QUALITY_ACTIVE = 'SCREEN_QUALITY_ACTIVE';
import { default as SCREEN_QUALITY_ACTIVE_deprecated } from './deprecated/screen-quality-active.svg';
import { default as SCREEN_QUALITY_ACTIVE_rebranded } from './rebranded/screen-quality-active.svg';
export const SVG_SCREEN_QUALITY_INACTIVE = 'SCREEN_QUALITY_INACTIVE';
import { default as SCREEN_QUALITY_INACTIVE_deprecated } from './deprecated/screen-quality-inactive.svg';
import { default as SCREEN_QUALITY_INACTIVE_rebranded } from './rebranded/screen-quality-inactive.svg';
export const SVG_SCREEN_REBOOT_ACTIVE = 'SCREEN_REBOOT_ACTIVE';
import { default as SCREEN_REBOOT_ACTIVE_deprecated } from './deprecated/screen-reboot-active.svg';
import { default as SCREEN_REBOOT_ACTIVE_rebranded } from './rebranded/screen-reboot-active.svg';
export const SVG_SCREEN_REBOOT_INACTIVE = 'SCREEN_REBOOT_INACTIVE';
import { default as SCREEN_REBOOT_INACTIVE_deprecated } from './deprecated/screen-reboot-inactive.svg';
import { default as SCREEN_REBOOT_INACTIVE_rebranded } from './rebranded/screen-reboot-inactive.svg';
export const SVG_SCREEN_RUN_ACTIVE = 'SCREEN_RUN_ACTIVE';
import { default as SCREEN_RUN_ACTIVE_deprecated } from './deprecated/screen-run-active.svg';
import { default as SCREEN_RUN_ACTIVE_rebranded } from './rebranded/screen-run-active.svg';
export const SVG_SCREEN_RUN_INACTIVE = 'SCREEN_RUN_INACTIVE';
import { default as SCREEN_RUN_INACTIVE_deprecated } from './deprecated/screen-run-inactive.svg';
import { default as SCREEN_RUN_INACTIVE_rebranded } from './rebranded/screen-run-inactive.svg';
export const SVG_SCREEN_SHARING = 'SCREEN_SHARING';
import { default as SCREEN_SHARING_deprecated } from './deprecated/screen-sharing.svg';
import { default as SCREEN_SHARING_rebranded } from './rebranded/screen-sharing.svg';
export const SVG_SCREEN_SNAPSHOT_ACTIVE = 'SCREEN_SNAPSHOT_ACTIVE';
import { default as SCREEN_SNAPSHOT_ACTIVE_deprecated } from './deprecated/screen-snapshot-active.svg';
import { default as SCREEN_SNAPSHOT_ACTIVE_rebranded } from './rebranded/screen-snapshot-active.svg';
export const SVG_SCREEN_SNAPSHOT_INACTIVE = 'SCREEN_SNAPSHOT_INACTIVE';
import { default as SCREEN_SNAPSHOT_INACTIVE_deprecated } from './deprecated/screen-snapshot-inactive.svg';
import { default as SCREEN_SNAPSHOT_INACTIVE_rebranded } from './rebranded/screen-snapshot-inactive.svg';
export const SVG_SCREEN_STOP_REMOTE_ACTIVE = 'SCREEN_STOP_REMOTE_ACTIVE';
import { default as SCREEN_STOP_REMOTE_ACTIVE_deprecated } from './deprecated/screen-stop-remote-active.svg';
import { default as SCREEN_STOP_REMOTE_ACTIVE_rebranded } from './rebranded/screen-stop-remote-active.svg';
export const SVG_SCREEN_STOP_REMOTE_INACTIVE = 'SCREEN_STOP_REMOTE_INACTIVE';
import { default as SCREEN_STOP_REMOTE_INACTIVE_deprecated } from './deprecated/screen-stop-remote-inactive.svg';
import { default as SCREEN_STOP_REMOTE_INACTIVE_rebranded } from './rebranded/screen-stop-remote-inactive.svg';
export const SVG_SCREEN_SYSTEM_INFO_ACTIVE = 'SCREEN_SYSTEM_INFO_ACTIVE';
import { default as SCREEN_SYSTEM_INFO_ACTIVE_deprecated } from './deprecated/screen-system-info-active.svg';
import { default as SCREEN_SYSTEM_INFO_ACTIVE_rebranded } from './rebranded/screen-system-info-active.svg';
export const SVG_SCREEN_UNATTENDED_ACTIVE = 'SCREEN_UNATTENDED_ACTIVE';
import { default as SCREEN_UNATTENDED_ACTIVE_deprecated } from './deprecated/screen-unattended-active.svg';
import { default as SCREEN_UNATTENDED_ACTIVE_rebranded } from './rebranded/screen-unattended-active.svg';
export const SVG_SCREEN_SYSTEM_INFO_INACTIVE = 'SCREEN_SYSTEM_INFO_INACTIVE';
import { default as SCREEN_SYSTEM_INFO_INACTIVE_deprecated } from './deprecated/screen-system-info-inactive.svg';
import { default as SCREEN_SYSTEM_INFO_INACTIVE_rebranded } from './rebranded/screen-system-info-inactive.svg';
export const SVG_SCREEN_UNATTENDED_INACTIVE = 'SCREEN_UNATTENDED_INACTIVE';
import { default as SCREEN_UNATTENDED_INACTIVE_deprecated } from './deprecated/screen-unattended-inactive.svg';
import { default as SCREEN_UNATTENDED_INACTIVE_rebranded } from './rebranded/screen-unattended-inactive.svg';
export const SVG_SEARCH = 'SEARCH';
import { default as SEARCH_deprecated } from './deprecated/search.svg';
import { default as SEARCH_rebranded } from './rebranded/search.svg';
export const SVG_SEE_IT = 'SEE_IT';
import { default as SEE_IT_deprecated } from './deprecated/see-it.svg';
import { default as SEE_IT_rebranded } from './rebranded/see-it.svg';
export const SVG_SEND_LARGE_ACTIVE = 'SEND_LARGE_ACTIVE';
import { default as SEND_LARGE_ACTIVE_deprecated } from './deprecated/send-large-active.svg';
import { default as SEND_LARGE_ACTIVE_rebranded } from './rebranded/send-large-active.svg';
export const SVG_SEND_LARGE_INACTIVE = 'SEND_LARGE_INACTIVE';
import { default as SEND_LARGE_INACTIVE_deprecated } from './deprecated/send-large-inactive.svg';
import { default as SEND_LARGE_INACTIVE_rebranded } from './rebranded/send-large-inactive.svg';
export const SVG_SERVER_ACTIVE = 'SERVER_ACTIVE';
import { default as SERVER_ACTIVE_deprecated } from './deprecated/server-active.svg';
import { default as SERVER_ACTIVE_rebranded } from './rebranded/server-active.svg';
export const SVG_SERVER_INACTIVE = 'SERVER_INACTIVE';
import { default as SERVER_INACTIVE_deprecated } from './deprecated/server-inactive.svg';
import { default as SERVER_INACTIVE_rebranded } from './rebranded/server-inactive.svg';
export const SVG_SETTINGS_ACTIVE = 'SETTINGS_ACTIVE';
import { default as SETTINGS_ACTIVE_deprecated } from './deprecated/settings-active.svg';
import { default as SETTINGS_ACTIVE_rebranded } from './rebranded/settings-active.svg';
export const SVG_SETTINGS_INACTIVE = 'SETTINGS_INACTIVE';
import { default as SETTINGS_INACTIVE_deprecated } from './deprecated/settings-inactive.svg';
import { default as SETTINGS_INACTIVE_rebranded } from './rebranded/settings-inactive.svg';
export const SVG_SHARE_20_PX = 'SHARE_20_PX';
import { default as SHARE_20_PX_deprecated } from './deprecated/share-20-px.svg';
import { default as SHARE_20_PX_rebranded } from './rebranded/share-20-px.svg';
export const SVG_SHARE_ARROW = 'SHARE_ARROW';
import { default as SHARE_ARROW_deprecated } from './deprecated/share-arrow.svg';
import { default as SHARE_ARROW_rebranded } from './rebranded/share-arrow.svg';
export const SVG_SHARE = 'SHARE';
import { default as SHARE_deprecated } from './deprecated/share.svg';
import { default as SHARE_rebranded } from './rebranded/share.svg';
export const SVG_SHIELD_ACTIVE = 'SHIELD_ACTIVE';
import { default as SHIELD_ACTIVE_deprecated } from './deprecated/shield-active.svg';
import { default as SHIELD_ACTIVE_rebranded } from './rebranded/shield-active.svg';
export const SVG_SHIELD_INACTIVE = 'SHIELD_INACTIVE';
import { default as SHIELD_INACTIVE_deprecated } from './deprecated/shield-inactive.svg';
import { default as SHIELD_INACTIVE_rebranded } from './rebranded/shield-inactive.svg';
export const SVG_SHUFFLE = 'SHUFFLE';
import { default as SHUFFLE_deprecated } from './deprecated/shuffle.svg';
import { default as SHUFFLE_rebranded } from './rebranded/shuffle.svg';
export const SVG_SIGNAL_0 = 'SIGNAL_0';
import { default as SIGNAL_0_deprecated } from './deprecated/signal-0.svg';
import { default as SIGNAL_0_rebranded } from './rebranded/signal-0.svg';
export const SVG_SIGNAL_1 = 'SIGNAL_1';
import { default as SIGNAL_1_deprecated } from './deprecated/signal-1.svg';
import { default as SIGNAL_1_rebranded } from './rebranded/signal-1.svg';
export const SVG_SIGNAL_3 = 'SIGNAL_3';
import { default as SIGNAL_3_deprecated } from './deprecated/signal-3.svg';
import { default as SIGNAL_3_rebranded } from './rebranded/signal-3.svg';
export const SVG_SIGNAL_2 = 'SIGNAL_2';
import { default as SIGNAL_2_deprecated } from './deprecated/signal-2.svg';
import { default as SIGNAL_2_rebranded } from './rebranded/signal-2.svg';
export const SVG_SIGNAL_STRENGTH_0 = 'SIGNAL_STRENGTH_0';
import { default as SIGNAL_STRENGTH_0_deprecated } from './deprecated/signal-strength-0.svg';
import { default as SIGNAL_STRENGTH_0_rebranded } from './rebranded/signal-strength-0.svg';
export const SVG_SIGNAL_STRENGTH_1 = 'SIGNAL_STRENGTH_1';
import { default as SIGNAL_STRENGTH_1_deprecated } from './deprecated/signal-strength-1.svg';
import { default as SIGNAL_STRENGTH_1_rebranded } from './rebranded/signal-strength-1.svg';
export const SVG_SIGNAL_STRENGTH_2 = 'SIGNAL_STRENGTH_2';
import { default as SIGNAL_STRENGTH_2_deprecated } from './deprecated/signal-strength-2.svg';
import { default as SIGNAL_STRENGTH_2_rebranded } from './rebranded/signal-strength-2.svg';
export const SVG_SIGNAL_STRENGTH_3 = 'SIGNAL_STRENGTH_3';
import { default as SIGNAL_STRENGTH_3_deprecated } from './deprecated/signal-strength-3.svg';
import { default as SIGNAL_STRENGTH_3_rebranded } from './rebranded/signal-strength-3.svg';
export const SVG_SIGNAL_STRENGTH_4 = 'SIGNAL_STRENGTH_4';
import { default as SIGNAL_STRENGTH_4_deprecated } from './deprecated/signal-strength-4.svg';
import { default as SIGNAL_STRENGTH_4_rebranded } from './rebranded/signal-strength-4.svg';
export const SVG_SIGNOUT = 'SIGNOUT';
import { default as SIGNOUT_deprecated } from './deprecated/signout.svg';
import { default as SIGNOUT_rebranded } from './rebranded/signout.svg';
export const SVG_SKETCH = 'SKETCH';
import { default as SKETCH_deprecated } from './deprecated/sketch.svg';
import { default as SKETCH_rebranded } from './rebranded/sketch.svg';
export const SVG_SLIDERS_ACTIVE = 'SLIDERS_ACTIVE';
import { default as SLIDERS_ACTIVE_deprecated } from './deprecated/sliders-active.svg';
import { default as SLIDERS_ACTIVE_rebranded } from './rebranded/sliders-active.svg';
export const SVG_SLIDERS_INACTIVE = 'SLIDERS_INACTIVE';
import { default as SLIDERS_INACTIVE_deprecated } from './deprecated/sliders-inactive.svg';
import { default as SLIDERS_INACTIVE_rebranded } from './rebranded/sliders-inactive.svg';
export const SVG_SMALL_ARROW_DOWN = 'SMALL_ARROW_DOWN';
import { default as SMALL_ARROW_DOWN_deprecated } from './deprecated/small-arrow-down.svg';
import { default as SMALL_ARROW_DOWN_rebranded } from './rebranded/small-arrow-down.svg';
export const SVG_SMALL_ARROW_LEFT = 'SMALL_ARROW_LEFT';
import { default as SMALL_ARROW_LEFT_deprecated } from './deprecated/small-arrow-left.svg';
import { default as SMALL_ARROW_LEFT_rebranded } from './rebranded/small-arrow-left.svg';
export const SVG_SMALL_ARROW_RIGHT = 'SMALL_ARROW_RIGHT';
import { default as SMALL_ARROW_RIGHT_deprecated } from './deprecated/small-arrow-right.svg';
import { default as SMALL_ARROW_RIGHT_rebranded } from './rebranded/small-arrow-right.svg';
export const SVG_SMALL_ARROW_UP = 'SMALL_ARROW_UP';
import { default as SMALL_ARROW_UP_deprecated } from './deprecated/small-arrow-up.svg';
import { default as SMALL_ARROW_UP_rebranded } from './rebranded/small-arrow-up.svg';
export const SVG_SMARTPHONE = 'SMARTPHONE';
import { default as SMARTPHONE_deprecated } from './deprecated/smartphone.svg';
import { default as SMARTPHONE_rebranded } from './rebranded/smartphone.svg';
export const SVG_SNOOZE = 'SNOOZE';
import { default as SNOOZE_deprecated } from './deprecated/snooze.svg';
import { default as SNOOZE_rebranded } from './rebranded/snooze.svg';
export const SVG_SPACES_ACTIVE = 'SPACES_ACTIVE';
import { default as SPACES_ACTIVE_deprecated } from './deprecated/spaces-active.svg';
import { default as SPACES_ACTIVE_rebranded } from './rebranded/spaces-active.svg';
export const SVG_SPACES_INACTIVE = 'SPACES_INACTIVE';
import { default as SPACES_INACTIVE_deprecated } from './deprecated/spaces-inactive.svg';
import { default as SPACES_INACTIVE_rebranded } from './rebranded/spaces-inactive.svg';
export const SVG_SPEAKER_20_PX = 'SPEAKER_20_PX';
import { default as SPEAKER_20_PX_deprecated } from './deprecated/speaker-20-px.svg';
import { default as SPEAKER_20_PX_rebranded } from './rebranded/speaker-20-px.svg';
export const SVG_SPEAKER_OFF_ACTIVE = 'SPEAKER_OFF_ACTIVE';
import { default as SPEAKER_OFF_ACTIVE_deprecated } from './deprecated/speaker-off-active.svg';
import { default as SPEAKER_OFF_ACTIVE_rebranded } from './rebranded/speaker-off-active.svg';
export const SVG_SPEAKER_OFF_INACTIVE = 'SPEAKER_OFF_INACTIVE';
import { default as SPEAKER_OFF_INACTIVE_deprecated } from './deprecated/speaker-off-inactive.svg';
import { default as SPEAKER_OFF_INACTIVE_rebranded } from './rebranded/speaker-off-inactive.svg';
export const SVG_SPEAKER_ON_ACTIVE = 'SPEAKER_ON_ACTIVE';
import { default as SPEAKER_ON_ACTIVE_deprecated } from './deprecated/speaker-on-active.svg';
import { default as SPEAKER_ON_ACTIVE_rebranded } from './rebranded/speaker-on-active.svg';
export const SVG_SPEAKER_ON_INACTIVE = 'SPEAKER_ON_INACTIVE';
import { default as SPEAKER_ON_INACTIVE_deprecated } from './deprecated/speaker-on-inactive.svg';
import { default as SPEAKER_ON_INACTIVE_rebranded } from './rebranded/speaker-on-inactive.svg';
export const SVG_SPEAKING_20_PX = 'SPEAKING_20_PX';
import { default as SPEAKING_20_PX_deprecated } from './deprecated/speaking-20-px.svg';
import { default as SPEAKING_20_PX_rebranded } from './rebranded/speaking-20-px.svg';
export const SVG_SPEAKING = 'SPEAKING';
import { default as SPEAKING_deprecated } from './deprecated/speaking.svg';
import { default as SPEAKING_rebranded } from './rebranded/speaking.svg';
export const SVG_STAR_EMPTY = 'STAR_EMPTY';
import { default as STAR_EMPTY_deprecated } from './deprecated/star-empty.svg';
import { default as STAR_EMPTY_rebranded } from './rebranded/star-empty.svg';
export const SVG_STAR_FILLED = 'STAR_FILLED';
import { default as STAR_FILLED_deprecated } from './deprecated/star-filled.svg';
import { default as STAR_FILLED_rebranded } from './rebranded/star-filled.svg';
export const SVG_STAR_HALF_FILLED = 'STAR_HALF_FILLED';
import { default as STAR_HALF_FILLED_deprecated } from './deprecated/star-half-filled.svg';
import { default as STAR_HALF_FILLED_rebranded } from './rebranded/star-half-filled.svg';
export const SVG_STOP_20_PX = 'STOP_20_PX';
import { default as STOP_20_PX_deprecated } from './deprecated/stop-20-px.svg';
import { default as STOP_20_PX_rebranded } from './rebranded/stop-20-px.svg';
export const SVG_STAR = 'STAR';
import { default as STAR_deprecated } from './deprecated/star.svg';
import { default as STAR_rebranded } from './rebranded/star.svg';
export const SVG_STOP_ACTIVE = 'STOP_ACTIVE';
import { default as STOP_ACTIVE_deprecated } from './deprecated/stop-active.svg';
import { default as STOP_ACTIVE_rebranded } from './rebranded/stop-active.svg';
export const SVG_STOP_INACTIVE = 'STOP_INACTIVE';
import { default as STOP_INACTIVE_deprecated } from './deprecated/stop-inactive.svg';
import { default as STOP_INACTIVE_rebranded } from './rebranded/stop-inactive.svg';
export const SVG_STRETCHING_COLLAPSE = 'STRETCHING_COLLAPSE';
import { default as STRETCHING_COLLAPSE_deprecated } from './deprecated/stretching-collapse.svg';
import { default as STRETCHING_COLLAPSE_rebranded } from './rebranded/stretching-collapse.svg';
export const SVG_STRETCHING_EXIT_FULLSCREEN = 'STRETCHING_EXIT_FULLSCREEN';
import { default as STRETCHING_EXIT_FULLSCREEN_deprecated } from './deprecated/stretching-exit-fullscreen.svg';
import { default as STRETCHING_EXIT_FULLSCREEN_rebranded } from './rebranded/stretching-exit-fullscreen.svg';
export const SVG_STRETCHING_EXPAND = 'STRETCHING_EXPAND';
import { default as STRETCHING_EXPAND_deprecated } from './deprecated/stretching-expand.svg';
import { default as STRETCHING_EXPAND_rebranded } from './rebranded/stretching-expand.svg';
export const SVG_STRETCHING_FULLSCREEN = 'STRETCHING_FULLSCREEN';
import { default as STRETCHING_FULLSCREEN_deprecated } from './deprecated/stretching-fullscreen.svg';
import { default as STRETCHING_FULLSCREEN_rebranded } from './rebranded/stretching-fullscreen.svg';
export const SVG_SUBTRACT = 'SUBTRACT';
import { default as SUBTRACT_deprecated } from './deprecated/subtract.svg';
import { default as SUBTRACT_rebranded } from './rebranded/subtract.svg';
export const SVG_SWAP = 'SWAP';
import { default as SWAP_deprecated } from './deprecated/swap.svg';
import { default as SWAP_rebranded } from './rebranded/swap.svg';
export const SVG_SYNC = 'SYNC';
import { default as SYNC_deprecated } from './deprecated/sync.svg';
import { default as SYNC_rebranded } from './rebranded/sync.svg';
export const SVG_SYNCHRONIZED = 'SYNCHRONIZED';
import { default as SYNCHRONIZED_deprecated } from './deprecated/synchronized.svg';
import { default as SYNCHRONIZED_rebranded } from './rebranded/synchronized.svg';
export const SVG_TABLET_CHEVRON = 'TABLET_CHEVRON';
import { default as TABLET_CHEVRON_deprecated } from './deprecated/tablet-chevron.svg';
import { default as TABLET_CHEVRON_rebranded } from './rebranded/tablet-chevron.svg';
export const SVG_TAG = 'TAG';
import { default as TAG_deprecated } from './deprecated/tag.svg';
import { default as TAG_rebranded } from './rebranded/tag.svg';
export const SVG_TEST_ACTIVE = 'TEST_ACTIVE';
import { default as TEST_ACTIVE_deprecated } from './deprecated/test-active.svg';
import { default as TEST_ACTIVE_rebranded } from './rebranded/test-active.svg';
export const SVG_TEST_INACTIVE = 'TEST_INACTIVE';
import { default as TEST_INACTIVE_deprecated } from './deprecated/test-inactive.svg';
import { default as TEST_INACTIVE_rebranded } from './rebranded/test-inactive.svg';
export const SVG_TEXT_FIELD = 'TEXT_FIELD';
import { default as TEXT_FIELD_deprecated } from './deprecated/text-field.svg';
import { default as TEXT_FIELD_rebranded } from './rebranded/text-field.svg';
export const SVG_TEXT = 'TEXT';
import { default as TEXT_deprecated } from './deprecated/text.svg';
import { default as TEXT_rebranded } from './rebranded/text.svg';
export const SVG_THEMES = 'THEMES';
import { default as THEMES_deprecated } from './deprecated/themes.svg';
import { default as THEMES_rebranded } from './rebranded/themes.svg';
export const SVG_THUMBS_DOWN_ACTIVE = 'THUMBS_DOWN_ACTIVE';
import { default as THUMBS_DOWN_ACTIVE_deprecated } from './deprecated/thumbs-down-active.svg';
import { default as THUMBS_DOWN_ACTIVE_rebranded } from './rebranded/thumbs-down-active.svg';
export const SVG_THUMBS_DOWN_INACTIVE = 'THUMBS_DOWN_INACTIVE';
import { default as THUMBS_DOWN_INACTIVE_deprecated } from './deprecated/thumbs-down-inactive.svg';
import { default as THUMBS_DOWN_INACTIVE_rebranded } from './rebranded/thumbs-down-inactive.svg';
export const SVG_THUMBS_UP_ACTIVE = 'THUMBS_UP_ACTIVE';
import { default as THUMBS_UP_ACTIVE_deprecated } from './deprecated/thumbs-up-active.svg';
import { default as THUMBS_UP_ACTIVE_rebranded } from './rebranded/thumbs-up-active.svg';
export const SVG_THUMBS_UP_INACTIVE = 'THUMBS_UP_INACTIVE';
import { default as THUMBS_UP_INACTIVE_deprecated } from './deprecated/thumbs-up-inactive.svg';
import { default as THUMBS_UP_INACTIVE_rebranded } from './rebranded/thumbs-up-inactive.svg';
export const SVG_TIME_LIMITATION = 'TIME_LIMITATION';
import { default as TIME_LIMITATION_deprecated } from './deprecated/time-limitation.svg';
import { default as TIME_LIMITATION_rebranded } from './rebranded/time-limitation.svg';
export const SVG_TRANSFER_CONVERSATION_ACTIVE = 'TRANSFER_CONVERSATION_ACTIVE';
import { default as TRANSFER_CONVERSATION_ACTIVE_deprecated } from './deprecated/transfer-conversation-active.svg';
import { default as TRANSFER_CONVERSATION_ACTIVE_rebranded } from './rebranded/transfer-conversation-active.svg';
export const SVG_TRANSFER_CONVERSATION_INACTIVE = 'TRANSFER_CONVERSATION_INACTIVE';
import { default as TRANSFER_CONVERSATION_INACTIVE_deprecated } from './deprecated/transfer-conversation-inactive.svg';
import { default as TRANSFER_CONVERSATION_INACTIVE_rebranded } from './rebranded/transfer-conversation-inactive.svg';
export const SVG_TRASH_ACTIVE = 'TRASH_ACTIVE';
import { default as TRASH_ACTIVE_deprecated } from './deprecated/trash-active.svg';
import { default as TRASH_ACTIVE_rebranded } from './rebranded/trash-active.svg';
export const SVG_TRASH_INACTIVE = 'TRASH_INACTIVE';
import { default as TRASH_INACTIVE_deprecated } from './deprecated/trash-inactive.svg';
import { default as TRASH_INACTIVE_rebranded } from './rebranded/trash-inactive.svg';
export const SVG_UBUNTU = 'UBUNTU';
import { default as UBUNTU_deprecated } from './deprecated/ubuntu.svg';
import { default as UBUNTU_rebranded } from './rebranded/ubuntu.svg';
export const SVG_TRENDING = 'TRENDING';
import { default as TRENDING_deprecated } from './deprecated/trending.svg';
import { default as TRENDING_rebranded } from './rebranded/trending.svg';
export const SVG_UNLOCKED_ACTIVE_20_PX = 'UNLOCKED_ACTIVE_20_PX';
import { default as UNLOCKED_ACTIVE_20_PX_deprecated } from './deprecated/unlocked-active-20-px.svg';
import { default as UNLOCKED_ACTIVE_20_PX_rebranded } from './rebranded/unlocked-active-20-px.svg';
export const SVG_UNDO = 'UNDO';
import { default as UNDO_deprecated } from './deprecated/undo.svg';
import { default as UNDO_rebranded } from './rebranded/undo.svg';
export const SVG_UPLOAD = 'UPLOAD';
import { default as UPLOAD_deprecated } from './deprecated/upload.svg';
import { default as UPLOAD_rebranded } from './rebranded/upload.svg';
export const SVG_UNLOCKED_ACTIVE = 'UNLOCKED_ACTIVE';
import { default as UNLOCKED_ACTIVE_deprecated } from './deprecated/unlocked-active.svg';
import { default as UNLOCKED_ACTIVE_rebranded } from './rebranded/unlocked-active.svg';
export const SVG_VECTOR = 'VECTOR';
import { default as VECTOR_deprecated } from './deprecated/vector.svg';
import { default as VECTOR_rebranded } from './rebranded/vector.svg';
export const SVG_USB_C = 'USB_C';
import { default as USB_C_deprecated } from './deprecated/usb-c.svg';
import { default as USB_C_rebranded } from './rebranded/usb-c.svg';
export const SVG_VIEW_SWITCH_ACTIVE_CAMERAS = 'VIEW_SWITCH_ACTIVE_CAMERAS';
import { default as VIEW_SWITCH_ACTIVE_CAMERAS_deprecated } from './deprecated/view-switch-active-cameras.svg';
import { default as VIEW_SWITCH_ACTIVE_CAMERAS_rebranded } from './rebranded/view-switch-active-cameras.svg';
export const SVG_VIEW_GRID = 'VIEW_GRID';
import { default as VIEW_GRID_deprecated } from './deprecated/view-grid.svg';
import { default as VIEW_GRID_rebranded } from './rebranded/view-grid.svg';
export const SVG_VIEW_SWITCH_EVERYONE = 'VIEW_SWITCH_EVERYONE';
import { default as VIEW_SWITCH_EVERYONE_deprecated } from './deprecated/view-switch-everyone.svg';
import { default as VIEW_SWITCH_EVERYONE_rebranded } from './rebranded/view-switch-everyone.svg';
export const SVG_VIEW_SWITCH_FILMSTRIP = 'VIEW_SWITCH_FILMSTRIP';
import { default as VIEW_SWITCH_FILMSTRIP_deprecated } from './deprecated/view-switch-filmstrip.svg';
import { default as VIEW_SWITCH_FILMSTRIP_rebranded } from './rebranded/view-switch-filmstrip.svg';
export const SVG_VIEW_SWITCH_PORTRAIT = 'VIEW_SWITCH_PORTRAIT';
import { default as VIEW_SWITCH_PORTRAIT_deprecated } from './deprecated/view-switch-portrait.svg';
import { default as VIEW_SWITCH_PORTRAIT_rebranded } from './rebranded/view-switch-portrait.svg';
export const SVG_VIEWS_ACTIVE = 'VIEWS_ACTIVE';
import { default as VIEWS_ACTIVE_deprecated } from './deprecated/views-active.svg';
import { default as VIEWS_ACTIVE_rebranded } from './rebranded/views-active.svg';
export const SVG_VIEWS_INACTIVE = 'VIEWS_INACTIVE';
import { default as VIEWS_INACTIVE_deprecated } from './deprecated/views-inactive.svg';
import { default as VIEWS_INACTIVE_rebranded } from './rebranded/views-inactive.svg';
export const SVG_VIEW_SWITCH_HIDEALL = 'VIEW_SWITCH_HIDEALL';
import { default as VIEW_SWITCH_HIDEALL_deprecated } from './deprecated/view-switch-hideall.svg';
import { default as VIEW_SWITCH_HIDEALL_rebranded } from './rebranded/view-switch-hideall.svg';
export const SVG_VIMEO = 'VIMEO';
import { default as VIMEO_deprecated } from './deprecated/vimeo.svg';
import { default as VIMEO_rebranded } from './rebranded/vimeo.svg';
export const SVG_VISA = 'VISA';
import { default as VISA_deprecated } from './deprecated/visa.svg';
import { default as VISA_rebranded } from './rebranded/visa.svg';
export const SVG_VISIBILITY_ENABLED_ACTIVE = 'VISIBILITY_ENABLED_ACTIVE';
import { default as VISIBILITY_ENABLED_ACTIVE_deprecated } from './deprecated/visibility-enabled-active.svg';
import { default as VISIBILITY_ENABLED_ACTIVE_rebranded } from './rebranded/visibility-enabled-active.svg';
export const SVG_VISIBILITY_DISABLED_INACTIVE = 'VISIBILITY_DISABLED_INACTIVE';
import { default as VISIBILITY_DISABLED_INACTIVE_deprecated } from './deprecated/visibility-disabled-inactive.svg';
import { default as VISIBILITY_DISABLED_INACTIVE_rebranded } from './rebranded/visibility-disabled-inactive.svg';
export const SVG_VOICEMAIL_READ = 'VOICEMAIL_READ';
import { default as VOICEMAIL_READ_deprecated } from './deprecated/voicemail-read.svg';
import { default as VOICEMAIL_READ_rebranded } from './rebranded/voicemail-read.svg';
export const SVG_VOICEMAIL_UNREAD = 'VOICEMAIL_UNREAD';
import { default as VOICEMAIL_UNREAD_deprecated } from './deprecated/voicemail-unread.svg';
import { default as VOICEMAIL_UNREAD_rebranded } from './rebranded/voicemail-unread.svg';
export const SVG_VOIP_PAUSE = 'VOIP_PAUSE';
import { default as VOIP_PAUSE_deprecated } from './deprecated/voip-pause.svg';
import { default as VOIP_PAUSE_rebranded } from './rebranded/voip-pause.svg';
export const SVG_VOICEMAIL = 'VOICEMAIL';
import { default as VOICEMAIL_deprecated } from './deprecated/voicemail.svg';
import { default as VOICEMAIL_rebranded } from './rebranded/voicemail.svg';
export const SVG_VOIP = 'VOIP';
import { default as VOIP_deprecated } from './deprecated/voip.svg';
import { default as VOIP_rebranded } from './rebranded/voip.svg';
export const SVG_WEB = 'WEB';
import { default as WEB_deprecated } from './deprecated/web.svg';
import { default as WEB_rebranded } from './rebranded/web.svg';
export const SVG_WEBCAM_OFF_ACTIVE = 'WEBCAM_OFF_ACTIVE';
import { default as WEBCAM_OFF_ACTIVE_deprecated } from './deprecated/webcam-off-active.svg';
import { default as WEBCAM_OFF_ACTIVE_rebranded } from './rebranded/webcam-off-active.svg';
export const SVG_WEBCAM_ON_ACTIVE = 'WEBCAM_ON_ACTIVE';
import { default as WEBCAM_ON_ACTIVE_deprecated } from './deprecated/webcam-on-active.svg';
import { default as WEBCAM_ON_ACTIVE_rebranded } from './rebranded/webcam-on-active.svg';
export const SVG_WEBCAM_OFF_INACTIVE = 'WEBCAM_OFF_INACTIVE';
import { default as WEBCAM_OFF_INACTIVE_deprecated } from './deprecated/webcam-off-inactive.svg';
import { default as WEBCAM_OFF_INACTIVE_rebranded } from './rebranded/webcam-off-inactive.svg';
export const SVG_WEBCAM_ON_INACTIVE = 'WEBCAM_ON_INACTIVE';
import { default as WEBCAM_ON_INACTIVE_deprecated } from './deprecated/webcam-on-inactive.svg';
import { default as WEBCAM_ON_INACTIVE_rebranded } from './rebranded/webcam-on-inactive.svg';
export const SVG_WHISPER = 'WHISPER';
import { default as WHISPER_deprecated } from './deprecated/whisper.svg';
import { default as WHISPER_rebranded } from './rebranded/whisper.svg';
export const SVG_WHITEBOARD_INACTIVE = 'WHITEBOARD_INACTIVE';
import { default as WHITEBOARD_INACTIVE_deprecated } from './deprecated/whiteboard-inactive.svg';
import { default as WHITEBOARD_INACTIVE_rebranded } from './rebranded/whiteboard-inactive.svg';
export const SVG_WHITEBOARD_ACTIVE = 'WHITEBOARD_ACTIVE';
import { default as WHITEBOARD_ACTIVE_deprecated } from './deprecated/whiteboard-active.svg';
import { default as WHITEBOARD_ACTIVE_rebranded } from './rebranded/whiteboard-active.svg';
export const SVG_WHITEBOARD = 'WHITEBOARD';
import { default as WHITEBOARD_deprecated } from './deprecated/whiteboard.svg';
import { default as WHITEBOARD_rebranded } from './rebranded/whiteboard.svg';
export const SVG_WIFI_ACTIVE = 'WIFI_ACTIVE';
import { default as WIFI_ACTIVE_deprecated } from './deprecated/wifi-active.svg';
import { default as WIFI_ACTIVE_rebranded } from './rebranded/wifi-active.svg';
export const SVG_WIFI_INACTIVE = 'WIFI_INACTIVE';
import { default as WIFI_INACTIVE_deprecated } from './deprecated/wifi-inactive.svg';
import { default as WIFI_INACTIVE_rebranded } from './rebranded/wifi-inactive.svg';
export const SVG_WINDOWS = 'WINDOWS';
import { default as WINDOWS_deprecated } from './deprecated/windows.svg';
import { default as WINDOWS_rebranded } from './rebranded/windows.svg';
export const SVG_WRENCH_ACTIVE = 'WRENCH_ACTIVE';
import { default as WRENCH_ACTIVE_deprecated } from './deprecated/wrench-active.svg';
import { default as WRENCH_ACTIVE_rebranded } from './rebranded/wrench-active.svg';
export const SVG_WRENCH_INACTIVE = 'WRENCH_INACTIVE';
import { default as WRENCH_INACTIVE_deprecated } from './deprecated/wrench-inactive.svg';
import { default as WRENCH_INACTIVE_rebranded } from './rebranded/wrench-inactive.svg';
export const SVG_YUAN = 'YUAN';
import { default as YUAN_deprecated } from './deprecated/yuan.svg';
import { default as YUAN_rebranded } from './rebranded/yuan.svg';
export const SVG_ZIP = 'ZIP';
import { default as ZIP_deprecated } from './deprecated/zip.svg';
import { default as ZIP_rebranded } from './rebranded/zip.svg';
export const SVG_ZOOM_IN_ACTIVE = 'ZOOM_IN_ACTIVE';
import { default as ZOOM_IN_ACTIVE_deprecated } from './deprecated/zoom-in-active.svg';
import { default as ZOOM_IN_ACTIVE_rebranded } from './rebranded/zoom-in-active.svg';
export const SVG_ZOOM_OUT_ACTIVE = 'ZOOM_OUT_ACTIVE';
import { default as ZOOM_OUT_ACTIVE_deprecated } from './deprecated/zoom-out-active.svg';
import { default as ZOOM_OUT_ACTIVE_rebranded } from './rebranded/zoom-out-active.svg';
export const SVG_ZOOM_IN_INACTIVE = 'ZOOM_IN_INACTIVE';
import { default as ZOOM_IN_INACTIVE_deprecated } from './deprecated/zoom-in-inactive.svg';
import { default as ZOOM_IN_INACTIVE_rebranded } from './rebranded/zoom-in-inactive.svg';
export const SVG_ZOOM_OUT_INACTIVE = 'ZOOM_OUT_INACTIVE';
import { default as ZOOM_OUT_INACTIVE_deprecated } from './deprecated/zoom-out-inactive.svg';
import { default as ZOOM_OUT_INACTIVE_rebranded } from './rebranded/zoom-out-inactive.svg';
export const SVG_UNLOCKED_INACTIVE = 'UNLOCKED_INACTIVE';
import { default as UNLOCKED_INACTIVE_deprecated } from './deprecated/unlocked-inactive.svg';
import { default as UNLOCKED_INACTIVE_rebranded } from './rebranded/unlocked-inactive.svg';
export const SVG_UNLOCKED_INACTIVE_20_PX = 'UNLOCKED_INACTIVE_20_PX';
import { default as UNLOCKED_INACTIVE_20_PX_rebranded } from './rebranded/unlocked-inactive-20-px.svg';
import { default as UNLOCKED_INACTIVE_20_PX_deprecated } from './deprecated/unlocked-inactive-20-px.svg';
export const IconIds = {ACCESSIBILITY_deprecated,
ADD_ACTIVE_deprecated,
ADD_CIRCLE_ACTIVE_deprecated,
ADD_CIRCLE_INACTIVE_deprecated,
ADD_INACTIVE_deprecated,
ADD_PERSON_ACTIVE_deprecated,
ADD_PERSON_INACTIVE_deprecated,
ADD_deprecated,
ADDRESS_BOOK_CONTACTS_ACTIVE_deprecated,
ADDRESS_BOOK_CONTACTS_INACTIVE_deprecated,
ADDRESSES_ACTIVE_deprecated,
ADDRESSES_INACTIVE_deprecated,
ADJUST_CAMERA_deprecated,
ADJUSTMENTS_deprecated,
ADMIN_ACTIVE_deprecated,
ADMIN_INACTIVE_deprecated,
ADOBE_deprecated,
ALERT_ACTIVE_deprecated,
ALERT_INACTIVE_deprecated,
ANDROID_deprecated,
AMEX_deprecated,
ANNOTATION_ACTIVE_deprecated,
APP_SWITCHER_deprecated,
APPLE_MONOCHROMATIC_deprecated,
ARCHIVE_ACTIVE_deprecated,
ARCHIVE_INACTIVE_deprecated,
ARROW_DOWN_deprecated,
ARROW_LEFT_deprecated,
ARROW_RIGHT_deprecated,
ARROW_UP_deprecated,
ASSISTANCE_ACTIVE_deprecated,
ASSISTANCE_INACTIVE_deprecated,
AUDIO_OFF_20_PX_deprecated,
BACKSPACE_deprecated,
BADGE_INACTIVE_deprecated,
BADGE_ACTIVE_deprecated,
BATTERY_LOW_deprecated,
BATTERY_FULL_deprecated,
BATTERY_MID_deprecated,
BELL_ACTIVE_deprecated,
BELL_DISABLED_INACTIVE_deprecated,
BELL_DISABLED_ACTIVE_deprecated,
BELL_INACTIVE_deprecated,
BLOCK_deprecated,
BLUETOOTH_deprecated,
BLUETOOTH_CONNECTED_deprecated,
BOOKMARK_ACTIVE_deprecated,
BOOKMARK_INACTIVE_deprecated,
BRAVE_deprecated,
BREAKOUT_ROOM_deprecated,
BRIGHTNESS_deprecated,
BUG_ACTIVE_deprecated,
BUG_INACTIVE_deprecated,
BULB_ACTIVE_deprecated,
BULB_INACTIVE_deprecated,
BUSINESS_ACTIVE_deprecated,
BUSINESS_INACTIVE_deprecated,
CALCULATOR_ACTIVE_deprecated,
CALCULATOR_INACTIVE_deprecated,
CALENDAR_ACTIVE_deprecated,
CALENDAR_INACTIVE_deprecated,
CALL_FAILED_ACTIVE_deprecated,
CALL_FAILED_INACTIVE_deprecated,
CALL_MADE_deprecated,
CALL_ME_UP_ACTIVE_deprecated,
CALL_ME_UP_INACTIVE_deprecated,
CALL_MESSAGE_ACTIVE_deprecated,
CALL_MERGE_deprecated,
CALL_MESSAGE_INACTIVE_deprecated,
CALL_MISSED_deprecated,
CALL_ON_HOLD_ACTIVE_deprecated,
CALL_ON_HOLD_INACTIVE_deprecated,
CALL_PARK_ACTIVE_deprecated,
CALL_PARK_INACTIVE_deprecated,
CALL_RECEIVED_deprecated,
CALL_SPLIT_deprecated,
CALL_TRANSFER_ACTIVE_deprecated,
CALL_TRANSFER_INACTIVE_deprecated,
CAMERA_ACTIVE_deprecated,
CAMERA_AUTO_deprecated,
CAMERA_FLIP_deprecated,
CAMERA_INACTIVE_deprecated,
CAMERA_POSITION_BOTTOM_deprecated,
CAMERA_POSITION_LEFT_deprecated,
CAMERA_POSITION_RIGHT_deprecated,
CAMERA_POSITION_TOP_deprecated,
CAMERA_PRESETS_ACTIVE_deprecated,
CAMERA_PRESETS_INACTIVE_deprecated,
CAMERA_SHARE_deprecated,
CARD_deprecated,
CART_ACTIVE_deprecated,
CART_INACTIVE_deprecated,
CASH_deprecated,
CHAT_ACTIVE_deprecated,
CHAT_DOTS_ACTIVE_deprecated,
CHAT_DOTS_INACTIVE_deprecated,
CHAT_FEEDBACK_ACTIVE_deprecated,
CHAT_FEEDBACK_INACTIVE_deprecated,
CHAT_INACTIVE_deprecated,
CHAT_QUESTION_INACTIVE_deprecated,
CHAT_QUESTION_ACTIVE_deprecated,
CHECK_deprecated,
CHECKBOX_ACTIVE_ANDROID_deprecated,
CHECKBOX_ACTIVE_deprecated,
CHECKBOX_ANDROID_INDETERMINATE_deprecated,
CHECKBOX_ANDROID_deprecated,
CHECKBOX_CHECK_deprecated,
CHECKBOX_INDETERMINATE_deprecated,
CHECKBOX_LINE_deprecated,
CHECKBOX_deprecated,
CHECKMARK_CIRCLE_ACTIVE_deprecated,
CHECKMARK_CIRCLE_INACTIVE_deprecated,
CHEVRON_COMBO_deprecated,
CHEVRON_DOWN_20_PX_deprecated,
CHEVRON_DOWN_deprecated,
CHEVRON_LEFT_COLLAPSE_deprecated,
CHEVRON_LEFT_IOS_deprecated,
CHEVRON_LEFT_deprecated,
CHEVRON_RIGHT_EXPAND_deprecated,
CHEVRON_RIGHT_deprecated,
CHEVRON_UP_20_PX_deprecated,
CHEVRON_UP_deprecated,
CLEAR_ALL_deprecated,
CLIP_deprecated,
CLIPBOARD_ACTIVE_deprecated,
CLIPBOARD_INACTIVE_deprecated,
CLOCK_ACTIVE_deprecated,
CLOCK_INACTIVE_deprecated,
CLOSE_CIRCLE_ACTIVE_deprecated,
CLOSE_CIRCLE_INACTIVE_deprecated,
CLOSE_deprecated,
CLOUD_OFF_deprecated,
CLOUD_deprecated,
CLOUD_UPLOAD_deprecated,
COBY_ACTIVE_deprecated,
COBY_INACTIVE_deprecated,
CODE_deprecated,
APPLE_deprecated,
CONNECT_WISE_deprecated,
DATTO_deprecated,
FACEBOOK_deprecated,
FILE_deprecated,
GOOGLE_DRIVE_DOC_deprecated,
GOOGLE_DRIVE_DRAWINGS_deprecated,
GOOGLE_DRIVE_FOLDER_deprecated,
GOOGLE_DRIVE_SHEET_deprecated,
GOOGLE_DRIVE_SLIDE_deprecated,
GOOGLE_DRIVE_deprecated,
GOOGLE_GMAIL_deprecated,
GOOGLE_deprecated,
GOTO_ADMIN_PARTNER_APP_ICON_DARK_MODE_deprecated,
GOTO_ADMIN_PARTNER_APP_ICON_deprecated,
GOTO_ADMIN_PARTNER_FAVICON_DARK_MODE_deprecated,
GOTO_ADMIN_PARTNER_FAVICON_deprecated,
GOTO_APP_ICON_DARK_MODE_deprecated,
GOTO_BLACK_FAVICON_deprecated,
GOTO_APP_ICON_deprecated,
GOTO_BLACK_WHITE_deprecated,
GOTO_BLACK_YELLOW_FAVICON_deprecated,
GOTO_BLACK_YELLOW_deprecated,
GOTO_BLACK_deprecated,
GOTO_GIVES_BLACK_YELLOW_deprecated,
GOTO_GIVES_BLACK_deprecated,
GOTO_GIVES_GREY_deprecated,
GOTO_GIVES_WHITE_YELLOW_deprecated,
GOTO_GIVES_WHITE_deprecated,
GOTO_GREY_deprecated,
GOTO_INTEGRATIONS_APP_ICON_DARK_MODE_deprecated,
GOTO_INTEGRATIONS_APP_ICON_deprecated,
GOTO_MARK_deprecated,
GOTO_WHITE_FAVICON_deprecated,
GOTO_WHITE_YELLOW_FAVICON_DARK_MODE_deprecated,
GOTO_WHITE_YELLOW_deprecated,
GOTO_WHITE_deprecated,
GRASSHOPPER_MARK_deprecated,
GTC_CONTACT_CENTER_PICTO_deprecated,
GTC_MEETING_PICTO_deprecated,
GTC_MESSAGING_PICTO_deprecated,
GTC_PHONE_MTG_BUNDLE_PICTO_deprecated,
GTC_ROOM_PICTO_deprecated,
GTC_TRAINING_PICTO_deprecated,
GTC_VIRTUAL_EVENTS_PICTO_deprecated,
GTC_VOICE_PICTO_deprecated,
GTC_WEBINAR_PICTO_deprecated,
GTR_BLACK_HORIZONTAL_deprecated,
GTR_BLACK_VERTICAL_deprecated,
GTR_BLACK_YELLOW_PURPLE_HORIZONTAL_deprecated,
GTR_BLACK_YELLOW_PURPLE_VERTICAL_deprecated,
GTR_CONVERSATIONAL_TICKETING_PICTO_deprecated,
GTR_DEFAULT_APP_ICON_DARK_MODE_deprecated,
GTR_DEFAULT_APP_ICON_deprecated,
GTR_DEVICE_MONITORING_PICTO_deprecated,
GTR_ENDPOINT_MANAGEMENT_PICTO_deprecated,
GTR_ENDPOINT_SECURITY_PICTO_deprecated,
GTR_FAVICON_DARK_MODE_deprecated,
GTR_FAVICON_deprecated,
GTR_GREY_VERTICAL_deprecated,
GTR_GREY_HORIZONTAL_deprecated,
GTR_HELP_DESK_PICTO_deprecated,
GTR_MOBILE_DEVICE_SUPPORT_PICTO_deprecated,
GTR_IT_AUTOMATION_PICTO_deprecated,
GTR_PURPLE_APP_ICON_DARK_MODE_deprecated,
GTR_PURPLE_APP_ICON_deprecated,
GTR_REMOTE_ACCESS_PICTO_deprecated,
GTR_VISUAL_ENGAGEMENT_PICTO_deprecated,
GTR_REMOTE_SUPPORT_PICTO_deprecated,
GTR_WHITE_HORIZONTAL_deprecated,
GTR_WHITE_YELLOW_HORIZONTAL_deprecated,
GTR_WHITE_VERTICAL_deprecated,
GTR_WHITE_YELLOW_VERTICAL_deprecated,
INSTAGRAM_deprecated,
LINKEDIN_deprecated,
LP_BY_GO_TO_BLACK_HORIZONTAL_deprecated,
LP_BY_GO_TO_BLACK_RED_HORIZONTAL_deprecated,
LP_BY_GO_TO_BLACK_RED_VERTICAL_deprecated,
LP_BY_GO_TO_BLACK_VERTICAL_deprecated,
LP_BY_GO_TO_GREY_HORIZONTAL_deprecated,
LP_BY_GO_TO_GREY_VERTICAL_deprecated,
LP_BY_GO_TO_WHITE_HORIZONTAL_deprecated,
LP_BY_GO_TO_WHITE_RED_HORIZONTAL_deprecated,
LP_BY_GO_TO_WHITE_RED_VERTICAL_deprecated,
LP_BY_GO_TO_WHITE_VERTICAL_deprecated,
MICROSOFT_TEAMS_deprecated,
MICROSOFT_deprecated,
OFFICE_365_deprecated,
OUTLOOK_deprecated,
SLACK_deprecated,
TWITTER_deprecated,
YOUTUBE_deprecated,
COMMUTER_MODE_deprecated,
CONFERENCE_PHONE_deprecated,
CONNECT_ACTIVE_deprecated,
CONNECTED_VIA_PHONE_ACTIVE_deprecated,
CONNECT_INACTIVE_deprecated,
CONNECTED_VIA_PHONE_INACTIVE_deprecated,
CONTINUE_20_PX_deprecated,
CONTROLS_ACTIVE_deprecated,
CONTROLS_INACTIVE_deprecated,
CONVERSATION_ACTIVE_deprecated,
CONVERSATION_INACTIVE_deprecated,
COPY_ACTIVE_deprecated,
COPY_INACTIVE_deprecated,
CPU_deprecated,
CREATE_CONVERSATION_ACTIVE_deprecated,
CREATE_CONVERSATION_INACTIVE_deprecated,
CREATE_GROUP_ACTIVE_deprecated,
CREATE_GROUP_INACTIVE_deprecated,
CROWD_INACTIVE_deprecated,
CTRL_ALT_DEL_ACTIVE_deprecated,
CROWD_ACTIVE_deprecated,
CVS_ACTIVE_deprecated,
CTRL_ALT_DEL_INACTIVE_deprecated,
DARK_MODE_deprecated,
CVS_INACTIVE_deprecated,
DASHBOARD_ACTIVE_deprecated,
DATA_MASKING_ACTIVE_deprecated,
DASHBOARD_INACTIVE_deprecated,
DATA_MASKING_INACTIVE_deprecated,
DATA_deprecated,
DELETE_CONVERSATION_ACTIVE_deprecated,
DESKTOP_deprecated,
DELETE_CONVERSATION_INACTIVE_deprecated,
DEVICES_ACTIVE_deprecated,
DEVICES_INACTIVE_deprecated,
DIAL_IN_ACTIVE_deprecated,
DIAL_IN_INACTIVE_deprecated,
DIAL_OUT_ACTIVE_deprecated,
DIAL_OUT_INACTIVE_deprecated,
DIAL_PAD_deprecated,
DISCOVER_deprecated,
DOCUMENT_ACTIVE_deprecated,
DOCUMENT_INACTIVE_deprecated,
DOLLAR_deprecated,
DOWNLOAD_deprecated,
DOLBY_deprecated,
DRAG_CURSOR_deprecated,
DRAG_DROP_deprecated,
DRAG_FREE_deprecated,
DRAG_LINEAR_deprecated,
DRAWER_LEFT_INACTIVE_deprecated,
DRAWER_LEFT_ACTIVE_deprecated,
DRAWER_RIGHT_ACTIVE_deprecated,
DRAWER_RIGHT_INACTIVE_deprecated,
DRIVE_ACTIVE_deprecated,
DRIVE_INACTIVE_deprecated,
DUAL_DISPLAY_ACTIVE_deprecated,
DUAL_DISPLAY_deprecated,
EDGE_deprecated,
ECHO_deprecated,
EDIT_INACTIVE_deprecated,
EDIT_deprecated,
EDUCATION_ACTIVE_deprecated,
EDUCATION_INACTIVE_deprecated,
EMAIL_ACTIVE_deprecated,
EMAIL_INACTIVE_deprecated,
EMOJI_SAD_deprecated,
EMOJI_deprecated,
ENLARGE_MEETING_deprecated,
ENTER_ACTIVE_deprecated,
ENTER_INACTIVE_deprecated,
EVENT_ACTIVE_deprecated,
EURO_deprecated,
EVENT_INACTIVE_deprecated,
EVENT_PHONE_ACTIVE_deprecated,
EVENT_PHONE_INACTIVE_deprecated,
EXECUTABLE_ACTIVE_deprecated,
EXECUTABLE_INACTIVE_deprecated,
EXTERNAL_LINK_deprecated,
FADE_OUT_deprecated,
FAX_deprecated,
FILE_ACTIVE_deprecated,
FILE_BROWSER_ACTIVE_deprecated,
FILE_BROWSER_INACTIVE_deprecated,
FILE_CODE_ACTIVE_deprecated,
FILE_CODE_INACTIVE_deprecated,
FILE_INACTIVE_deprecated,
FILE_PDF_ACTIVE_deprecated,
FILE_PDF_INACTIVE_deprecated,
FILE_PRESENTATION_ACTIVE_deprecated,
FILE_PRESENTATION_INACTIVE_deprecated,
FILE_SOUND_ACTIVE_deprecated,
FILE_SOUND_INACTIVE_deprecated,
FILE_SPREADSHEET_ACTIVE_deprecated,
FILE_SPREADSHEET_INACTIVE_deprecated,
FILE_TRANSFER_ACTIVE_deprecated,
FILE_TRANSFER_INACTIVE_deprecated,
FILE_VIDEO_ACTIVE_deprecated,
FILE_VIDEO_INACTIVE_deprecated,
FILTER_ACTIVE_deprecated,
FILTER_INACTIVE_deprecated,
FIREFOX_deprecated,
FIT_HEIGHT_deprecated,
FIT_WIDTH_deprecated,
FITNESS_deprecated,
FLASLIGHT_OFF_ACTIVE_deprecated,
FLASLIGHT_OFF_INACTIVE_deprecated,
FLASLIGHT_ON_ACTIVE_deprecated,
FLASLIGHT_ON_INACTIVE_deprecated,
FLOWCHART_deprecated,
FOLDER_ACTIVE_deprecated,
FOLDER_ARCHIVE_ACTIVE_deprecated,
FOLDER_ARCHIVE_INACTIVE_deprecated,
FOLDER_INACTIVE_deprecated,
FOLDER_UP_deprecated,
FONT_deprecated,
GEO_PIN_ACTIVE_deprecated,
GEO_PIN_INACTIVE_deprecated,
GIFT_deprecated,
GLOBE_deprecated,
GOOGLE_CHROME_deprecated,
GOOGLE_MONOCHROMATIC_deprecated,
GOTO_ASSIST_deprecated,
GOTO_deprecated,
GRIP_20_PX_deprecated,
HAMBURGER_MENU_deprecated,
HAND_RAISE_deprecated,
HAND_LOWER_deprecated,
HARDPHONE_deprecated,
HDMI_deprecated,
HEADPHONES_deprecated,
HEALTHCARE_ACTIVE_deprecated,
HEALTHCARE_INACTIVE_deprecated,
HEART_ACTIVE_deprecated,
HEART_INACTIVE_deprecated,
HELP_CIRCLE_ACTIVE_deprecated,
HELP_CIRCLE_INACTIVE_deprecated,
HELP_SQUARE_ACTIVE_deprecated,
HELPDESK_deprecated,
HELP_SQUARE_INACTIVE_deprecated,
HIGHLIGHTER_ACTIVE_deprecated,
HIGHLIGHTER_deprecated,
HISTORY_deprecated,
HOME_ACTIVE_deprecated,
HOME_INACTIVE_deprecated,
HOUSE_ACTIVE_deprecated,
INBOX_ACTIVE_deprecated,
HOUSE_INACTIVE_deprecated,
ID_CARD_deprecated,
INBOX_INACTIVE_deprecated,
INFINITY_deprecated,
INFO_ACTIVE_deprecated,
INFO_INACTIVE_deprecated,
INTEGRATIONS_deprecated,
KEY_ACTIVE_deprecated,
INTERNET_EXPLORER_deprecated,
KEY_INACTIVE_deprecated,
LAB_ACTIVE_deprecated,
KEYBOARD_INACTIVE_deprecated,
LAB_INACTIVE_deprecated,
LAUNCH_ACTIVE_deprecated,
LAUNCH_INACTIVE_deprecated,
LEGAL_ACTIVE_deprecated,
LEAVE_deprecated,
LEGAL_INACTIVE_deprecated,
LINK_ACTIVE_deprecated,
LINK_HORIZONTAL_deprecated,
LINK_INACTIVE_deprecated,
LINUX_deprecated,
LIST_ACTIVE_deprecated,
LIST_INACTIVE_deprecated,
LISTEN_deprecated,
LOADER_deprecated,
LOCKED_ACTIVE_20_PX_deprecated,
LOCKED_ACTIVE_deprecated,
LOCKED_INACTIVE_20_PX_deprecated,
LOCKED_INACTIVE_deprecated,
LOG_ACTIVE_deprecated,
LOG_INACTIVE_deprecated,
LOGMEIN_deprecated,
LOUD_SPEAKER_deprecated,
MAGIC_WAND_ACTIVE_deprecated,
MAIN_SWITCH_ACTIVE_deprecated,
MAGIC_WAND_INACTIVE_deprecated,
MAIN_SWITCH_INACTIVE_deprecated,
MANUFACTURING_ACTIVE_deprecated,
MANUFACTURING_INACTIVE_deprecated,
MATERIALS_ACTIVE_deprecated,
MASTER_deprecated,
MATERIALS_INACTIVE_deprecated,
MEET_NOW_deprecated,
MEETING_JOIN_ACTIVE_deprecated,
MEETING_JOIN_INACTIVE_deprecated,
MEETING_SYNC_deprecated,
MEETINGS_ACTIVE_deprecated,
MEETINGS_INACTIVE_deprecated,
MERGE_deprecated,
MESSENGER_deprecated,
MIC_OFF_20_PX_deprecated,
MIC_ON_20_PX_deprecated,
MICROPHONE_ACTIVE_deprecated,
MICROPHONE_INACTIVE_deprecated,
MICROPHONE_OFF_ACTIVE_deprecated,
MICROPHONE_ON_INACTIVE_deprecated,
MINIFY_MEETING_deprecated,
MOBILE_SUPPORT_deprecated,
MORE_VERTICAL_MOBILE_ONLY_deprecated,
MORE_HORIZONTAL_deprecated,
MOUSE_ACTIVE_deprecated,
MOUSE_INACTIVE_deprecated,
MUSIC_deprecated,
NETWORK_ACTIVE_deprecated,
NETWORK_INACTIVE_deprecated,
NOTE_ACTIVE_deprecated,
NOTE_INACTIVE_deprecated,
NOTE_deprecated,
NOTEPAD_ACTIVE_deprecated,
NOTEPAD_INACTIVE_deprecated,
NOTIFICATIONS_ALERT_ACTIVE_deprecated,
NOTIFICATIONS_ALERT_INACTIVE_deprecated,
NOTIFICATIONS_deprecated,
NPA_INACTIVE_deprecated,
NPA_ACTIVE_deprecated,
NUMBERED_ARROW_INACTIVE_deprecated,
NUMBERED_ARROW_ACTIVE_deprecated,
OPEN_VOICE_deprecated,
OPERA_deprecated,
PAINT_INACTIVE_deprecated,
PAINT_ACTIVE_deprecated,
PALETTE_ACTIVE_deprecated,
PALETTE_INACTIVE_deprecated,
PAUSE_20_PX_deprecated,
PAUSE_ACTIVE_deprecated,
PAUSE_CIRCLE_ACTIVE_deprecated,
PAUSE_CIRCLE_INACTIVE_deprecated,
PAUSE_INACTIVE_deprecated,
PBX_deprecated,
PEOPLE_ACTIVE_deprecated,
PEOPLE_INACTIVE_deprecated,
PERSON_ACTIVE_deprecated,
PERSON_CHECKMARK_ACTIVE_deprecated,
PERSON_CHECKMARK_INACTIVE_deprecated,
PERSON_INACTIVE_deprecated,
PERSON_TRANSFER_FROM_INACTIVE_deprecated,
PERSON_TRANSFER_FROM_ACTIVE_deprecated,
PERSON_TRANSFER_TO_ACTIVE_deprecated,
PERSON_TRANSFER_TO_INACTIVE_deprecated,
PHONE_DOWN_ACTIVE_deprecated,
PHONE_DOWN_INACTIVE_deprecated,
PHONE_UP_ACTIVE_deprecated,
PHONE_UP_DISABLED_ACTIVE_deprecated,
PHONE_UP_DISABLED_INACTIVE_deprecated,
PHONE_UP_INACTIVE_deprecated,
PICTURE_ACTIVE_deprecated,
PICTURE_DISABLED_ACTIVE_deprecated,
PICTURE_DISABLED_INACTIVE_deprecated,
PICTURE_INACTIVE_deprecated,
PIE_CHART_ACTIVE_deprecated,
PIE_CHART_INACTIVE_deprecated,
PIP_MAXIMIZE_deprecated,
PIP_MINIMIZE_deprecated,
PLAY_ACTIVE_deprecated,
PLAY_INACTIVE_deprecated,
POINTER_OFF_INACTIVE_deprecated,
POINTER_OFF_ACTIVE_deprecated,
POINTER_ON_INACTIVE_deprecated,
POINTER_ON_ACTIVE_deprecated,
POINTER_WINDOWS_OFF_ACTIVE_deprecated,
POINTER_WINDOWS_OFF_INACTIVE_deprecated,
POINTER_WINDOWS_ON_ACTIVE_deprecated,
POINTER_WINDOWS_ON_INACTIVE_deprecated,
POINTER_deprecated,
POLLS_deprecated,
POP_IT_BACK_deprecated,
POP_IT_OUT_deprecated,
POP_OUT_CAMERA_deprecated,
POP_OUT_WINDOW_deprecated,
POSITION_TV_BOTTOM_deprecated,
POSITION_TV_LEFT_deprecated,
POSITION_TV_RIGHT_deprecated,
POUND_SIGN_deprecated,
POSITION_TV_TOP_deprecated,
POUND_deprecated,
PRESENCE_AVAILABLE_deprecated,
PRESENCE_BUSY_ACTIVE_deprecated,
PRESENCE_BUSY_INACTIVE_deprecated,
PRESENCE_DND_deprecated,
PRESENCE_OFFLINE_deprecated,
PRESENTATION_ACTIVE_deprecated,
PRESENTATION_INACTIVE_deprecated,
PRIVATE_ACTIVE_deprecated,
PRIVATE_INACTIVE_deprecated,
PUSHPIN_ACTIVE_deprecated,
PUSHPIN_INACTIVE_deprecated,
QUESTION_deprecated,
RADIO_BUTTON_ANDROID_SELECTED_deprecated,
RADIO_BUTTON_ANDROID_UNSELECTED_deprecated,
RADIO_BUTTON_SELECTED_deprecated,
RADIO_BUTTON_UNSELECTED_deprecated,
READER_ACTIVE_deprecated,
READER_INACTIVE_deprecated,
RECORD_INACTIVE_deprecated,
RECORDING_TAPE_deprecated,
RECORDING_deprecated,
RECURRING_deprecated,
REDO_deprecated,
REFRESH_deprecated,
REMOTE_SUPPORT_ACTIVE_deprecated,
REMOTE_SUPPORT_deprecated,
REPLY_deprecated,
REPORT_deprecated,
RESIZE_HANDLE_deprecated,
RESTORE_deprecated,
ROOM_PHYSICAL_deprecated,
ROOM_VIEW_deprecated,
ROTATE_CCW_ACTIVE_deprecated,
ROTATE_CCW_INACTIVE_deprecated,
ROTATE_CW_ACTIVE_deprecated,
ROTATE_CW_INACTIVE_deprecated,
ROUTER_ACTIVE_deprecated,
ROUTER_INACTIVE_deprecated,
SAFARI_deprecated,
SCREEN_ACTIVE_deprecated,
SCREEN_ADD_DEVICE_ACTIVE_deprecated,
SCREEN_ADD_DEVICE_INACTIVE_deprecated,
SCREEN_INACTIVE_deprecated,
SCREEN_MIRRORING_LAPTOP_deprecated,
SCREEN_QUALITY_ACTIVE_deprecated,
SCREEN_QUALITY_INACTIVE_deprecated,
SCREEN_REBOOT_ACTIVE_deprecated,
SCREEN_REBOOT_INACTIVE_deprecated,
SCREEN_RUN_ACTIVE_deprecated,
SCREEN_RUN_INACTIVE_deprecated,
SCREEN_SHARING_deprecated,
SCREEN_SNAPSHOT_ACTIVE_deprecated,
SCREEN_SNAPSHOT_INACTIVE_deprecated,
SCREEN_STOP_REMOTE_ACTIVE_deprecated,
SCREEN_STOP_REMOTE_INACTIVE_deprecated,
SCREEN_SYSTEM_INFO_ACTIVE_deprecated,
SCREEN_UNATTENDED_ACTIVE_deprecated,
SCREEN_SYSTEM_INFO_INACTIVE_deprecated,
SCREEN_UNATTENDED_INACTIVE_deprecated,
SEARCH_deprecated,
SEE_IT_deprecated,
SEND_LARGE_ACTIVE_deprecated,
SEND_LARGE_INACTIVE_deprecated,
SERVER_ACTIVE_deprecated,
SERVER_INACTIVE_deprecated,
SETTINGS_ACTIVE_deprecated,
SETTINGS_INACTIVE_deprecated,
SHARE_20_PX_deprecated,
SHARE_ARROW_deprecated,
SHARE_deprecated,
SHIELD_ACTIVE_deprecated,
SHIELD_INACTIVE_deprecated,
SHUFFLE_deprecated,
SIGNAL_0_deprecated,
SIGNAL_1_deprecated,
SIGNAL_3_deprecated,
SIGNAL_2_deprecated,
SIGNAL_STRENGTH_0_deprecated,
SIGNAL_STRENGTH_1_deprecated,
SIGNAL_STRENGTH_2_deprecated,
SIGNAL_STRENGTH_3_deprecated,
SIGNAL_STRENGTH_4_deprecated,
SIGNOUT_deprecated,
SKETCH_deprecated,
SLIDERS_ACTIVE_deprecated,
SLIDERS_INACTIVE_deprecated,
SMALL_ARROW_DOWN_deprecated,
SMALL_ARROW_LEFT_deprecated,
SMALL_ARROW_RIGHT_deprecated,
SMALL_ARROW_UP_deprecated,
SMARTPHONE_deprecated,
SNOOZE_deprecated,
SPACES_ACTIVE_deprecated,
SPACES_INACTIVE_deprecated,
SPEAKER_20_PX_deprecated,
SPEAKER_OFF_ACTIVE_deprecated,
SPEAKER_OFF_INACTIVE_deprecated,
SPEAKER_ON_ACTIVE_deprecated,
SPEAKER_ON_INACTIVE_deprecated,
SPEAKING_20_PX_deprecated,
SPEAKING_deprecated,
STAR_EMPTY_deprecated,
STAR_FILLED_deprecated,
STAR_HALF_FILLED_deprecated,
STOP_20_PX_deprecated,
STAR_deprecated,
STOP_ACTIVE_deprecated,
STOP_INACTIVE_deprecated,
STRETCHING_COLLAPSE_deprecated,
STRETCHING_EXIT_FULLSCREEN_deprecated,
STRETCHING_EXPAND_deprecated,
STRETCHING_FULLSCREEN_deprecated,
SUBTRACT_deprecated,
SWAP_deprecated,
SYNC_deprecated,
SYNCHRONIZED_deprecated,
TABLET_CHEVRON_deprecated,
TAG_deprecated,
TEST_ACTIVE_deprecated,
TEST_INACTIVE_deprecated,
TEXT_FIELD_deprecated,
TEXT_deprecated,
THEMES_deprecated,
THUMBS_DOWN_ACTIVE_deprecated,
THUMBS_DOWN_INACTIVE_deprecated,
THUMBS_UP_ACTIVE_deprecated,
THUMBS_UP_INACTIVE_deprecated,
TIME_LIMITATION_deprecated,
TRANSFER_CONVERSATION_ACTIVE_deprecated,
TRANSFER_CONVERSATION_INACTIVE_deprecated,
TRASH_ACTIVE_deprecated,
TRASH_INACTIVE_deprecated,
UBUNTU_deprecated,
TRENDING_deprecated,
UNLOCKED_ACTIVE_20_PX_deprecated,
UNDO_deprecated,
UPLOAD_deprecated,
UNLOCKED_ACTIVE_deprecated,
VECTOR_deprecated,
USB_C_deprecated,
VIEW_SWITCH_ACTIVE_CAMERAS_deprecated,
VIEW_GRID_deprecated,
VIEW_SWITCH_EVERYONE_deprecated,
VIEW_SWITCH_FILMSTRIP_deprecated,
VIEW_SWITCH_PORTRAIT_deprecated,
VIEWS_ACTIVE_deprecated,
VIEWS_INACTIVE_deprecated,
VIEW_SWITCH_HIDEALL_deprecated,
VIMEO_deprecated,
VISA_deprecated,
VISIBILITY_ENABLED_ACTIVE_deprecated,
VISIBILITY_DISABLED_INACTIVE_deprecated,
VOICEMAIL_READ_deprecated,
VOICEMAIL_UNREAD_deprecated,
VOIP_PAUSE_deprecated,
VOICEMAIL_deprecated,
VOIP_deprecated,
WEB_deprecated,
WEBCAM_OFF_ACTIVE_deprecated,
WEBCAM_ON_ACTIVE_deprecated,
WEBCAM_OFF_INACTIVE_deprecated,
WEBCAM_ON_INACTIVE_deprecated,
WHISPER_deprecated,
WHITEBOARD_INACTIVE_deprecated,
WHITEBOARD_ACTIVE_deprecated,
WHITEBOARD_deprecated,
WIFI_ACTIVE_deprecated,
WIFI_INACTIVE_deprecated,
WINDOWS_deprecated,
WRENCH_ACTIVE_deprecated,
WRENCH_INACTIVE_deprecated,
YUAN_deprecated,
ZIP_deprecated,
ZOOM_IN_ACTIVE_deprecated,
ZOOM_OUT_ACTIVE_deprecated,
ZOOM_IN_INACTIVE_deprecated,
ZOOM_OUT_INACTIVE_deprecated,
ACCESSIBILITY_rebranded,
ADD_ACTIVE_rebranded,
ADD_CIRCLE_INACTIVE_rebranded,
ADD_INACTIVE_rebranded,
ADD_CIRCLE_ACTIVE_rebranded,
ADD_PERSON_INACTIVE_rebranded,
ADD_PERSON_ACTIVE_rebranded,
ADDRESS_BOOK_CONTACTS_ACTIVE_rebranded,
ADD_rebranded,
ADDRESS_BOOK_CONTACTS_INACTIVE_rebranded,
ADDRESSES_ACTIVE_rebranded,
ADDRESSES_INACTIVE_rebranded,
ADJUST_CAMERA_rebranded,
ADJUSTMENTS_rebranded,
ADMIN_ACTIVE_rebranded,
ADMIN_INACTIVE_rebranded,
ADOBE_rebranded,
ALERT_ACTIVE_rebranded,
AMEX_rebranded,
ANDROID_rebranded,
ANNOTATION_ACTIVE_rebranded,
ALERT_INACTIVE_rebranded,
APP_SWITCHER_rebranded,
APPLE_MONOCHROMATIC_rebranded,
ARCHIVE_ACTIVE_rebranded,
ARCHIVE_INACTIVE_rebranded,
ARROW_DOWN_rebranded,
ARROW_RIGHT_rebranded,
ARROW_LEFT_rebranded,
ARROW_UP_rebranded,
ASSISTANCE_ACTIVE_rebranded,
AUDIO_OFF_20_PX_rebranded,
ASSISTANCE_INACTIVE_rebranded,
BADGE_ACTIVE_rebranded,
BACKSPACE_rebranded,
BADGE_INACTIVE_rebranded,
BATTERY_FULL_rebranded,
BATTERY_LOW_rebranded,
BELL_ACTIVE_rebranded,
BATTERY_MID_rebranded,
BELL_DISABLED_ACTIVE_rebranded,
BELL_DISABLED_INACTIVE_rebranded,
BELL_INACTIVE_rebranded,
BLOCK_rebranded,
BLUETOOTH_CONNECTED_rebranded,
BLUETOOTH_rebranded,
BOOKMARK_ACTIVE_rebranded,
BOOKMARK_INACTIVE_rebranded,
BRAVE_rebranded,
BREAKOUT_ROOM_rebranded,
BRIGHTNESS_rebranded,
BUG_INACTIVE_rebranded,
BUG_ACTIVE_rebranded,
BULB_ACTIVE_rebranded,
BULB_INACTIVE_rebranded,
BUSINESS_ACTIVE_rebranded,
BUSINESS_INACTIVE_rebranded,
CALCULATOR_ACTIVE_rebranded,
CALCULATOR_INACTIVE_rebranded,
CALENDAR_ACTIVE_rebranded,
CALENDAR_INACTIVE_rebranded,
CALL_FAILED_ACTIVE_rebranded,
CALL_FAILED_INACTIVE_rebranded,
CALL_MADE_rebranded,
CALL_ME_UP_ACTIVE_rebranded,
CALL_ME_UP_INACTIVE_rebranded,
CALL_MERGE_rebranded,
CALL_MESSAGE_ACTIVE_rebranded,
CALL_MISSED_rebranded,
CALL_MESSAGE_INACTIVE_rebranded,
CALL_ON_HOLD_ACTIVE_rebranded,
CALL_ON_HOLD_INACTIVE_rebranded,
CALL_PARK_ACTIVE_rebranded,
CALL_PARK_INACTIVE_rebranded,
CALL_RECEIVED_rebranded,
CALL_TRANSFER_ACTIVE_rebranded,
CALL_SPLIT_rebranded,
CAMERA_ACTIVE_rebranded,
CALL_TRANSFER_INACTIVE_rebranded,
CAMERA_AUTO_rebranded,
CAMERA_FLIP_rebranded,
CAMERA_INACTIVE_rebranded,
CAMERA_POSITION_BOTTOM_rebranded,
CAMERA_POSITION_LEFT_rebranded,
CAMERA_POSITION_RIGHT_rebranded,
CAMERA_POSITION_TOP_rebranded,
CAMERA_PRESETS_ACTIVE_rebranded,
CAMERA_PRESETS_INACTIVE_rebranded,
CAMERA_SHARE_rebranded,
CARD_rebranded,
CART_ACTIVE_rebranded,
CART_INACTIVE_rebranded,
CASH_rebranded,
CHAT_ACTIVE_rebranded,
CHAT_DOTS_ACTIVE_rebranded,
CHAT_DOTS_INACTIVE_rebranded,
CHAT_FEEDBACK_ACTIVE_rebranded,
CHAT_FEEDBACK_INACTIVE_rebranded,
CHAT_INACTIVE_rebranded,
CHAT_QUESTION_ACTIVE_rebranded,
CHECK_rebranded,
CHAT_QUESTION_INACTIVE_rebranded,
CHECKBOX_ACTIVE_ANDROID_rebranded,
CHECKBOX_ACTIVE_rebranded,
CHECKBOX_ANDROID_rebranded,
CHECKBOX_ANDROID_INDETERMINATE_rebranded,
CHECKBOX_CHECK_rebranded,
CHECKBOX_INDETERMINATE_rebranded,
CHECKBOX_LINE_rebranded,
CHECKMARK_CIRCLE_ACTIVE_rebranded,
CHECKBOX_rebranded,
CHECKMARK_CIRCLE_INACTIVE_rebranded,
CHEVRON_DOWN_20_PX_rebranded,
CHEVRON_COMBO_rebranded,
CHEVRON_DOWN_rebranded,
CHEVRON_LEFT_COLLAPSE_rebranded,
CHEVRON_LEFT_IOS_rebranded,
CHEVRON_LEFT_rebranded,
CHEVRON_RIGHT_EXPAND_rebranded,
CHEVRON_RIGHT_rebranded,
CHEVRON_UP_20_PX_rebranded,
CHEVRON_UP_rebranded,
CLEAR_ALL_rebranded,
CLIP_rebranded,
CLIPBOARD_ACTIVE_rebranded,
CLIPBOARD_INACTIVE_rebranded,
CLOCK_ACTIVE_rebranded,
CLOCK_INACTIVE_rebranded,
CLOSE_CIRCLE_ACTIVE_rebranded,
CLOSE_CIRCLE_INACTIVE_rebranded,
CLOUD_OFF_rebranded,
CLOUD_UPLOAD_rebranded,
CLOSE_rebranded,
CLOUD_rebranded,
COBY_ACTIVE_rebranded,
COBY_INACTIVE_rebranded,
CODE_rebranded,
APPLE_rebranded,
CONNECT_WISE_rebranded,
DATTO_rebranded,
FACEBOOK_rebranded,
GOOGLE_DRIVE_DOC_rebranded,
FILE_rebranded,
GOOGLE_DRIVE_FOLDER_rebranded,
GOOGLE_DRIVE_DRAWINGS_rebranded,
GOOGLE_DRIVE_SHEET_rebranded,
GOOGLE_DRIVE_SLIDE_rebranded,
GOOGLE_DRIVE_rebranded,
GOOGLE_GMAIL_rebranded,
GOTO_ADMIN_PARTNER_APP_ICON_rebranded,
GOOGLE_rebranded,
GOTO_ADMIN_PARTNER_APP_ICON_DARK_MODE_rebranded,
GOTO_ADMIN_PARTNER_FAVICON_DARK_MODE_rebranded,
GOTO_APP_ICON_DARK_MODE_rebranded,
GOTO_ADMIN_PARTNER_FAVICON_rebranded,
GOTO_APP_ICON_rebranded,
GOTO_BLACK_WHITE_rebranded,
GOTO_BLACK_YELLOW_FAVICON_rebranded,
GOTO_BLACK_FAVICON_rebranded,
GOTO_BLACK_YELLOW_rebranded,
GOTO_BLACK_rebranded,
GOTO_GIVES_BLACK_YELLOW_rebranded,
GOTO_GIVES_BLACK_rebranded,
GOTO_GIVES_GREY_rebranded,
GOTO_GIVES_WHITE_YELLOW_rebranded,
GOTO_GIVES_WHITE_rebranded,
GOTO_GREY_rebranded,
GOTO_INTEGRATIONS_APP_ICON_DARK_MODE_rebranded,
GOTO_INTEGRATIONS_APP_ICON_rebranded,
GOTO_MARK_rebranded,
GOTO_WHITE_FAVICON_rebranded,
GOTO_WHITE_YELLOW_FAVICON_DARK_MODE_rebranded,
GOTO_WHITE_rebranded,
GOTO_WHITE_YELLOW_rebranded,
GRASSHOPPER_MARK_rebranded,
GTC_CONTACT_CENTER_PICTO_rebranded,
GTC_MEETING_PICTO_rebranded,
GTC_MESSAGING_PICTO_rebranded,
GTC_PHONE_MTG_BUNDLE_PICTO_rebranded,
GTC_ROOM_PICTO_rebranded,
GTC_TRAINING_PICTO_rebranded,
GTC_VIRTUAL_EVENTS_PICTO_rebranded,
GTC_VOICE_PICTO_rebranded,
GTC_WEBINAR_PICTO_rebranded,
GTR_BLACK_HORIZONTAL_rebranded,
GTR_BLACK_VERTICAL_rebranded,
GTR_BLACK_YELLOW_PURPLE_VERTICAL_rebranded,
GTR_BLACK_YELLOW_PURPLE_HORIZONTAL_rebranded,
GTR_CONVERSATIONAL_TICKETING_PICTO_rebranded,
GTR_DEFAULT_APP_ICON_DARK_MODE_rebranded,
GTR_DEFAULT_APP_ICON_rebranded,
GTR_DEVICE_MONITORING_PICTO_rebranded,
GTR_ENDPOINT_MANAGEMENT_PICTO_rebranded,
GTR_FAVICON_DARK_MODE_rebranded,
GTR_ENDPOINT_SECURITY_PICTO_rebranded,
GTR_FAVICON_rebranded,
GTR_GREY_HORIZONTAL_rebranded,
GTR_GREY_VERTICAL_rebranded,
GTR_IT_AUTOMATION_PICTO_rebranded,
GTR_HELP_DESK_PICTO_rebranded,
GTR_MOBILE_DEVICE_SUPPORT_PICTO_rebranded,
GTR_PURPLE_APP_ICON_DARK_MODE_rebranded,
GTR_PURPLE_APP_ICON_rebranded,
GTR_REMOTE_ACCESS_PICTO_rebranded,
GTR_REMOTE_SUPPORT_PICTO_rebranded,
GTR_VISUAL_ENGAGEMENT_PICTO_rebranded,
GTR_WHITE_HORIZONTAL_rebranded,
GTR_WHITE_VERTICAL_rebranded,
GTR_WHITE_YELLOW_HORIZONTAL_rebranded,
INSTAGRAM_rebranded,
GTR_WHITE_YELLOW_VERTICAL_rebranded,
LINKEDIN_rebranded,
LP_BY_GO_TO_BLACK_HORIZONTAL_rebranded,
LP_BY_GO_TO_BLACK_RED_VERTICAL_rebranded,
LP_BY_GO_TO_BLACK_RED_HORIZONTAL_rebranded,
LP_BY_GO_TO_BLACK_VERTICAL_rebranded,
LP_BY_GO_TO_GREY_HORIZONTAL_rebranded,
LP_BY_GO_TO_GREY_VERTICAL_rebranded,
LP_BY_GO_TO_WHITE_HORIZONTAL_rebranded,
LP_BY_GO_TO_WHITE_RED_HORIZONTAL_rebranded,
LP_BY_GO_TO_WHITE_RED_VERTICAL_rebranded,
MICROSOFT_TEAMS_rebranded,
LP_BY_GO_TO_WHITE_VERTICAL_rebranded,
MICROSOFT_rebranded,
OFFICE_365_rebranded,
OUTLOOK_rebranded,
TWITTER_rebranded,
SLACK_rebranded,
YOUTUBE_rebranded,
COMMUTER_MODE_rebranded,
CONFERENCE_PHONE_rebranded,
CONNECT_ACTIVE_rebranded,
CONNECT_INACTIVE_rebranded,
CONNECTED_VIA_PHONE_ACTIVE_rebranded,
CONNECTED_VIA_PHONE_INACTIVE_rebranded,
CONTROLS_ACTIVE_rebranded,
CONTINUE_20_PX_rebranded,
CONTROLS_INACTIVE_rebranded,
CONVERSATION_ACTIVE_rebranded,
CONVERSATION_INACTIVE_rebranded,
COPY_ACTIVE_rebranded,
COPY_INACTIVE_rebranded,
CPU_rebranded,
CREATE_CONVERSATION_ACTIVE_rebranded,
CREATE_CONVERSATION_INACTIVE_rebranded,
CREATE_GROUP_INACTIVE_rebranded,
CREATE_GROUP_ACTIVE_rebranded,
CROWD_ACTIVE_rebranded,
CROWD_INACTIVE_rebranded,
CTRL_ALT_DEL_ACTIVE_rebranded,
CTRL_ALT_DEL_INACTIVE_rebranded,
CVS_ACTIVE_rebranded,
CVS_INACTIVE_rebranded,
DASHBOARD_ACTIVE_rebranded,
DASHBOARD_INACTIVE_rebranded,
DARK_MODE_rebranded,
DATA_MASKING_ACTIVE_rebranded,
DATA_MASKING_INACTIVE_rebranded,
DATA_rebranded,
DELETE_CONVERSATION_ACTIVE_rebranded,
DELETE_CONVERSATION_INACTIVE_rebranded,
DESKTOP_rebranded,
DEVICES_ACTIVE_rebranded,
DEVICES_INACTIVE_rebranded,
DIAL_IN_ACTIVE_rebranded,
DIAL_IN_INACTIVE_rebranded,
DIAL_OUT_ACTIVE_rebranded,
DIAL_OUT_INACTIVE_rebranded,
DIAL_PAD_rebranded,
DISCOVER_rebranded,
DOCUMENT_ACTIVE_rebranded,
DOCUMENT_INACTIVE_rebranded,
DOLLAR_rebranded,
DOLBY_rebranded,
DOWNLOAD_rebranded,
DRAG_CURSOR_rebranded,
DRAG_LINEAR_rebranded,
DRAG_DROP_rebranded,
DRAG_FREE_rebranded,
DRAWER_LEFT_ACTIVE_rebranded,
DRAWER_RIGHT_ACTIVE_rebranded,
DRAWER_LEFT_INACTIVE_rebranded,
DRAWER_RIGHT_INACTIVE_rebranded,
DRIVE_ACTIVE_rebranded,
DRIVE_INACTIVE_rebranded,
DUAL_DISPLAY_rebranded,
DUAL_DISPLAY_ACTIVE_rebranded,
ECHO_rebranded,
EDGE_rebranded,
EDIT_rebranded,
EDIT_INACTIVE_rebranded,
EDUCATION_ACTIVE_rebranded,
EDUCATION_INACTIVE_rebranded,
EMAIL_ACTIVE_rebranded,
EMAIL_INACTIVE_rebranded,
EMOJI_SAD_rebranded,
EMOJI_rebranded,
ENLARGE_MEETING_rebranded,
ENTER_ACTIVE_rebranded,
ENTER_INACTIVE_rebranded,
EURO_rebranded,
EVENT_INACTIVE_rebranded,
EVENT_ACTIVE_rebranded,
EVENT_PHONE_ACTIVE_rebranded,
EVENT_PHONE_INACTIVE_rebranded,
EXECUTABLE_ACTIVE_rebranded,
EXECUTABLE_INACTIVE_rebranded,
EXTERNAL_LINK_rebranded,
FADE_OUT_rebranded,
FAX_rebranded,
FILE_ACTIVE_rebranded,
FILE_BROWSER_ACTIVE_rebranded,
FILE_CODE_INACTIVE_rebranded,
FILE_BROWSER_INACTIVE_rebranded,
FILE_CODE_ACTIVE_rebranded,
FILE_INACTIVE_rebranded,
UNLOCKED_INACTIVE_deprecated,
FILE_PDF_ACTIVE_rebranded,
FILE_PDF_INACTIVE_rebranded,
FILE_PRESENTATION_ACTIVE_rebranded,
FILE_PRESENTATION_INACTIVE_rebranded,
FILE_SOUND_ACTIVE_rebranded,
FILE_SOUND_INACTIVE_rebranded,
FILE_SPREADSHEET_ACTIVE_rebranded,
FILE_SPREADSHEET_INACTIVE_rebranded,
FILE_TRANSFER_ACTIVE_rebranded,
FILE_VIDEO_ACTIVE_rebranded,
FILE_TRANSFER_INACTIVE_rebranded,
FILE_VIDEO_INACTIVE_rebranded,
FILTER_ACTIVE_rebranded,
FILTER_INACTIVE_rebranded,
FIREFOX_rebranded,
FIT_HEIGHT_rebranded,
FIT_WIDTH_rebranded,
FITNESS_rebranded,
FLASLIGHT_OFF_INACTIVE_rebranded,
FLASLIGHT_OFF_ACTIVE_rebranded,
FLASLIGHT_ON_ACTIVE_rebranded,
FLASLIGHT_ON_INACTIVE_rebranded,
FLOWCHART_rebranded,
FOLDER_ARCHIVE_ACTIVE_rebranded,
FOLDER_ARCHIVE_INACTIVE_rebranded,
FOLDER_INACTIVE_rebranded,
FOLDER_UP_rebranded,
FONT_rebranded,
GEO_PIN_ACTIVE_rebranded,
GEO_PIN_INACTIVE_rebranded,
GIFT_rebranded,
GOOGLE_CHROME_rebranded,
GOOGLE_MONOCHROMATIC_rebranded,
GLOBE_rebranded,
GOTO_ASSIST_rebranded,
GOTO_rebranded,
GRIP_20_PX_rebranded,
HAMBURGER_MENU_rebranded,
HAND_LOWER_rebranded,
HAND_RAISE_rebranded,
HARDPHONE_rebranded,
HDMI_rebranded,
HEADPHONES_rebranded,
HEALTHCARE_ACTIVE_rebranded,
HEALTHCARE_INACTIVE_rebranded,
HEART_ACTIVE_rebranded,
HEART_INACTIVE_rebranded,
FOLDER_ACTIVE_rebranded,
HELP_CIRCLE_ACTIVE_rebranded,
HELP_SQUARE_ACTIVE_rebranded,
HELP_CIRCLE_INACTIVE_rebranded,
HELP_SQUARE_INACTIVE_rebranded,
HELPDESK_rebranded,
HIGHLIGHTER_ACTIVE_rebranded,
HISTORY_rebranded,
HIGHLIGHTER_rebranded,
HOME_ACTIVE_rebranded,
HOUSE_ACTIVE_rebranded,
HOME_INACTIVE_rebranded,
ID_CARD_rebranded,
HOUSE_INACTIVE_rebranded,
INBOX_ACTIVE_rebranded,
INBOX_INACTIVE_rebranded,
INFINITY_rebranded,
INTEGRATIONS_rebranded,
INFO_ACTIVE_rebranded,
INFO_INACTIVE_rebranded,
INTERNET_EXPLORER_rebranded,
KEY_INACTIVE_rebranded,
KEY_ACTIVE_rebranded,
KEYBOARD_INACTIVE_rebranded,
LAB_INACTIVE_rebranded,
LAUNCH_ACTIVE_rebranded,
LAB_ACTIVE_rebranded,
LAUNCH_INACTIVE_rebranded,
LEAVE_rebranded,
LEGAL_INACTIVE_rebranded,
LEGAL_ACTIVE_rebranded,
LINK_ACTIVE_rebranded,
LINK_HORIZONTAL_rebranded,
LINK_INACTIVE_rebranded,
LIST_ACTIVE_rebranded,
LIST_INACTIVE_rebranded,
LISTEN_rebranded,
LOADER_rebranded,
LOCKED_ACTIVE_20_PX_rebranded,
LOCKED_ACTIVE_rebranded,
LINUX_rebranded,
LOCKED_INACTIVE_20_PX_rebranded,
LOG_ACTIVE_rebranded,
LOCKED_INACTIVE_rebranded,
LOG_INACTIVE_rebranded,
LOUD_SPEAKER_rebranded,
LOGMEIN_rebranded,
MAGIC_WAND_ACTIVE_rebranded,
MAIN_SWITCH_ACTIVE_rebranded,
MAGIC_WAND_INACTIVE_rebranded,
MAIN_SWITCH_INACTIVE_rebranded,
MANUFACTURING_ACTIVE_rebranded,
MANUFACTURING_INACTIVE_rebranded,
MATERIALS_ACTIVE_rebranded,
MASTER_rebranded,
MATERIALS_INACTIVE_rebranded,
MEETING_JOIN_ACTIVE_rebranded,
MEET_NOW_rebranded,
MEETING_JOIN_INACTIVE_rebranded,
MEETINGS_ACTIVE_rebranded,
MEETING_SYNC_rebranded,
MEETINGS_INACTIVE_rebranded,
MERGE_rebranded,
MESSENGER_rebranded,
MIC_ON_20_PX_rebranded,
MIC_OFF_20_PX_rebranded,
MICROPHONE_INACTIVE_rebranded,
MICROPHONE_OFF_ACTIVE_rebranded,
MICROPHONE_ACTIVE_rebranded,
MICROPHONE_ON_INACTIVE_rebranded,
MINIFY_MEETING_rebranded,
MORE_HORIZONTAL_rebranded,
MOBILE_SUPPORT_rebranded,
MOUSE_ACTIVE_rebranded,
MORE_VERTICAL_MOBILE_ONLY_rebranded,
MOUSE_INACTIVE_rebranded,
NETWORK_ACTIVE_rebranded,
MUSIC_rebranded,
NETWORK_INACTIVE_rebranded,
NOTE_ACTIVE_rebranded,
NOTE_INACTIVE_rebranded,
NOTEPAD_ACTIVE_rebranded,
NOTIFICATIONS_ALERT_ACTIVE_rebranded,
NOTE_rebranded,
NOTEPAD_INACTIVE_rebranded,
NOTIFICATIONS_ALERT_INACTIVE_rebranded,
NOTIFICATIONS_rebranded,
NPA_ACTIVE_rebranded,
NPA_INACTIVE_rebranded,
NUMBERED_ARROW_ACTIVE_rebranded,
NUMBERED_ARROW_INACTIVE_rebranded,
OPEN_VOICE_rebranded,
PAINT_ACTIVE_rebranded,
OPERA_rebranded,
PAINT_INACTIVE_rebranded,
PALETTE_ACTIVE_rebranded,
PALETTE_INACTIVE_rebranded,
PAUSE_20_PX_rebranded,
PAUSE_ACTIVE_rebranded,
PAUSE_CIRCLE_INACTIVE_rebranded,
PAUSE_CIRCLE_ACTIVE_rebranded,
PAUSE_INACTIVE_rebranded,
PBX_rebranded,
PEOPLE_ACTIVE_rebranded,
PERSON_CHECKMARK_ACTIVE_rebranded,
PEOPLE_INACTIVE_rebranded,
PERSON_ACTIVE_rebranded,
PERSON_CHECKMARK_INACTIVE_rebranded,
PERSON_INACTIVE_rebranded,
PERSON_TRANSFER_FROM_INACTIVE_rebranded,
PERSON_TRANSFER_FROM_ACTIVE_rebranded,
PERSON_TRANSFER_TO_ACTIVE_rebranded,
PERSON_TRANSFER_TO_INACTIVE_rebranded,
PHONE_DOWN_INACTIVE_rebranded,
PHONE_DOWN_ACTIVE_rebranded,
PHONE_UP_ACTIVE_rebranded,
PHONE_UP_DISABLED_ACTIVE_rebranded,
PHONE_UP_INACTIVE_rebranded,
PICTURE_ACTIVE_rebranded,
PHONE_UP_DISABLED_INACTIVE_rebranded,
PICTURE_DISABLED_ACTIVE_rebranded,
PICTURE_DISABLED_INACTIVE_rebranded,
PICTURE_INACTIVE_rebranded,
PIE_CHART_INACTIVE_rebranded,
PIE_CHART_ACTIVE_rebranded,
PIP_MAXIMIZE_rebranded,
PIP_MINIMIZE_rebranded,
PLAY_ACTIVE_rebranded,
POINTER_OFF_ACTIVE_rebranded,
PLAY_INACTIVE_rebranded,
POINTER_ON_ACTIVE_rebranded,
POINTER_OFF_INACTIVE_rebranded,
POINTER_ON_INACTIVE_rebranded,
POINTER_WINDOWS_OFF_ACTIVE_rebranded,
POINTER_WINDOWS_OFF_INACTIVE_rebranded,
POINTER_WINDOWS_ON_INACTIVE_rebranded,
POINTER_WINDOWS_ON_ACTIVE_rebranded,
POINTER_rebranded,
POP_IT_OUT_rebranded,
POLLS_rebranded,
POP_IT_BACK_rebranded,
POP_OUT_CAMERA_rebranded,
POP_OUT_WINDOW_rebranded,
POSITION_TV_BOTTOM_rebranded,
POSITION_TV_LEFT_rebranded,
POSITION_TV_TOP_rebranded,
POSITION_TV_RIGHT_rebranded,
POUND_SIGN_rebranded,
POUND_rebranded,
PRESENCE_AVAILABLE_rebranded,
PRESENCE_BUSY_ACTIVE_rebranded,
PRESENCE_BUSY_INACTIVE_rebranded,
PRESENCE_DND_rebranded,
PRESENCE_OFFLINE_rebranded,
PRESENTATION_ACTIVE_rebranded,
PRESENTATION_INACTIVE_rebranded,
PRIVATE_INACTIVE_rebranded,
PRIVATE_ACTIVE_rebranded,
PUSHPIN_ACTIVE_rebranded,
PUSHPIN_INACTIVE_rebranded,
QUESTION_rebranded,
RADIO_BUTTON_ANDROID_SELECTED_rebranded,
RADIO_BUTTON_ANDROID_UNSELECTED_rebranded,
RADIO_BUTTON_SELECTED_rebranded,
RADIO_BUTTON_UNSELECTED_rebranded,
READER_ACTIVE_rebranded,
READER_INACTIVE_rebranded,
RECORD_INACTIVE_rebranded,
RECORDING_TAPE_rebranded,
RECORDING_rebranded,
RECURRING_rebranded,
REDO_rebranded,
REMOTE_SUPPORT_ACTIVE_rebranded,
REFRESH_rebranded,
REMOTE_SUPPORT_rebranded,
REPLY_rebranded,
REPORT_rebranded,
RESTORE_rebranded,
RESIZE_HANDLE_rebranded,
ROOM_PHYSICAL_rebranded,
ROOM_VIEW_rebranded,
ROTATE_CCW_ACTIVE_rebranded,
ROTATE_CCW_INACTIVE_rebranded,
ROTATE_CW_ACTIVE_rebranded,
ROTATE_CW_INACTIVE_rebranded,
ROUTER_ACTIVE_rebranded,
ROUTER_INACTIVE_rebranded,
SAFARI_rebranded,
SCREEN_ACTIVE_rebranded,
SCREEN_ADD_DEVICE_ACTIVE_rebranded,
SCREEN_ADD_DEVICE_INACTIVE_rebranded,
SCREEN_INACTIVE_rebranded,
SCREEN_MIRRORING_LAPTOP_rebranded,
SCREEN_QUALITY_ACTIVE_rebranded,
SCREEN_QUALITY_INACTIVE_rebranded,
SCREEN_REBOOT_ACTIVE_rebranded,
SCREEN_REBOOT_INACTIVE_rebranded,
SCREEN_RUN_ACTIVE_rebranded,
SCREEN_RUN_INACTIVE_rebranded,
SCREEN_SHARING_rebranded,
SCREEN_SNAPSHOT_ACTIVE_rebranded,
SCREEN_SNAPSHOT_INACTIVE_rebranded,
SCREEN_STOP_REMOTE_ACTIVE_rebranded,
SCREEN_STOP_REMOTE_INACTIVE_rebranded,
SCREEN_SYSTEM_INFO_ACTIVE_rebranded,
SCREEN_SYSTEM_INFO_INACTIVE_rebranded,
SCREEN_UNATTENDED_ACTIVE_rebranded,
SCREEN_UNATTENDED_INACTIVE_rebranded,
SEARCH_rebranded,
SEE_IT_rebranded,
SEND_LARGE_ACTIVE_rebranded,
SEND_LARGE_INACTIVE_rebranded,
SERVER_ACTIVE_rebranded,
SERVER_INACTIVE_rebranded,
SETTINGS_ACTIVE_rebranded,
SETTINGS_INACTIVE_rebranded,
SHARE_20_PX_rebranded,
SHARE_ARROW_rebranded,
SHIELD_ACTIVE_rebranded,
SHARE_rebranded,
SHIELD_INACTIVE_rebranded,
SHUFFLE_rebranded,
SIGNAL_1_rebranded,
SIGNAL_0_rebranded,
SIGNAL_2_rebranded,
SIGNAL_3_rebranded,
SIGNAL_STRENGTH_0_rebranded,
SIGNAL_STRENGTH_2_rebranded,
SIGNAL_STRENGTH_1_rebranded,
SIGNAL_STRENGTH_3_rebranded,
SIGNAL_STRENGTH_4_rebranded,
SIGNOUT_rebranded,
SKETCH_rebranded,
SLIDERS_ACTIVE_rebranded,
SLIDERS_INACTIVE_rebranded,
SMALL_ARROW_DOWN_rebranded,
SMALL_ARROW_RIGHT_rebranded,
SMALL_ARROW_LEFT_rebranded,
SMALL_ARROW_UP_rebranded,
SMARTPHONE_rebranded,
SNOOZE_rebranded,
SPACES_ACTIVE_rebranded,
SPACES_INACTIVE_rebranded,
SPEAKER_20_PX_rebranded,
SPEAKER_OFF_ACTIVE_rebranded,
SPEAKER_OFF_INACTIVE_rebranded,
SPEAKER_ON_ACTIVE_rebranded,
SPEAKER_ON_INACTIVE_rebranded,
SPEAKING_20_PX_rebranded,
SPEAKING_rebranded,
STAR_EMPTY_rebranded,
STAR_FILLED_rebranded,
STAR_HALF_FILLED_rebranded,
STAR_rebranded,
STOP_20_PX_rebranded,
STOP_ACTIVE_rebranded,
STOP_INACTIVE_rebranded,
STRETCHING_COLLAPSE_rebranded,
STRETCHING_EXIT_FULLSCREEN_rebranded,
STRETCHING_EXPAND_rebranded,
STRETCHING_FULLSCREEN_rebranded,
SUBTRACT_rebranded,
SWAP_rebranded,
SYNC_rebranded,
SYNCHRONIZED_rebranded,
TABLET_CHEVRON_rebranded,
TAG_rebranded,
TEST_ACTIVE_rebranded,
TEST_INACTIVE_rebranded,
TEXT_FIELD_rebranded,
TEXT_rebranded,
THEMES_rebranded,
THUMBS_DOWN_ACTIVE_rebranded,
THUMBS_DOWN_INACTIVE_rebranded,
THUMBS_UP_ACTIVE_rebranded,
THUMBS_UP_INACTIVE_rebranded,
TIME_LIMITATION_rebranded,
TRANSFER_CONVERSATION_ACTIVE_rebranded,
TRANSFER_CONVERSATION_INACTIVE_rebranded,
TRASH_ACTIVE_rebranded,
TRASH_INACTIVE_rebranded,
TRENDING_rebranded,
UBUNTU_rebranded,
UNDO_rebranded,
UNLOCKED_ACTIVE_20_PX_rebranded,
UNLOCKED_ACTIVE_rebranded,
UNLOCKED_INACTIVE_20_PX_rebranded,
UPLOAD_rebranded,
UNLOCKED_INACTIVE_rebranded,
USB_C_rebranded,
VECTOR_rebranded,
VIEW_GRID_rebranded,
VIEW_SWITCH_ACTIVE_CAMERAS_rebranded,
VIEW_SWITCH_EVERYONE_rebranded,
VIEW_SWITCH_FILMSTRIP_rebranded,
VIEW_SWITCH_HIDEALL_rebranded,
VIEWS_ACTIVE_rebranded,
VIEW_SWITCH_PORTRAIT_rebranded,
VIEWS_INACTIVE_rebranded,
VIMEO_rebranded,
VISIBILITY_DISABLED_INACTIVE_rebranded,
VISA_rebranded,
VISIBILITY_ENABLED_ACTIVE_rebranded,
VOICEMAIL_READ_rebranded,
VOICEMAIL_UNREAD_rebranded,
VOICEMAIL_rebranded,
VOIP_PAUSE_rebranded,
VOIP_rebranded,
WEB_rebranded,
WEBCAM_OFF_ACTIVE_rebranded,
WEBCAM_OFF_INACTIVE_rebranded,
WEBCAM_ON_ACTIVE_rebranded,
WEBCAM_ON_INACTIVE_rebranded,
WHISPER_rebranded,
WHITEBOARD_ACTIVE_rebranded,
WHITEBOARD_INACTIVE_rebranded,
WHITEBOARD_rebranded,
WIFI_ACTIVE_rebranded,
WIFI_INACTIVE_rebranded,
WINDOWS_rebranded,
WRENCH_ACTIVE_rebranded,
WRENCH_INACTIVE_rebranded,
YUAN_rebranded,
ZIP_rebranded,
ZOOM_IN_INACTIVE_rebranded,
ZOOM_OUT_ACTIVE_rebranded,
ZOOM_OUT_INACTIVE_rebranded,
ZOOM_IN_ACTIVE_rebranded,
UNLOCKED_INACTIVE_20_PX_deprecated,
}